// Generated by Avo VERSION 140.1.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* eslint-disable */

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  self.DOMException = self.DOMException;
  try {
    new self.DOMException();
  } catch (err) {
    self.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    self.DOMException.prototype = Object.create(Error.prototype);
    self.DOMException.prototype.constructor = self.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new self.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new self.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }
})();

(function(exports) {
  var __AVO_DEV__ = false;
  var __AVO_NOOP__ = false;
  var __AVO_LOGGER__ = null;
  var __AVO_ENV__ = null;
  var __REPORT_FAILURE_AS__ = null;
  var __STRICT__ = null;

  var __WEB_DEBUGGER__ = true;
  const avoInspectorApiKey = "GiIO3qy8XWVdWxluseEP";
  var __INSPECTOR__ = null;

  // polyfill Array.isArray
  if (!Array.isArray) {
    Array.isArray = function(arg) {
      return Object.prototype.toString.call(arg) === '[object Array]';
    };
  }

  // polyfill Object.assign
  if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
      value: function assign(target, varArgs) { // .length of function is 2
        if (target == null) { // TypeError if undefined or null
          throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];

          if (nextSource != null) { // Skip over if undefined or null
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }

  // From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
  if (!Object.keys) {
    Object.keys = (function() {
      'use strict';
      var hasOwnProperty = Object.prototype.hasOwnProperty,
          hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
          dontEnums = [
            'toString',
            'toLocaleString',
            'valueOf',
            'hasOwnProperty',
            'isPrototypeOf',
            'propertyIsEnumerable',
            'constructor'
          ],
          dontEnumsLength = dontEnums.length;

      return function(obj) {
        if (typeof obj !== 'function' && (typeof obj !== 'object' || obj === null)) {
          throw new TypeError('Object.keys called on non-object');
        }

        var result = [], prop, i;

        for (prop in obj) {
          if (hasOwnProperty.call(obj, prop)) {
            result.push(prop);
          }
        }

        if (hasDontEnumBug) {
          for (i = 0; i < dontEnumsLength; i++) {
            if (hasOwnProperty.call(obj, dontEnums[i])) {
              result.push(dontEnums[i]);
            }
          }
        }
        return result;
      };
    }());
  }

  // polyfill Array.indexOf
  if (!Array.prototype.indexOf)  Array.prototype.indexOf = (function(Object, max, min){
    "use strict";
    return function indexOf(member, fromIndex) {
      if(this===null||this===undefined)throw TypeError("Array.prototype.indexOf called on null or undefined");

      var that = Object(this), Len = that.length >>> 0, i = min(fromIndex | 0, Len);
      if (i < 0) i = max(0, Len+i); else if (i >= Len) return -1;

      if(member===void 0){ for(; i !== Len; ++i) if(that[i]===void 0 && i in that) return i; // undefined
      }else if(member !== member){   for(; i !== Len; ++i) if(that[i] !== that[i]) return i; // NaN
      }else                           for(; i !== Len; ++i) if(that[i] === member) return i; // all else

      return -1; // if the value was not found, then return -1
    };
  })(Object, Math.max, Math.min);

  var array_difference, AvoAssert, InternalAvoLogger;
  array_difference = function array_difference(a1, a2) {
    var result = [];
    for (var i = 0; i < a1.length; i++) {
      if (a2.indexOf(a1[i]) === -1) {
        result.push(a1[i]);
      }
    }
    return result;
  }

  AvoAssert = {
    assertObject: function assertObject(propertyId, propName, obj) {
      if (typeof obj !== 'object') {
        var message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
        return [{tag: 'expectedObjectType', propertyId: propertyId, message: message, actualType: typeof obj}];
      } else {
        return [];
      }
    },

    assertString: function assertString(propertyId, propName, str) {
      if (typeof str !== 'string') {
        var message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
        return [{tag: 'expectedStringType', propertyId: propertyId, message: message, actualType: typeof str}];
      } else {
        return [];
      }
    },

    assertInt: function assertInt(propertyId, propName, int) {
      if (typeof int === 'number' && int !== Math.round(int)) {
        var message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
        return [{tag: 'expectedIntType', propertyId: propertyId, actualType: 'float'}];
      } else if (typeof int !== 'number') {
        var message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
        return [{tag: 'expectedIntType', propertyId: propertyId, message: message, actualType: typeof int}];
      } else {
        return [];
      }
    },

    assertLong: function assertLong(propertyId, propName, long) {
      if (typeof long === 'number' && long !== Math.round(long)) {
        var message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
        return [{tag: 'expectedLongType', propertyId: propertyId, actualType: 'float'}];
      } else if (typeof long !== 'number') {
        var message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
        return [{tag: 'expectedLongType', propertyId: propertyId, message: message, actualType: typeof long}];
      } else {
        return [];
      }
    },

    assertFloat: function assertFloat(propertyId, propName, float) {
      if (typeof float !== 'number') {
        var message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
        return [{tag: 'expectedFloatType', propertyId: propertyId, message: message, actualType: typeof float}];
      } else {
        return [];
      }
    },

    assertBool: function assertBool(propertyId, propName, bool) {
      if (typeof bool !== 'boolean') {
        var message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
        return [{tag: 'expectedBoolType', propertyId: propertyId, message: message, actualType: typeof bool}];
      } else {
        return [];
      }
    },

    assertMax: function assertMax(propertyId, propName, max, value) {
      if (value > max) {
        var message = propName +
          ' has a maximum value of ' +
          max +
          ' but you provided the value ' +
          JSON.stringify(value);
        return [{tag: 'expectedMax', propertyId: propertyId, message: message}];
      } else {
        return [];
      }
    },

    assertMin: function assertMin(propertyId, propName, min, value) {
      if (value < min) {
        var message = propName +
          ' has a minimum value of ' +
          min +
          ' but you provided the value ' +
          JSON.stringify(value);
        return [{tag: 'expectedMin', propertyId: propertyId, message: message}];
      } else {
        return [];
      }
    },

    assertList: function assertList(propertyId, propName, value) {
      if (!Array.isArray(value)) {
        var message = propName + ' should be of type list but you provided type ' + typeof value;
        return [{tag: 'expectedList', propertyId: propertyId, message: message, actualType: typeof value}];
      } else {
        return [];
      }
    },

    assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName, input, spec) {
      var additionalKeys = array_difference(input, spec);
      if (additionalKeys.length) {
        var message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
        return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
      } else {
        return [];
      }
    },

    assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName, input, spec) {
      var additionalKeys = array_difference(input, spec);
      if (additionalKeys.length) {
        var message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
        return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
      } else {
        return [];
      }
    }
  };

    const WebDebuggerAssertions = {
      hasKey(obj, key) {
        return obj && obj[key] != null;
      },
      assertKey(obj, key, assert) {
        if (this.hasKey(obj, key) && assert(obj[key])) {
          return true;
        } else {
          throw new Error('WebDebugger: Object key: "' + key + '" failed assertion.')
        }
      },
      assertKeys(obj, arrayOfAssertions) {
        return arrayOfAssertions.every(assertionForKey => {
          if (this.hasKey(assertionForKey, "key") && this.hasKey(assertionForKey, "assert")) {
            return this.assertKey(obj, assertionForKey.key, assertionForKey.assert);
          } else {
            throw new Error('WebDebugger: Object form for assertion invalid.');
          }
        });
      },
      assertInt(int) {
        return Number.isInteger(int);
      },
    };

    var WebDebuggerPosition = {
      position: {
        BOTTOM_RIGHT: 'BottomRight',
        BOTTOM_LEFT: 'BottomLeft',
        TOP_RIGHT: 'TopRight',
        TOP_LEFT: 'TopLeft',
      },
      BottomRight(parameters) {
        return WebDebuggerAssertions.assertKeys(
          parameters,
          [
            { key: "bottom", assert: WebDebuggerAssertions.assertInt },
            { key: "right", assert: WebDebuggerAssertions.assertInt },
          ],
        ) && {
          position: this.position.BOTTOM_RIGHT,
          bottom: parameters.bottom,
          right: parameters.right,
        };
      },
      BottomLeft(parameters) {
        return WebDebuggerAssertions.assertKeys(
          parameters,
          [
            { key: "bottom", assert: WebDebuggerAssertions.assertInt },
            { key: "left", assert: WebDebuggerAssertions.assertInt },
          ],
        ) && {
          position: this.position.BOTTOM_LEFT,
          bottom: parameters.bottom,
          left: parameters.left,
        };
      },
      TopRight(parameters) {
        return WebDebuggerAssertions.assertKeys(
          parameters,
          [
            { key: "top", assert: WebDebuggerAssertions.assertInt },
            { key: "right", assert: WebDebuggerAssertions.assertInt },
          ],
        ) && {
          position: this.position.TOP_RIGHT,
          top: parameters.top,
          right: parameters.right,
        };
      },
      TopLeft(parameters) {
        return WebDebuggerAssertions.assertKeys(
          parameters,
          [
            { key: "top", assert: WebDebuggerAssertions.assertInt },
            { key: "left", assert: WebDebuggerAssertions.assertInt },
          ],
        ) && {
          position: this.position.TOP_LEFT,
          top: parameters.top,
          left: parameters.left,
        };
      },
    }


  InternalAvoLogger = {
    logEventSent: function logEventSent(eventName, eventProperties, userProperties, groupProperties) {
      const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties) + "Group Props:" + JSON.stringify(groupProperties);

      if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
        return
      }
      typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties, "Group Props:", groupProperties);
    },

    log: function log(message) {
      if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
        return
      }
      typeof console !== 'undefined' && console.log("[avo] " + message);
    },

    warn: function warn(message) {
      if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
        return
      }
      typeof console !== 'undefined' && console.warn("[avo] " + message);
    },

    error: function error(message, error) {
      if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
        return
      }
      typeof console !== 'undefined' && console.error("[avo] " + message, error);
    }
  };

  var _avo_invoke, _avo_invoke_meta;
var _avo_sampling_rate = 1.0;
function _avo_invoke_payload(body) {
  if (typeof window === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(body)
      }).then(function(res) { return res.json(); }).then(function(data) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke = function _avo_invoke(env, eventId, hash, messages, origin) {
  _avo_invoke_payload({
    "ac": "IyDTSAAFkw53HlwQei4M",
    "br": "master",
    "en": env,
    "ev": eventId,
    "ha": hash,
    "sc": "X9gv6TJDCL2GRoNljVYW",
    "se": (new Date()).toISOString(),
    "so": "MZkEugWSv",
    "va": messages.length === 0,
    "me": messages,
    "or": origin
  });
}

_avo_invoke_meta = function _avo_invoke_meta(env, type, messages, origin) {
  _avo_invoke_payload({
    "ac": "IyDTSAAFkw53HlwQei4M",
    "br": "master",
    "en": env,
    "ty": type,
    "sc": "X9gv6TJDCL2GRoNljVYW",
    "se": (new Date()).toISOString(),
    "so": "MZkEugWSv",
    "va": messages.length === 0,
    "me": messages,
    "or": origin
  });
}


  var _avo_debugger_log;
var _avo_debugger_events_during_boot = [];
var _avo_debugger_ready = false;

if (typeof window !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    var iframe = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      var message = {
        type_: "avo-debugger-boot-events",
        schemaId: "X9gv6TJDCL2GRoNljVYW",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId, eventName, messages, eventProperties, userProperties, groupProperties) {
  if (typeof window === 'undefined') { return; }
  var event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties: eventProperties,
    userProperties: userProperties,
    groupProperties: groupProperties
  };

  if (_avo_debugger_ready) {
    var message = {type_: "avo-debugger-events", events: [event]};
    document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


var Segment = {
  make: function make(apiKey, options) {
    if (typeof window === 'undefined') { InternalAvoLogger.warn('window.analytics is not available in Node.js'); return; }
    var analytics = window.analytics = window.analytics || [];
    if (analytics.initialize) return;
    if (analytics.invoked) {
      if (InternalAvoLogger && InternalAvoLogger.error) {
        InternalAvoLogger.error('Segment snippet included twice.');
      }
      return;
    }
    analytics.invoked = true;
    analytics.methods = [
      'trackSubmit',
      'trackClick',
      'trackLink',
      'trackForm',
      'pageview',
      'identify',
      'reset',
      'group',
      'track',
      'ready',
      'alias',
      'debug',
      'page',
      'once',
      'off',
      'on',
      'addSourceMiddleware',
      'addIntegrationMiddleware',
      'setAnonymousId',
      'addDestinationMiddleware'
    ];
    analytics.factory = function(method){
      return function(){
        var args = Array.prototype.slice.call(arguments);
        args.unshift(method);
        analytics.push(args);
        return analytics;
      };
    };
    for (var i = 0; i < analytics.methods.length; i++) {
      var key = analytics.methods[i];
      analytics[key] = analytics.factory(key);
    }
    analytics.load = function(key, options){
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = (key === 'LL0hAYZEpxxw6w3AECtek3EM75UT67l7' || key === 'CrB4sgN7NB1QAfsS6K7Qq6g6QA9JIwW7') ? 'https://a-cdn.babylist.com/analytics.js/v1/' + key + '/analytics.min.js' : key === 'aERifzWx3rz7CeDmHQFxGCWiLQGHCV21' ? 'https://staging-a-cdn.babylist.com/analytics.js/v1/' + key + '/analytics.min.js' : 'https://cdn.segment.com/analytics.js/v1/' + key + '/analytics.min.js';
      var first = document.getElementsByTagName('script')[0];
      first.parentNode.insertBefore(script, first);
      analytics._loadOptions = options;
    };
    analytics._writeKey = apiKey;
    analytics.SNIPPET_VERSION = '4.15.3';

    analytics.load(apiKey, options);
  },

  /* Segment does not have revenue api, @see https://segment.com/docs/spec/track/#properties */
  logEvent: function logEvent(eventName, eventProperties, integrations) {
    if (typeof window === 'undefined') { return; }
    window.analytics.track(eventName, eventProperties, Object.assign({}, {integrations: integrations}));
  },

  setUserProperties: function setUserProperties(userProperties, integrations) {
    if (typeof window === 'undefined') { return; }
    window.analytics.identify(userProperties, Object.assign({}, {integrations: integrations}));
  },

  identify: function identify(userId, integrations) {
    if (typeof window === 'undefined') { return; }
    window.analytics.identify(userId, {}, Object.assign({}, {integrations: integrations}));
  },

  unidentify: function unidentify(integrations) {
    if (typeof window === 'undefined') { return; }
    window.analytics.identify(null, {}, Object.assign({}, {integrations: integrations}));
  },

  page: function page(eventName, eventProperties, integrations) {
    if (typeof window === 'undefined') { return; }
    window.analytics.page(eventName, eventProperties, Object.assign({}, {integrations: integrations}));
  },
};

  var UserAuthenticationMethod = {
    EMAIL: "Email",
    APPLE: "Apple",
    GOOGLE: "Google",
  };

  var RegistryTemplateType = {
    PRIOR_REG: "prior_reg",
    REG_TEMPLATE: "reg_template",
    REG_TEMPLATE_SPONSORED: "reg_template_sponsored",
    BLANK: "blank",
  };

  var ListType = {
    BIRTHDAY: "birthday",
    BABY_REGISTRY: "baby_registry",
    HOLIDAY: "holiday",
  };

  var CoregistrationPromptType = {
    MODAL: "modal",
    PAGE: "page",
  };

  var ContentIds = {
    PREGNANCY: "pregnancy",
    ADOPTION: "adoption",
    SURROGACY: "surrogacy",
    STILL_TRYING: "stillTrying",
  };

  var BlockerType = {
    INSURANCE_VERIFICATION_FAILED: "INSURANCE_VERIFICATION_FAILED",
    INSURANCE_UNSUPPORTED: "INSURANCE_UNSUPPORTED",
    ORDER_IN_PROGRESS: "ORDER_IN_PROGRESS",
    AWAITING_PAID_INVOICE: "AWAITING_PAID_INVOICE",
    ORDER_PLACED_WITHIN_INTERVAL: "ORDER_PLACED_WITHIN_INTERVAL",
    SUBSCRIPTION_ENDED: "SUBSCRIPTION_ENDED",
    UNKNOWN_ERROR: "UNKNOWN_ERROR",
  };

  var CartTypes = {
    STORE: "Store",
    STORE_RESERVATION: "Store Reservation",
    EXTERNAL_RESERVATION: "External Reservation",
    SPLIT_CART: "Split Cart",
  };

  var ComponentType = {
    HERO_BANNER: "hero_banner",
    PRODUCT_CAROUSEL: "product_carousel",
    FEATURE_BANNER: "feature_banner",
    PROMO_BANNER: "promo_banner",
    VIDEO: "video",
    GUIDE: "guide",
    NAVIGATION: "navigation",
    BOTTOM_BANNER: "bottom_banner",
  };

  var DeviceType = {
    TABLET: "tablet",
    MOBILE: "mobile",
    DESKTOP: "desktop",
    BACKEND: "backend",
  };

  var SortCriteria = {
    PRICE: "Price",
    RATING: "Rating",
    REVIEW_COUNT: "Review Count",
    POPULAR: "Popular",
    NEWEST: "Newest",
  };

  var FormName = {
    CUSTOMER_INSURANCE_FORM: "Customer Insurance Form",
    PHYSICIAN_SEARCH_FORM: "Physician Search Form",
    CUSTOMER_VERIFICATION_FORM: "Customer Verification Form",
    INSURANCE_FORM: "Insurance Form",
    REPLACEMENT_PARTS_ORDER_FORM: "Replacement Parts Order Form",
    REPLACEMENT_PARTS_NEW_INSURANCE_FORM: "Replacement Parts New Insurance Form",
  };

  var ItemType = {
    TEXT: "Text",
    PHOTO: "Photo",
  };

  var DeactivationReason = {
    BABY_ARRIVED: "Baby Arrived",
    TOO_MUCH_EMAIL: "Too Much Email",
    JUST_BECAUSE: "Just Because",
    EXPERIENCED_A_LOSS: "Experienced a Loss",
  };

  var InitialSearchBarSize = {
    ICON: "Icon",
    EXPANDED: "Expanded",
  };

  var EventType = {
    ITEM_QUANTITY_UPDATED: "Item Quantity Updated",
    ITEM_REMOVED: "Item Removed",
    MARK_AS_UNPURCHASED: "Mark as Unpurchased",
    MARK_AS_PURCHASED: "Mark as Purchased",
    CANCELLED_RESERVATION: "Cancelled Reservation",
    CHANGED_STORE: "Changed Store",
    ADDED_TO_STORE_RESERVATION: "Added to Store Reservation",
    QUICK_ADD: "Quick Add",
    CLICK: "Click",
    PRODUCT_CLICK: "Product Click",
    ADDED_TO_STORE: "Added to Store",
    NONE: "None",
    SHIPPING_ADDRESS: "Shipping Address",
    SHIPPING_TYPE: "Shipping Type",
    PAYMENT_INFO: "Payment Info",
    ITEM_REMOVED_MINUS_OUT_OF_STOCK: "Item Removed - Out of Stock",
    CHECK: "Check",
    UNCHECK: "Uncheck",
    ADD_TO_BABYLIST: "Add to Babylist",
    PAGE_VIEWED: "Page Viewed",
    SEARCH_RESULTS_VIEWED: "Search Results Viewed",
    SUBMITTED: "Submitted",
    DISMISSED: "Dismissed",
    COPY: "Copy",
    SUCCESSFUL: "Successful",
    ERROR_MINUS_UNRECOGNIZED_EMAIL: "Error - Unrecognized Email",
    ERROR_MINUS_INCORRECT_PASSWORD: "Error - Incorrect Password",
    ERROR_MINUS_SSO_TOKEN_FAILED: "Error - SSO Token Failed",
    ERROR_MINUS_EXISTING_EMAIL: "Error - Existing Email",
    EMAIL_MINUS_INVALID_EMAIL: "Email - Invalid Email",
    ERROR_MINUS_INVALID_CREDENTIALS: "Error - Invalid Credentials",
    MODAL: "Modal",
    POP_MINUS_UP: "Pop-Up",
    SHOP: "Shop",
    GUIDES: "Guides",
    REGISTRIES: "Registries",
    UNIFIED: "Unified",
    REGISTRY: "Registry",
    UNKNOWN: "Unknown",
    FSA_HSA: "FSA/HSA",
    SHOWN_WITH_NEXT_ADD: "Shown With Next Add",
    SHOWN_WITHOUT_NEXT_ADD: "Shown Without Next Add",
    QUICK_VIEW: "Quick View",
    SWIPED: "Swiped",
    BULK_EDIT: "Bulk Edit",
  };

  var StoreAdded = {
    AMAZON: "Amazon",
    BABYLIST: "Babylist",
  };

  var PdpType = {
    PRODUCT: "product",
    GIFT_GIVER: "gift_giver",
    FAVOR: "favor",
    CASH_FUND: "cash_fund",
    GIFT_CARD: "gift_card",
    UNIVERSAL: "universal",
  };

  var ConsolidationValue = {
    ROLLING: "rolling",
    NONE: "none",
    MODAL_NOT_VIEWED: "modal not viewed",
  };

  var ProductType = {
    PRODUCT: "Product",
    GIFT_CARD: "Gift Card",
  };

  var Status = {
    SUCCESS: "success",
    FAIL: "fail",
    VALIDATION_ERROR: "validation error",
  };

  var CartStores = {
    AMAZON: "Amazon",
    BABYLIST_STORE: "Babylist Store",
  };

  var SortOrder = {
    ASC: "ASC",
    DESC: "DESC",
  };

  var ExternalRegistryMergeType = {
    LINK: "link",
    TRANSFER: "transfer",
  };

  var CollaboratorRole = {
    PARTNER: "Partner",
    COLLABORATOR: "Collaborator",
    REGISTRANT: "Registrant",
  };

  var Library = {
    ANDROID: "android",
    IOS: "ios",
    WEB: "web",
    RUBY: "ruby",
  };

  var ReservationCancellationReason = {
    LATER: "later",
    LOOKING: "looking",
    CHANGED_MIND: "changed_mind",
    NOT_AVAILABLE: "not_available",
    NONE: "none",
  };

  var StoreName = {
    BABYLIST_HEALTH: "Babylist Health",
    BABYLIST: "Babylist",
    EXPECTFUL: "Expectful",
  };

  var InteractionTarget = {
    PDP_BREADCRUMB_LINK: "pdp_breadcrumb_link",
    PDP_BREADCRUMB_EXPAND: "pdp_breadcrumb_expand",
    PDP_IMAGE_THUMBNAIL: "pdp_image_thumbnail",
    PDP_REVIEWS_QUICK_LINK: "pdp_reviews_quick_link",
    PDP_QNA_QUICK_LINK: "pdp_qna_quick_link",
    PDP_BACK_TO_TOP: "pdp_back_to_top",
    PDP_EXPAND_DESCRIPTION: "pdp_expand_description",
    PDP_COLLAPSE_DESCRIPTION: "pdp_collapse_description",
    PDP_EXPAND_DETAILS: "pdp_expand_details",
    PDP_COLLAPSE_DETAILS: "pdp_collapse_details",
  };

  var EventLocation = {
    PDP: "PDP",
    FEED: "Feed",
    GUIDE: "Guide",
    REGISTRY: "Registry",
    CART: "Cart",
    SHOPIFY: "Shopify",
    HOME_PAGE: "Home Page",
    STORE: "Store",
    NONE: "None",
    NEXT_ADD_RECOMMENDER: "Next Add Recommender",
    STORE_MINUS_SEARCH: "Store - Search",
    STORE_MINUS_CATEGORY: "Store - Category",
    STORE_MINUS_PRODUCT_COLLECTIONS: "Store - Product Collections",
    ADD_TO_BABYLIST_BUTTON: "Add to Babylist Button",
    REGISTRY_DISCOUNT_SCREEN: "Registry Discount Screen",
    REG_ITEM_EDIT_SCREEN: "Reg Item Edit Screen",
    SHOP_REGISTRY: "Shop Registry",
    STORE_MINUS_PRODUCT_LIST: "Store - Product List",
    CART_DETAILS_PAGE: "Cart Details Page",
    ADD_ITEM_FOR_STORE: "Add Item For Store",
    CORE_ITEM_WIZARD: "Core Item Wizard",
    BUYING_OPTIONS_MODAL: "Buying Options Modal",
    ADD_ITEM: "Add Item",
    ADD_ITEM_MINUS_SHARE_EXTENSION: "Add Item - Share Extension",
    ONBOARDING: "Onboarding",
    DIAPER_CALCULATOR: "Diaper Calculator",
    GIFT_TRACKER: "Gift Tracker",
    REVIEW_LISTINGS_PAGE: "Review Listings Page",
    Q_A_PAGE: "Q&A Page",
    REVIEW_CUSTOMER_PHOTOS: "Review Customer Photos",
    ORDER_HISTORY: "Order History",
    CLOTHING_CALCULATOR: "Clothing Calculator",
    ORGANIZE_REGISTRY: "Organize Registry",
    BANNER_BUTTON: "Banner Button",
    SIGNMINUSUP_WIDGET: "Sign-up Widget",
    PRODUCT_CAROUSEL: "Product Carousel",
    CHECKLIST_QUIZ_MINUS_GENDER: "Checklist Quiz - Gender",
    CHECKLIST_QUIZ_MINUS_FEELING: "Checklist Quiz - Feeling",
    CHECKLIST_QUIZ_MINUS_BUDGET: "Checklist Quiz - Budget",
    CHECKLIST_QUIZ_MINUS_BREASTFEEDING: "Checklist Quiz - Breastfeeding",
    CHECKLIST_QUIZ_MINUS_PUMPING: "Checklist Quiz - Pumping",
    CHECKLIST_QUIZ_MINUS_SLEEP_AREA: "Checklist Quiz - Sleep Area",
    CHECKLIST_QUIZ_MINUS_DIAPERS: "Checklist Quiz - Diapers",
    CHECKLIST_QUIZ_MINUS_LAUNDRY_PLANS: "Checklist Quiz - Laundry Plans",
    CHECKLIST_QUIZ_MINUS_NURSERY: "Checklist Quiz - Nursery",
    CHECKLIST_QUIZ_MINUS_GENDER_COLOR: "Checklist Quiz - Gender Color",
    CHECKLIST_QUIZ_MINUS_LAUNDRY_FREQUENCY: "Checklist Quiz - Laundry Frequency",
    CHECKLIST_QUIZ_MINUS_CELEBRITY: "Checklist Quiz - Celebrity",
    CHECKLIST_QUIZ_MINUS_SEASON: "Checklist Quiz - Season",
    CHECKLIST_QUIZ_MINUS_PLANNING: "Checklist Quiz - Planning",
    CHECKLIST_QUIZ_MINUS_FOOD: "Checklist Quiz - Food",
    CHECKLIST_QUIZ_MINUS_CARS: "Checklist Quiz - Cars",
    CHECKLIST_QUIZ_MINUS_KNOW_US: "Checklist Quiz - Know Us",
    CHECKLIST_QUIZ_MINUS_COREGISTRATION: "Checklist Quiz - Coregistration",
    CHECKLIST_QUIZ_MINUS_EMAIL_COLLECTION: "Checklist Quiz - Email Collection",
    ONBOARDING_MINUS_ROAD_AHEAD: "Onboarding - Road Ahead",
    ONBOARDING_MINUS_ARRIVAL_DATE: "Onboarding - Arrival Date",
    ONBOARDING_MINUS_MILESTONE: "Onboarding - Milestone",
    ONBOARDING_MINUS_ADOPTION_AFFIRMATION: "Onboarding - Adoption Affirmation",
    ONBOARDING_MINUS_STILL_TRYING_AFFIRMATION: "Onboarding - Still Trying Affirmation",
    ONBOARDING_MINUS_ADOPTION_AGE: "Onboarding - Adoption Age",
    ONBOARDING_MINUS_FIRST_TIME_PARENT: "Onboarding - First Time Parent",
    ONBOARDING_MINUS_SENTIMENT: "Onboarding - Sentiment",
    ONBOARDING_MINUS_PARTNER: "Onboarding - Partner",
    ONBOARDING_MINUS_YOU_GOT_THIS: "Onboarding - You Got This",
    ONBOARDING_MINUS_PARTNER_NAME: "Onboarding - Partner Name",
    ONBOARDING_MINUS_INVITE_PARTNER: "Onboarding - Invite Partner",
    ONBOARDING_MINUS_PARTNER_EMAIL_COLLECTION: "Onboarding - Partner Email Collection",
    ONBOARDING_MINUS_PARTNER_EMAIL_INVITE_SENT: "Onboarding - Partner Email Invite Sent",
    ONBOARDING_MINUS_VALUE_PROPOSITION: "Onboarding - Value Proposition",
    ONBOARDING_MINUS_BABYLIST_BUTTON: "Onboarding - Babylist Button",
    CHECKLIST_QUIZ_MINUS_EXPECTING_STATUS: "Checklist Quiz - Expecting Status",
    CHECKLIST_QUIZ_MINUS_HAVE_REGISTRY: "Checklist Quiz - Have Registry",
    STORE_MINUS_BRAND: "Store - Brand",
    ADD_ITEMS: "Add Items",
    CART_MINUS_RECOMMENDATIONS_CAROUSEL: "Cart - Recommendations Carousel",
    CART_MINUS_RECOMMENDATIONS_QUICK_VIEW_MODAL: "Cart - Recommendations Quick View Modal",
    ADD_ITEM_FOR_BRAND: "Add Item For Brand",
    GIFT_GIVER_MINUS_EMAIL_COLLECTION: "Gift Giver - Email Collection",
    GUIDES: "Guides",
    PLP: "PLP",
    ONBOARDING_MINUS_APP_DOWNLOAD: "Onboarding - App Download",
    TOOLBAR_MINUS_APP_DOWNLOAD: "Toolbar - App Download",
    TILE_MINUS_APP_DOWNLOAD: "Tile - App Download",
    DEEP_LINK: "Deep Link",
    CHECKLIST: "Checklist",
    CHECKLIST_CATEGORY: "Checklist Category",
    SETTINGS: "Settings",
    REGISTRY_PREVIEW_PAGE: "Registry Preview Page",
    REGISTRY_STARTER_PAGE: "Registry Starter Page",
    REGISTRY_CREATE_FORM: "Registry Create Form",
    ONBOARDING_MINUS_LIST_TYPE: "Onboarding - List Type",
    TAB_BAR: "Tab Bar",
    LIST_MINUS_EMPTY_LIST: "List - Empty List",
    ADD_ITEMS_MINUS_SEARCH: "Add Items - Search",
    ADD_ITEMS_MINUS_TILE: "Add Items - Tile",
    SEARCH_TEXT: "Search Text",
    SEARCH_PHOTO: "Search Photo",
    REGISTRY_EMPTY_STATE: "Registry Empty State",
    INSURANCE_PANEL_MINUS_TOP_INSURANCES: "Insurance Panel - Top Insurances",
    INSURANCE_PANEL_MINUS_ALL_INSURANCES: "Insurance Panel - All Insurances",
    INSURANCE_PANEL_MINUS_SEARCH_RESULTS: "Insurance Panel - Search Results",
    MOBILE_WEB_TOP_UTILITY_BAR: "Mobile Web Top Utility Bar",
    MOBILE_WEB_BOTTOM_NAV: "Mobile Web Bottom Nav",
    MOBILE_WEB_HAMBURGER: "Mobile Web Hamburger",
    WEB_TOP_NAV: "Web Top Nav",
    STORE_MINUS_CAROUSEL: "Store - Carousel",
    ACCOUNT_CREATION_FORM: "Account Creation Form",
    SETTINGS_MINUS_SHIPPING_ADDRESS: "Settings - Shipping Address",
    SETTINGS_MINUS_SHIPPING_CONSOLIDATION: "Settings - Shipping Consolidation",
    FIND_MY_REGISTRY: "Find My Registry",
    STORE_MINUS_SEARCH_SUGGESTIONS: "Store - Search Suggestions",
    MENU: "Menu",
    PDP_MINUS_ADD_TO_BABYLIST: "PDP - Add To Babylist",
    PDP_MINUS_ADD_TO_CART: "PDP - Add To Cart",
    ONBOARDING_MINUS_EMAIL_COLLECTION: "Onboarding - Email Collection",
    ALL_LISTS: "All Lists",
    REGISTRY_MINUS_PREFERENCES_ROW: "Registry - Preferences Row",
    REGISTRY_MINUS_STATS_ROW: "Registry - Stats Row",
    SUBSCRIPTION_MODAL_MINUS_DESKTOP_NAV: "Subscription Modal - Desktop Nav",
    SUBSCRIPTION_MODAL_MINUS_FOOTER: "Subscription Modal - Footer",
    SUBSCRIPTION_MODAL_MINUS_MOBILE_NAV: "Subscription Modal - Mobile Nav",
    SUBSCRIPTION_MODAL_MINUS_ARTICLE_SIDEBAR: "Subscription Modal - Article Sidebar",
    SUBSCRIPTION_MODAL_MINUS_ARTICLE_INMINUSLINE: "Subscription Modal - Article In-Line",
    SUBSCRIPTION_MODAL_MINUS_JOURNEY_STAGE: "Subscription Modal - Journey Stage",
    SUBSCRIPTION_MODAL_MINUS_DUE_DATE: "Subscription Modal - Due Date",
    SUBSCRIPTION_MODAL_MINUS_BABY_BIRTH_DATE: "Subscription Modal - Baby Birth Date",
    LIST_ADOPTION_MODAL_MINUS_FEED: "List Adoption Modal - Feed",
    LIST_ADOPTION_MODAL_MINUS_REGISTRY: "List Adoption Modal - Registry",
    LIST_ADOPTION_MODAL_MINUS_STORE: "List Adoption Modal - Store",
    LIST_ADOPTION_MODAL_MINUS_GUIDES: "List Adoption Modal - Guides",
    COPY_REG_ITEM_MINUS_CATEGORY_LIST: "Copy Reg Item - Category List",
    LOG_IN_MINUS_FORGOT_PASSWORD: "Log In - Forgot Password",
    LOG_IN_MINUS_LOG_IN_SCREEN: "Log In - Log In Screen",
    LOG_IN_MINUS_LOG_IN_MODAL: "Log In - Log In Modal",
    HOLIDAY_LANDING_PAGE: "Holiday Landing Page",
    LOG_IN_MINUS_START: "Log In - Start",
    LOG_IN_MINUS_TRY_GOOGLE: "Log In - Try Google",
    LOG_IN_MINUS_SUBMIT_EMAIL_PASSWORD: "Log In - Submit Email Password",
    LOG_IN_MINUS_GOOGLE_NO_ACCOUNT: "Log In - Google No Account",
    LOG_IN_MINUS_VERIFY_EMAIL_PASSWORD: "Log In - Verify Email Password",
    SIGN_UP_MINUS_EXISTING_ACCOUNT: "Sign Up - Existing Account",
    SIGN_UP_MINUS_NAME: "Sign Up - Name",
    SIGN_UP_MINUS_EMAIL_CONFIRMATION: "Sign Up - Email Confirmation",
    ONBOARDING_MINUS_ADD_WALKTHROUGH_INTRO: "Onboarding - Add Walkthrough Intro",
    ONBOARDING_MINUS_ADD_WALKTHROUGH: "Onboarding - Add Walkthrough",
    LOG_IN_MINUS_NO_ACCOUNT: "Log In - No Account",
    SIGN_UP_MINUS_START: "Sign Up - Start",
    SIGN_UP_MINUS_NAME_CONFIRMATION: "Sign Up - Name Confirmation",
    SIGN_UP_MINUS_NAME_AND_EMAIL_CONFIRMATION: "Sign Up - Name And Email Confirmation",
    EXTERNAL_REGISTRY_TRANSFER: "External Registry Transfer",
    SIGN_UP_MINUS_BABYLIST_BOOKMARKLET: "Sign Up - Babylist Bookmarklet",
    SIGN_UP_MINUS_BABYLIST_EMBEDDED_PARTNER_BUTTON: "Sign Up - Babylist Embedded Partner Button",
    SIGN_UP_MINUS_BABYLIST_EXTENSION: "Sign Up - Babylist Extension",
    SIGN_UP_MINUS_GUIDES_MINUS_ADD_ITEMS: "Sign Up - Guides - Add Items",
    ADD_ITEMS_MINUS_BABYLIST_BOOKMARKLET: "Add Items - Babylist Bookmarklet",
    ADD_ITEMS_MINUS_BABYLIST_EMBEDDED_PARTNER_BUTTON: "Add Items - Babylist Embedded Partner Button",
    ADD_ITEMS_MINUS_BABYLIST_EXTENSION: "Add Items - Babylist Extension",
    LOG_IN_MINUS_BABYLIST_BOOKMARKLET: "Log In - Babylist Bookmarklet",
    LOG_IN_MINUS_BABYLIST_EMBEDDED_PARTNER_BUTTON: "Log In - Babylist Embedded Partner Button",
    LOG_IN_MINUS_BABYLIST_EXTENSION: "Log In - Babylist Extension",
    HEALTH_REPLACEMENT_PARTS_ORDER_FORM: "Health Replacement Parts Order Form",
    PRODUCT: "Product",
    APP_BOTTOM_NAV: "App Bottom Nav",
    PUSH_NOTIFICATION: "Push Notification",
    MESSAGE_CENTER_INBOX: "Message Center Inbox",
    SHOP: "Shop",
    UNIFIED_SEARCH: "Unified Search",
    LOG_IN_MINUS_GUIDES_MINUS_ADD_ITEMS: "Log In - Guides - Add Items",
    HEALTH_INSURANCE_VERIFIER_TOOL: "Health Insurance Verifier Tool",
    HELLO_BABY_BOX_MINUS_SHIPPING_CONSOLIDATION: "Hello Baby Box - Shipping Consolidation",
    SHOP_MINUS_FLYOUT_NAV: "Shop - Flyout Nav",
    SHOP_MINUS_LEFT_NAV: "Shop - Left Nav",
    SHOP_MINUS_IMAGE_NAV: "Shop - Image Nav",
    SHOP_MINUS_BREADCRUMBS: "Shop - Breadcrumbs",
    FOOTER: "Footer",
    MOBILE_WEB_MINUS_CATEGORY_DROP_DOWN: "Mobile Web - Category Drop Down",
    HELLO_BABY_BOX_REQUIREMENTS: "Hello Baby Box Requirements",
    REGISTRY_MINUS_GIFT_GIVER_VIEW: "Registry - Gift Giver View",
    REGISTRY_MINUS_BUYING_OPTIONS_MODAL: "Registry - Buying Options Modal",
    LOG_IN_MINUS_DEEP_LINK: "Log In - Deep Link",
    PUSH_NOTIFICATION_OPTMINUSIN_MODAL: "Push Notification Opt-In Modal",
    DEVICE_MINUS_PUSH_NOTIFICATION_OPTMINUSIN_MODAL: "Device - Push Notification Opt-In Modal",
    DEVICE_MINUS_MESSAGE_CENTER_INBOX: "Device - Message Center Inbox",
    SHIPMENTS: "Shipments",
    SHIPMENT_DETAILS: "Shipment Details",
    ORDERS: "Orders",
    ORDER_DETAILS: "Order Details",
    HOME_MINUS_RIGHT_RAIL: "Home - Right Rail",
    HOME_MINUS_LEFT_RAIL: "Home - Left Rail",
    BOTTOM_NAV_BAR: "Bottom Nav Bar",
    STORE_MINUS_PRODUCT_CARD_QUICK_VIEW: "Store - Product Card Quick View",
    STORE_MINUS_PRODUCT_CARD: "Store - Product Card",
    REGISTRY_MINUS_BUYING_OPTION_REG_ITEM_CARD: "Registry - Buying Option Reg Item Card",
    REGISTRY_MINUS_ORGANIZE_ITEM_SCREEN: "Registry - Organize Item Screen",
  };

  function assertOptionalReservationStoreOriginal(reservationStoreOriginal,
    label_) {
    var messages = [];
    if (reservationStoreOriginal !== undefined && reservationStoreOriginal !== null) {
      messages = messages.concat(AvoAssert.assertString("-2YWaZ1CaG", label_ ? "reservation_store_original" + ": " + label_ : "reservation_store_original", reservationStoreOriginal));
    }
    return messages;
  }

  function assertUserAuthenticationMethod(userAuthenticationMethod, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("-5fcT2VKC", label_ ? "user_authentication_method" + ": " + label_ : "user_authentication_method", userAuthenticationMethod));
    if ("Email" !== userAuthenticationMethod &&
          "Apple" !== userAuthenticationMethod &&
          "Google" !== userAuthenticationMethod) {
      var message = (label_ ? "user_authentication_method" + ": " + label_ : "user_authentication_method") + " should match one of the following values [ Email | Apple | Google ] but you provided the value " + userAuthenticationMethod
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "-5fcT2VKC", message: message}]);
    }
    return messages;
  }

  function assertDiaperCalculatorPromptTotalCount(
    diaperCalculatorPromptTotalCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("-pTGCR-Pa9", label_ ? "diaper_calculator_prompt_total_count" + ": " + label_ : "diaper_calculator_prompt_total_count", diaperCalculatorPromptTotalCount));
    return messages;
  }

  function assertFeedItemTitle(feedItemTitle, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("05bQiKNQ-0", label_ ? "feed_item_title" + ": " + label_ : "feed_item_title", feedItemTitle));
    return messages;
  }

  function assertArrivalDate(arrivalDate, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("0Sl7tZu61R", label_ ? "arrival_date" + ": " + label_ : "arrival_date", arrivalDate));
    return messages;
  }

  function assertAppVersion(appVersion, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("0f-4JhLUSj", label_ ? "app_version" + ": " + label_ : "app_version", appVersion));
    return messages;
  }

  function assertOptionalRank(rank, label_) {
    var messages = [];
    if (rank !== undefined && rank !== null) {
      messages = messages.concat(AvoAssert.assertInt("11Ict5JuI9", label_ ? "rank" + ": " + label_ : "rank", rank));
    }
    return messages;
  }

  function assertDiaperCalculatorPromptIndex(diaperCalculatorPromptIndex,
    label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("1QOf3CIcKI", label_ ? "diaper_calculator_prompt_index" + ": " + label_ : "diaper_calculator_prompt_index", diaperCalculatorPromptIndex));
    return messages;
  }

  function assertCartItemQuantity(cartItemQuantity, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("1Vdhmd-w_5", label_ ? "cart_item_quantity" + ": " + label_ : "cart_item_quantity", cartItemQuantity));
    return messages;
  }

  function assertBranchId(branchId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("2D0Tn9jeZ9", label_ ? "branch_id" + ": " + label_ : "branch_id", branchId));
    return messages;
  }

  function assertOptionalReqDeviceType(reqDeviceType, label_) {
    var messages = [];
    if (reqDeviceType !== undefined && reqDeviceType !== null) {
      messages = messages.concat(AvoAssert.assertString("2evh-NL9K4", label_ ? "req_device_type" + ": " + label_ : "req_device_type", reqDeviceType));
    }
    return messages;
  }

  function assertOptionalExperimentGroup(experimentGroup, label_) {
    var messages = [];
    if (experimentGroup !== undefined && experimentGroup !== null) {
      messages = messages.concat(AvoAssert.assertString("2fe5gtXT8S", label_ ? "experiment_group" + ": " + label_ : "experiment_group", experimentGroup));
    }
    return messages;
  }

  function assertExperimentGroup(experimentGroup, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("2fe5gtXT8S", label_ ? "experiment_group" + ": " + label_ : "experiment_group", experimentGroup));
    return messages;
  }

  function assertOptionalEmailProvided(emailProvided, label_) {
    var messages = [];
    if (emailProvided !== undefined && emailProvided !== null) {
      messages = messages.concat(AvoAssert.assertBool("2qrsdSn6P", label_ ? "email_provided" + ": " + label_ : "email_provided", emailProvided));
    }
    return messages;
  }

  function assertOptionalReqBlAnonId(reqBlAnonId, label_) {
    var messages = [];
    if (reqBlAnonId !== undefined && reqBlAnonId !== null) {
      messages = messages.concat(AvoAssert.assertString("3cepIA03RI", label_ ? "req_bl_anon_id" + ": " + label_ : "req_bl_anon_id", reqBlAnonId));
    }
    return messages;
  }

  function assertTop20Results(top20Results, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("3gjxIHhWK", "top_20_results", top20Results));
    if (top20Results !== null && top20Results !== undefined && top20Results.forEach) {
      top20Results.forEach(function (value, index) {
      });
    }
    return messages;
  }

  function assertFeedItemType(feedItemType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("40T5ce69rV", label_ ? "feed_item_type" + ": " + label_ : "feed_item_type", feedItemType));
    return messages;
  }

  function assertRegistryTemplateType(registryTemplateType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("47VVtO4qg", label_ ? "registry_template_type" + ": " + label_ : "registry_template_type", registryTemplateType));
    if ("prior_reg" !== registryTemplateType &&
          "reg_template" !== registryTemplateType &&
          "reg_template_sponsored" !== registryTemplateType &&
          "blank" !== registryTemplateType) {
      var message = (label_ ? "registry_template_type" + ": " + label_ : "registry_template_type") + " should match one of the following values [ prior_reg | reg_template | reg_template_sponsored | blank ] but you provided the value " + registryTemplateType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "47VVtO4qg", message: message}]);
    }
    return messages;
  }

  function assertFilters(filters, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("4K1X2mTbIS", label_ ? "filters" + ": " + label_ : "filters", filters));
    return messages;
  }

  function assertFreeGiftSelected(freeGiftSelected, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("5LZ4gMc0f", label_ ? "free_gift_selected" + ": " + label_ : "free_gift_selected", freeGiftSelected));
    return messages;
  }

  function assertOptionalCategoryId(categoryId, label_) {
    var messages = [];
    if (categoryId !== undefined && categoryId !== null) {
      messages = messages.concat(AvoAssert.assertString("6aTdu1v9r8", label_ ? "category_id" + ": " + label_ : "category_id", categoryId));
    }
    return messages;
  }

  function assertFeedSessionId(feedSessionId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("7PziKxGyrH", label_ ? "feed_session_id" + ": " + label_ : "feed_session_id", feedSessionId));
    return messages;
  }

  function assertOptionalSuggestedCategoryTitle(suggestedCategoryTitle,
    label_) {
    var messages = [];
    if (suggestedCategoryTitle !== undefined && suggestedCategoryTitle !== null) {
      messages = messages.concat(AvoAssert.assertString("7ZAoZUrw6e", label_ ? "suggested_category_title" + ": " + label_ : "suggested_category_title", suggestedCategoryTitle));
    }
    return messages;
  }

  function assertOptionalReqLibrary(reqLibrary, label_) {
    var messages = [];
    if (reqLibrary !== undefined && reqLibrary !== null) {
      messages = messages.concat(AvoAssert.assertString("7hn8qCCpUt", label_ ? "req_library" + ": " + label_ : "req_library", reqLibrary));
    }
    return messages;
  }

  function assertDiaperCalculatorResultName(diaperCalculatorResultName,
    label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("8AoVlXgXPn", label_ ? "diaper_calculator_result_name" + ": " + label_ : "diaper_calculator_result_name", diaperCalculatorResultName));
    return messages;
  }

  function assertExternalRegistryUrl(externalRegistryUrl, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("8Cxs_Nq4i", label_ ? "external_registry_url" + ": " + label_ : "external_registry_url", externalRegistryUrl));
    return messages;
  }

  function assertInsuranceName(insuranceName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("8ls_yj5rwW", label_ ? "insurance_name" + ": " + label_ : "insurance_name", insuranceName));
    return messages;
  }

  function assertMessageId(messageId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("8mW_BCBJR", label_ ? "message_id" + ": " + label_ : "message_id", messageId));
    return messages;
  }

  function assertOptionalUtmCoop(utmCoop, label_) {
    var messages = [];
    if (utmCoop !== undefined && utmCoop !== null) {
      messages = messages.concat(AvoAssert.assertString("8qZabQPXtS", label_ ? "utm_coop" + ": " + label_ : "utm_coop", utmCoop));
    }
    return messages;
  }

  function assertOptionalFeedbackTextValue(feedbackTextValue, label_) {
    var messages = [];
    if (feedbackTextValue !== undefined && feedbackTextValue !== null) {
      messages = messages.concat(AvoAssert.assertString("8sWc-mWJy", label_ ? "feedback_text_value" + ": " + label_ : "feedback_text_value", feedbackTextValue));
    }
    return messages;
  }

  function assertOptionalRegistryId(registryId, label_) {
    var messages = [];
    if (registryId !== undefined && registryId !== null) {
      messages = messages.concat(AvoAssert.assertInt("8uZciylnJf", label_ ? "registry_id" + ": " + label_ : "registry_id", registryId));
    }
    return messages;
  }

  function assertPostType(postType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("94vyME35Ha", label_ ? "post_type" + ": " + label_ : "post_type", postType));
    return messages;
  }

  function assertOptionalPostType(postType, label_) {
    var messages = [];
    if (postType !== undefined && postType !== null) {
      messages = messages.concat(AvoAssert.assertString("94vyME35Ha", label_ ? "post_type" + ": " + label_ : "post_type", postType));
    }
    return messages;
  }

  function assertOptionalListType(listType, label_) {
    var messages = [];
    if (listType !== undefined && listType !== null) {
      messages = messages.concat(AvoAssert.assertString("9CoXibTIEF", label_ ? "list_type" + ": " + label_ : "list_type", listType));
      if ("birthday" !== listType && "baby_registry" !== listType &&
            "holiday" !== listType) {
        var message = (label_ ? "list_type" + ": " + label_ : "list_type") + " should match one of the following values [ birthday | baby_registry | holiday ] but you provided the value " + listType
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "9CoXibTIEF", message: message}]);
      }
    }
    return messages;
  }

  function assertOptionalPositionInList(positionInList, label_) {
    var messages = [];
    if (positionInList !== undefined && positionInList !== null) {
      messages = messages.concat(AvoAssert.assertInt("9hIUmuT0nS", label_ ? "position_in_list" + ": " + label_ : "position_in_list", positionInList));
      messages = messages.concat(AvoAssert.assertMin("9hIUmuT0nS", label_ ? "position_in_list" + ": " + label_ : "position_in_list", 1, positionInList));
    }
    return messages;
  }

  function assertPositionInList(positionInList, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("9hIUmuT0nS", label_ ? "position_in_list" + ": " + label_ : "position_in_list", positionInList));
    messages = messages.concat(AvoAssert.assertMin("9hIUmuT0nS", label_ ? "position_in_list" + ": " + label_ : "position_in_list", 1, positionInList));
    return messages;
  }

  function assertOptionalCartTotalValue(cartTotalValue, label_) {
    var messages = [];
    if (cartTotalValue !== undefined && cartTotalValue !== null) {
      messages = messages.concat(AvoAssert.assertFloat("AbcCBgMrrb", label_ ? "cart_total_value" + ": " + label_ : "cart_total_value", cartTotalValue));
    }
    return messages;
  }

  function assertOptionalContentId(contentId, label_) {
    var messages = [];
    if (contentId !== undefined && contentId !== null) {
      messages = messages.concat(AvoAssert.assertString("AuhMqGrHU", label_ ? "content_id" + ": " + label_ : "content_id", contentId));
    }
    return messages;
  }

  function assertOptionalMinEstimate(minEstimate, label_) {
    var messages = [];
    if (minEstimate !== undefined && minEstimate !== null) {
      messages = messages.concat(AvoAssert.assertInt("AwOV6QJA4", label_ ? "min_estimate" + ": " + label_ : "min_estimate", minEstimate));
    }
    return messages;
  }

  function assertOptionalCategoryTitle(categoryTitle, label_) {
    var messages = [];
    if (categoryTitle !== undefined && categoryTitle !== null) {
      messages = messages.concat(AvoAssert.assertString("B17latt6RY", label_ ? "category_title" + ": " + label_ : "category_title", categoryTitle));
    }
    return messages;
  }

  function assertCategoryTitle(categoryTitle, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("B17latt6RY", label_ ? "category_title" + ": " + label_ : "category_title", categoryTitle));
    return messages;
  }

  function assertCoregistrationPromptType(coregistrationPromptType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Bep0RyMDTf", label_ ? "coregistration_prompt_type" + ": " + label_ : "coregistration_prompt_type", coregistrationPromptType));
    if ("modal" !== coregistrationPromptType &&
          "page" !== coregistrationPromptType) {
      var message = (label_ ? "coregistration_prompt_type" + ": " + label_ : "coregistration_prompt_type") + " should match one of the following values [ modal | page ] but you provided the value " + coregistrationPromptType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "Bep0RyMDTf", message: message}]);
    }
    return messages;
  }

  function assertOptionalUtmTerm(utmTerm, label_) {
    var messages = [];
    if (utmTerm !== undefined && utmTerm !== null) {
      messages = messages.concat(AvoAssert.assertString("CEkofPYbd2", label_ ? "utm_term" + ": " + label_ : "utm_term", utmTerm));
    }
    return messages;
  }

  function assertOptionalMaxEstimate(maxEstimate, label_) {
    var messages = [];
    if (maxEstimate !== undefined && maxEstimate !== null) {
      messages = messages.concat(AvoAssert.assertInt("D9u-ew0U3", label_ ? "max_estimate" + ": " + label_ : "max_estimate", maxEstimate));
    }
    return messages;
  }

  function assertOptionalSearchTerm(searchTerm, label_) {
    var messages = [];
    if (searchTerm !== undefined && searchTerm !== null) {
      messages = messages.concat(AvoAssert.assertString("DP8VA0H6RC", label_ ? "search_term" + ": " + label_ : "search_term", searchTerm));
    }
    return messages;
  }

  function assertSearchTerm(searchTerm, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("DP8VA0H6RC", label_ ? "search_term" + ": " + label_ : "search_term", searchTerm));
    return messages;
  }

  function assertOptionalEventUrl(eventUrl, label_) {
    var messages = [];
    if (eventUrl !== undefined && eventUrl !== null) {
      messages = messages.concat(AvoAssert.assertString("Dkb7pVwGYW", label_ ? "event_url" + ": " + label_ : "event_url", eventUrl));
    }
    return messages;
  }

  function assertOptionalReservationStoreUpdated(reservationStoreUpdated,
    label_) {
    var messages = [];
    if (reservationStoreUpdated !== undefined && reservationStoreUpdated !== null) {
      messages = messages.concat(AvoAssert.assertString("Ds1npU9g2O", label_ ? "reservation_store_updated" + ": " + label_ : "reservation_store_updated", reservationStoreUpdated));
    }
    return messages;
  }

  function assertInsuranceProvider(insuranceProvider, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ENRznu7YeV", label_ ? "insurance_provider" + ": " + label_ : "insurance_provider", insuranceProvider));
    return messages;
  }

  function assertOptionalProductBrand(productBrand, label_) {
    var messages = [];
    if (productBrand !== undefined && productBrand !== null) {
      messages = messages.concat(AvoAssert.assertString("EUdmleR_r0", label_ ? "product_brand" + ": " + label_ : "product_brand", productBrand));
    }
    return messages;
  }

  function assertOptionalEventCta(eventCta, label_) {
    var messages = [];
    if (eventCta !== undefined && eventCta !== null) {
      messages = messages.concat(AvoAssert.assertString("FAr2OJLazI", label_ ? "event_cta" + ": " + label_ : "event_cta", eventCta));
    }
    return messages;
  }

  function assertOptionalReqUtmTerm(reqUtmTerm, label_) {
    var messages = [];
    if (reqUtmTerm !== undefined && reqUtmTerm !== null) {
      messages = messages.concat(AvoAssert.assertString("FZC-2sIqqH", label_ ? "req_utm_term" + ": " + label_ : "req_utm_term", reqUtmTerm));
    }
    return messages;
  }

  function assertOptionalStrategy(strategy, label_) {
    var messages = [];
    if (strategy !== undefined && strategy !== null) {
      messages = messages.concat(AvoAssert.assertString("FjngcQv7h", label_ ? "strategy" + ": " + label_ : "strategy", strategy));
    }
    return messages;
  }

  function assertOptionalInStockSoonMessage(inStockSoonMessage, label_) {
    var messages = [];
    if (inStockSoonMessage !== undefined && inStockSoonMessage !== null) {
      messages = messages.concat(AvoAssert.assertBool("FymJ-MEah", label_ ? "in_stock_soon_message" + ": " + label_ : "in_stock_soon_message", inStockSoonMessage));
    }
    return messages;
  }

  function assertOptionalGuideTopics(guideTopics, label_) {
    var messages = [];
    if (guideTopics !== undefined && guideTopics !== null) {
      messages = messages.concat(AvoAssert.assertList("G6bkpcJWx", "Guide Topics", guideTopics));
      guideTopics.forEach(function (value, index) {
      });
    }
    return messages;
  }

  function assertRegItemId(regItemId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("GD_6h8Uh9", label_ ? "reg_item_id" + ": " + label_ : "reg_item_id", regItemId));
    return messages;
  }

  function assertStoreSearchTerms(storeSearchTerms, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("GEjpAADWrj", label_ ? "store_search_terms" + ": " + label_ : "store_search_terms", storeSearchTerms));
    return messages;
  }

  function assertOptionalGetNotifiedWhenThisIsInStockMessage(
    getNotifiedWhenThisIsInStockMessage, label_) {
    var messages = [];
    if (getNotifiedWhenThisIsInStockMessage !== undefined && getNotifiedWhenThisIsInStockMessage !== null) {
      messages = messages.concat(AvoAssert.assertBool("Gd7BtoYo_", label_ ? "get_notified_when_this_is_in_stock_message" + ": " + label_ : "get_notified_when_this_is_in_stock_message", getNotifiedWhenThisIsInStockMessage));
    }
    return messages;
  }

  function assertDiaperCalculatorOptionKey(diaperCalculatorOptionKey, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("GtjrRtlHJ_", label_ ? "diaper_calculator_option_key" + ": " + label_ : "diaper_calculator_option_key", diaperCalculatorOptionKey));
    return messages;
  }

  function assertContentIds(contentIds, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("HQ-Sfte1o2", "content_ids", contentIds));
    if (contentIds !== null && contentIds !== undefined && contentIds.forEach) {
      contentIds.forEach(function (value, index) {
        messages = messages.concat(AvoAssert.assertString("HQ-Sfte1o2", "item at index " + index + " in content_ids", value));
        if ("pregnancy" !== value && "adoption" !== value &&
              "surrogacy" !== value && "stillTrying" !== value) {
          var message = (label_ ? "item at index " + index + " in content_ids" + ": " + label_ : "item at index " + index + " in content_ids") + " should match one of the following values [ pregnancy | adoption | surrogacy | stillTrying ] but you provided the value " + value
          messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "HQ-Sfte1o2", message: message}]);
        }
      });
    }
    return messages;
  }

  function assertFeedItemId(feedItemId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("HfvztBLQ9W", label_ ? "feed_item_id" + ": " + label_ : "feed_item_id", feedItemId));
    return messages;
  }

  function assertOptionalProductIds(productIds, label_) {
    var messages = [];
    if (productIds !== undefined && productIds !== null) {
      messages = messages.concat(AvoAssert.assertList("IBTbEZvoWR", "product_ids", productIds));
      productIds.forEach(function (value, index) {
      });
    }
    return messages;
  }

  function assertStoreCategoryName(storeCategoryName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("IT3W1-U_HY", label_ ? "store_category_name" + ": " + label_ : "store_category_name", storeCategoryName));
    return messages;
  }

  function assertState(state, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("IwLCHBAQ8", label_ ? "state" + ": " + label_ : "state", state));
    return messages;
  }

  function assertBlockerType(blockerType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("JF9Kviyl_", label_ ? "blocker_type" + ": " + label_ : "blocker_type", blockerType));
    if ("INSURANCE_VERIFICATION_FAILED" !== blockerType &&
          "INSURANCE_UNSUPPORTED" !== blockerType &&
          "ORDER_IN_PROGRESS" !== blockerType &&
          "AWAITING_PAID_INVOICE" !== blockerType &&
          "ORDER_PLACED_WITHIN_INTERVAL" !== blockerType &&
          "SUBSCRIPTION_ENDED" !== blockerType &&
          "UNKNOWN_ERROR" !== blockerType) {
      var message = (label_ ? "blocker_type" + ": " + label_ : "blocker_type") + " should match one of the following values [ INSURANCE_VERIFICATION_FAILED | INSURANCE_UNSUPPORTED | ORDER_IN_PROGRESS | AWAITING_PAID_INVOICE | ORDER_PLACED_WITHIN_INTERVAL | SUBSCRIPTION_ENDED | UNKNOWN_ERROR ] but you provided the value " + blockerType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "JF9Kviyl_", message: message}]);
    }
    return messages;
  }

  function assertIsPartner(isPartner, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("JFNgXwT9Pn", label_ ? "is_partner" + ": " + label_ : "is_partner", isPartner));
    return messages;
  }

  function assertCartTypes(cartTypes, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("JKdXRUiKFn", "cart_types", cartTypes));
    if (cartTypes !== null && cartTypes !== undefined && cartTypes.forEach) {
      cartTypes.forEach(function (value, index) {
        messages = messages.concat(AvoAssert.assertString("JKdXRUiKFn", "item at index " + index + " in cart_types", value));
        if ("Store" !== value && "Store Reservation" !== value &&
              "External Reservation" !== value && "Split Cart" !== value) {
          var message = (label_ ? "item at index " + index + " in cart_types" + ": " + label_ : "item at index " + index + " in cart_types") + " should match one of the following values [ Store | Store Reservation | External Reservation | Split Cart ] but you provided the value " + value
          messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "JKdXRUiKFn", message: message}]);
        }
      });
    }
    return messages;
  }

  function assertOptionalUserLastName(userLastName, label_) {
    var messages = [];
    if (userLastName !== undefined && userLastName !== null) {
      messages = messages.concat(AvoAssert.assertString("JUHzVfzt_p", label_ ? "user_last_name" + ": " + label_ : "user_last_name", userLastName));
    }
    return messages;
  }

  function assertOptionalReqLandingPage(reqLandingPage, label_) {
    var messages = [];
    if (reqLandingPage !== undefined && reqLandingPage !== null) {
      messages = messages.concat(AvoAssert.assertString("Jn1_yHbURD", label_ ? "req_landing_page" + ": " + label_ : "req_landing_page", reqLandingPage));
    }
    return messages;
  }

  function assertOptionalErrorMessage(errorMessage, label_) {
    var messages = [];
    if (errorMessage !== undefined && errorMessage !== null) {
      messages = messages.concat(AvoAssert.assertString("Jpho3Mg1f", label_ ? "error_message" + ": " + label_ : "error_message", errorMessage));
    }
    return messages;
  }

  function assertOptionalRegistryTemplateId(registryTemplateId, label_) {
    var messages = [];
    if (registryTemplateId !== undefined && registryTemplateId !== null) {
      messages = messages.concat(AvoAssert.assertInt("KEBwqFi-k", label_ ? "registry_template_id" + ": " + label_ : "registry_template_id", registryTemplateId));
    }
    return messages;
  }

  function assertFeedItemSession(feedItemSession, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("KNpC1hHEmV", label_ ? "feed_item_session" + ": " + label_ : "feed_item_session", feedItemSession));
    return messages;
  }

  function assertComponentType(componentType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Kbkh_3jyi", label_ ? "component_type" + ": " + label_ : "component_type", componentType));
    if ("hero_banner" !== componentType &&
          "product_carousel" !== componentType &&
          "feature_banner" !== componentType &&
          "promo_banner" !== componentType && "video" !== componentType &&
          "guide" !== componentType && "navigation" !== componentType &&
          "bottom_banner" !== componentType) {
      var message = (label_ ? "component_type" + ": " + label_ : "component_type") + " should match one of the following values [ hero_banner | product_carousel | feature_banner | promo_banner | video | guide | navigation | bottom_banner ] but you provided the value " + componentType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "Kbkh_3jyi", message: message}]);
    }
    return messages;
  }

  function assertOptionalRegistryOwnerId(registryOwnerId, label_) {
    var messages = [];
    if (registryOwnerId !== undefined && registryOwnerId !== null) {
      messages = messages.concat(AvoAssert.assertInt("KljnHhmsWG", label_ ? "registry_owner_id" + ": " + label_ : "registry_owner_id", registryOwnerId));
    }
    return messages;
  }

  function assertDeviceType(deviceType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("KriAEwq44m", label_ ? "device_type" + ": " + label_ : "device_type", deviceType));
    if ("tablet" !== deviceType && "mobile" !== deviceType &&
          "desktop" !== deviceType && "backend" !== deviceType) {
      var message = (label_ ? "device_type" + ": " + label_ : "device_type") + " should match one of the following values [ tablet | mobile | desktop | backend ] but you provided the value " + deviceType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "KriAEwq44m", message: message}]);
    }
    return messages;
  }

  function assertOptionalSortCriteria(sortCriteria, label_) {
    var messages = [];
    if (sortCriteria !== undefined && sortCriteria !== null) {
      messages = messages.concat(AvoAssert.assertString("LAMqRUVdxT", label_ ? "sort_criteria" + ": " + label_ : "sort_criteria", sortCriteria));
      if ("Price" !== sortCriteria && "Rating" !== sortCriteria &&
            "Review Count" !== sortCriteria && "Popular" !== sortCriteria &&
            "Newest" !== sortCriteria) {
        var message = (label_ ? "sort_criteria" + ": " + label_ : "sort_criteria") + " should match one of the following values [ Price | Rating | Review Count | Popular | Newest ] but you provided the value " + sortCriteria
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "LAMqRUVdxT", message: message}]);
      }
    }
    return messages;
  }

  function assertProductCollectionId(productCollectionId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("M9-9nF71Sp", label_ ? "product_collection_id" + ": " + label_ : "product_collection_id", productCollectionId));
    return messages;
  }

  function assertCoregistrationPartnerKey(coregistrationPartnerKey, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("MaKhICXQFA", label_ ? "coregistration_partner_key" + ": " + label_ : "coregistration_partner_key", coregistrationPartnerKey));
    return messages;
  }

  function assertUserId(userId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("Mzj1HBhPg9", label_ ? "user_id" + ": " + label_ : "user_id", userId));
    return messages;
  }

  function assertOptionalUserId(userId, label_) {
    var messages = [];
    if (userId !== undefined && userId !== null) {
      messages = messages.concat(AvoAssert.assertInt("Mzj1HBhPg9", label_ ? "user_id" + ": " + label_ : "user_id", userId));
    }
    return messages;
  }

  function assertOptionalBlAnonId(blAnonId, label_) {
    var messages = [];
    if (blAnonId !== undefined && blAnonId !== null) {
      messages = messages.concat(AvoAssert.assertString("NDLOh-q9J", label_ ? "bl_anon_id" + ": " + label_ : "bl_anon_id", blAnonId));
    }
    return messages;
  }

  function assertChecklistCategoryId(checklistCategoryId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("NYCVcKFMW-", label_ ? "checklist_category_id" + ": " + label_ : "checklist_category_id", checklistCategoryId));
    return messages;
  }

  function assertOptionalWillArriveBeforeArrivalDate(
    willArriveBeforeArrivalDate, label_) {
    var messages = [];
    if (willArriveBeforeArrivalDate !== undefined && willArriveBeforeArrivalDate !== null) {
      messages = messages.concat(AvoAssert.assertBool("Ni97m-DIV", label_ ? "will_arrive_before_arrival_date" + ": " + label_ : "will_arrive_before_arrival_date", willArriveBeforeArrivalDate));
    }
    return messages;
  }

  function assertOptionalReqLastExternalReferrer(reqLastExternalReferrer,
    label_) {
    var messages = [];
    if (reqLastExternalReferrer !== undefined && reqLastExternalReferrer !== null) {
      messages = messages.concat(AvoAssert.assertString("NwyX62Z4r2", label_ ? "req_last_external_referrer" + ": " + label_ : "req_last_external_referrer", reqLastExternalReferrer));
    }
    return messages;
  }

  function assertOptionalIsSynthetic(isSynthetic, label_) {
    var messages = [];
    if (isSynthetic !== undefined && isSynthetic !== null) {
      messages = messages.concat(AvoAssert.assertBool("OH8aphJyJx", label_ ? "is_synthetic" + ": " + label_ : "is_synthetic", isSynthetic));
    }
    return messages;
  }

  function assertCapiEventId(capiEventId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("P1RHrSlsWX", label_ ? "capi_event_id" + ": " + label_ : "capi_event_id", capiEventId));
    return messages;
  }

  function assertOptionalRegistryTemplateTitle(registryTemplateTitle, label_) {
    var messages = [];
    if (registryTemplateTitle !== undefined && registryTemplateTitle !== null) {
      messages = messages.concat(AvoAssert.assertString("P5TuvrzYy", label_ ? "registry_template_title" + ": " + label_ : "registry_template_title", registryTemplateTitle));
    }
    return messages;
  }

  function assertOfferIds(offerIds, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("P91IirEr8", "offer_ids", offerIds));
    if (offerIds !== null && offerIds !== undefined && offerIds.forEach) {
      offerIds.forEach(function (value, index) {
      });
    }
    return messages;
  }

  function assertOptionalUrlClicked(urlClicked, label_) {
    var messages = [];
    if (urlClicked !== undefined && urlClicked !== null) {
      messages = messages.concat(AvoAssert.assertString("PQeYFLl2c", label_ ? "url_clicked" + ": " + label_ : "url_clicked", urlClicked));
    }
    return messages;
  }

  function assertUrlClicked(urlClicked, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("PQeYFLl2c", label_ ? "url_clicked" + ": " + label_ : "url_clicked", urlClicked));
    return messages;
  }

  function assertDiaperCalculatorPromptKey(diaperCalculatorPromptKey, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Q3tkWMgoe5", label_ ? "diaper_calculator_prompt_key" + ": " + label_ : "diaper_calculator_prompt_key", diaperCalculatorPromptKey));
    return messages;
  }

  function assertInboxId(inboxId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("QmI5NOtzp", label_ ? "inbox_id" + ": " + label_ : "inbox_id", inboxId));
    return messages;
  }

  function assertProductCollectionTitle(productCollectionTitle, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("QohJgPisdx", label_ ? "product_collection_title" + ": " + label_ : "product_collection_title", productCollectionTitle));
    return messages;
  }

  function assertEmail(email, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("RKqhBhnmEV", label_ ? "email" + ": " + label_ : "email", email));
    return messages;
  }

  function assertOptionalEntryPoint(entryPoint, label_) {
    var messages = [];
    if (entryPoint !== undefined && entryPoint !== null) {
      messages = messages.concat(AvoAssert.assertString("SEpbyxPtUJ", label_ ? "entry_point" + ": " + label_ : "entry_point", entryPoint));
    }
    return messages;
  }

  function assertIsFirstRegItem(isFirstRegItem, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("SqR4V-W1h", label_ ? "is_first_reg_item" + ": " + label_ : "is_first_reg_item", isFirstRegItem));
    return messages;
  }

  function assertOriginalCartTotal(originalCartTotal, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertFloat("UFTlxllG8K", label_ ? "original_cart_total" + ": " + label_ : "original_cart_total", originalCartTotal));
    return messages;
  }

  function assertOptionalUserFirstName(userFirstName, label_) {
    var messages = [];
    if (userFirstName !== undefined && userFirstName !== null) {
      messages = messages.concat(AvoAssert.assertString("UqqJyK4STl", label_ ? "user_first_name" + ": " + label_ : "user_first_name", userFirstName));
    }
    return messages;
  }

  function assertChecklistType(checklistType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("VMnhclaN1n", label_ ? "checklist_type" + ": " + label_ : "checklist_type", checklistType));
    return messages;
  }

  function assertResultCount(resultCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("VPXPSm5669", label_ ? "result_count" + ": " + label_ : "result_count", resultCount));
    return messages;
  }

  function assertFormName(formName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("VWt-iAFvK", label_ ? "form_name" + ": " + label_ : "form_name", formName));
    if ("Customer Insurance Form" !== formName &&
          "Physician Search Form" !== formName &&
          "Customer Verification Form" !== formName &&
          "Insurance Form" !== formName &&
          "Replacement Parts Order Form" !== formName &&
          "Replacement Parts New Insurance Form" !== formName) {
      var message = (label_ ? "form_name" + ": " + label_ : "form_name") + " should match one of the following values [ Customer Insurance Form | Physician Search Form | Customer Verification Form | Insurance Form | Replacement Parts Order Form | Replacement Parts New Insurance Form ] but you provided the value " + formName
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "VWt-iAFvK", message: message}]);
    }
    return messages;
  }

  function assertOptionalItemType(itemType, label_) {
    var messages = [];
    if (itemType !== undefined && itemType !== null) {
      messages = messages.concat(AvoAssert.assertString("VZ1_hmw_sP", label_ ? "item_type" + ": " + label_ : "item_type", itemType));
      if ("Text" !== itemType && "Photo" !== itemType) {
        var message = (label_ ? "item_type" + ": " + label_ : "item_type") + " should match one of the following values [ Text | Photo ] but you provided the value " + itemType
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "VZ1_hmw_sP", message: message}]);
      }
    }
    return messages;
  }

  function assertOptionalSearchId(searchId, label_) {
    var messages = [];
    if (searchId !== undefined && searchId !== null) {
      messages = messages.concat(AvoAssert.assertString("VlL55_rwx1", label_ ? "search_id" + ": " + label_ : "search_id", searchId));
    }
    return messages;
  }

  function assertDeactivationReason(deactivationReason, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("VwUny5mM2v", label_ ? "deactivation_reason" + ": " + label_ : "deactivation_reason", deactivationReason));
    if ("Baby Arrived" !== deactivationReason &&
          "Too Much Email" !== deactivationReason &&
          "Just Because" !== deactivationReason &&
          "Experienced a Loss" !== deactivationReason) {
      var message = (label_ ? "deactivation_reason" + ": " + label_ : "deactivation_reason") + " should match one of the following values [ Baby Arrived | Too Much Email | Just Because | Experienced a Loss ] but you provided the value " + deactivationReason
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "VwUny5mM2v", message: message}]);
    }
    return messages;
  }

  function assertFeedbackValue(feedbackValue, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("WGPIMEP175", label_ ? "feedback_value" + ": " + label_ : "feedback_value", feedbackValue));
    return messages;
  }

  function assertSlotPosition(slotPosition, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("WJKbg26Iv", label_ ? "slot_position" + ": " + label_ : "slot_position", slotPosition));
    messages = messages.concat(AvoAssert.assertMin("WJKbg26Iv", label_ ? "slot_position" + ": " + label_ : "slot_position", 1, slotPosition));
    return messages;
  }

  function assertPlatform(platform, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("WS8hgbYjUd", label_ ? "platform" + ": " + label_ : "platform", platform));
    return messages;
  }

  function assertOptionalReferrer(referrer, label_) {
    var messages = [];
    if (referrer !== undefined && referrer !== null) {
      messages = messages.concat(AvoAssert.assertString("X7_HdTU1M4", label_ ? "referrer" + ": " + label_ : "referrer", referrer));
    }
    return messages;
  }

  function assertOptionalProductRecommenderModelVersion(
    productRecommenderModelVersion, label_) {
    var messages = [];
    if (productRecommenderModelVersion !== undefined && productRecommenderModelVersion !== null) {
      messages = messages.concat(AvoAssert.assertString("YQ72-3ABf", label_ ? "product_recommender_model_version" + ": " + label_ : "product_recommender_model_version", productRecommenderModelVersion));
    }
    return messages;
  }

  function assertOptionalFacebookClickId(facebookClickId, label_) {
    var messages = [];
    if (facebookClickId !== undefined && facebookClickId !== null) {
      messages = messages.concat(AvoAssert.assertString("YcHHHs516", label_ ? "facebook_click_id" + ": " + label_ : "facebook_click_id", facebookClickId));
    }
    return messages;
  }

  function assertInsuranceProviderId(insuranceProviderId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("ZmEyxhz5TT", label_ ? "insurance_provider_id" + ": " + label_ : "insurance_provider_id", insuranceProviderId));
    return messages;
  }

  function assertOptionalSuggestedCategoryReturned(suggestedCategoryReturned,
    label_) {
    var messages = [];
    if (suggestedCategoryReturned !== undefined && suggestedCategoryReturned !== null) {
      messages = messages.concat(AvoAssert.assertString("Zqh3aYRqWf", label_ ? "suggested_category_returned" + ": " + label_ : "suggested_category_returned", suggestedCategoryReturned));
    }
    return messages;
  }

  function assertRegItemQuantity(regItemQuantity, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("_IP9QswtZC", label_ ? "reg_item_quantity" + ": " + label_ : "reg_item_quantity", regItemQuantity));
    return messages;
  }

  function assertRegDiscountApplied(regDiscountApplied, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("__MYG2YQnE", label_ ? "reg_discount_applied" + ": " + label_ : "reg_discount_applied", regDiscountApplied));
    return messages;
  }

  function assertOptionalInitialSearchBarSize(initialSearchBarSize, label_) {
    var messages = [];
    if (initialSearchBarSize !== undefined && initialSearchBarSize !== null) {
      messages = messages.concat(AvoAssert.assertString("_rOlgjAh0G", label_ ? "initial_search_bar_size" + ": " + label_ : "initial_search_bar_size", initialSearchBarSize));
      if ("Icon" !== initialSearchBarSize &&
            "Expanded" !== initialSearchBarSize) {
        var message = (label_ ? "initial_search_bar_size" + ": " + label_ : "initial_search_bar_size") + " should match one of the following values [ Icon | Expanded ] but you provided the value " + initialSearchBarSize
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "_rOlgjAh0G", message: message}]);
      }
    }
    return messages;
  }

  function assertOptionalEventType(eventType, label_) {
    var messages = [];
    if (eventType !== undefined && eventType !== null) {
      messages = messages.concat(AvoAssert.assertString("_w-bj6EA-b", label_ ? "event_type" + ": " + label_ : "event_type", eventType));
      if ("Item Quantity Updated" !== eventType &&
            "Item Removed" !== eventType &&
            "Mark as Unpurchased" !== eventType &&
            "Mark as Purchased" !== eventType &&
            "Cancelled Reservation" !== eventType &&
            "Changed Store" !== eventType &&
            "Added to Store Reservation" !== eventType &&
            "Quick Add" !== eventType && "Click" !== eventType &&
            "Product Click" !== eventType &&
            "Added to Store" !== eventType && "None" !== eventType &&
            "Shipping Address" !== eventType &&
            "Shipping Type" !== eventType && "Payment Info" !== eventType &&
            "Item Removed - Out of Stock" !== eventType &&
            "Check" !== eventType && "Uncheck" !== eventType &&
            "Add to Babylist" !== eventType && "Page Viewed" !== eventType &&
            "Search Results Viewed" !== eventType &&
            "Submitted" !== eventType && "Dismissed" !== eventType &&
            "Copy" !== eventType && "Successful" !== eventType &&
            "Error - Unrecognized Email" !== eventType &&
            "Error - Incorrect Password" !== eventType &&
            "Error - SSO Token Failed" !== eventType &&
            "Error - Existing Email" !== eventType &&
            "Email - Invalid Email" !== eventType &&
            "Error - Invalid Credentials" !== eventType &&
            "Modal" !== eventType && "Pop-Up" !== eventType &&
            "Shop" !== eventType && "Guides" !== eventType &&
            "Registries" !== eventType && "Unified" !== eventType &&
            "Registry" !== eventType && "Unknown" !== eventType &&
            "FSA/HSA" !== eventType && "Shown With Next Add" !== eventType &&
            "Shown Without Next Add" !== eventType &&
            "Quick View" !== eventType && "Swiped" !== eventType &&
            "Bulk Edit" !== eventType) {
        var message = (label_ ? "event_type" + ": " + label_ : "event_type") + " should match one of the following values [ Item Quantity Updated | Item Removed | Mark as Unpurchased | Mark as Purchased | Cancelled Reservation | Changed Store | Added to Store Reservation | Quick Add | Click | Product Click | Added to Store | None | Shipping Address | Shipping Type | Payment Info | Item Removed - Out of Stock | Check | Uncheck | Add to Babylist | Page Viewed | Search Results Viewed | Submitted | Dismissed | Copy | Successful | Error - Unrecognized Email | Error - Incorrect Password | Error - SSO Token Failed | Error - Existing Email | Email - Invalid Email | Error - Invalid Credentials | Modal | Pop-Up | Shop | Guides | Registries | Unified | Registry | Unknown | FSA/HSA | Shown With Next Add | Shown Without Next Add | Quick View | Swiped | Bulk Edit ] but you provided the value " + eventType
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "_w-bj6EA-b", message: message}]);
      }
    }
    return messages;
  }

  function assertEventType(eventType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("_w-bj6EA-b", label_ ? "event_type" + ": " + label_ : "event_type", eventType));
    if ("Item Quantity Updated" !== eventType &&
          "Item Removed" !== eventType &&
          "Mark as Unpurchased" !== eventType &&
          "Mark as Purchased" !== eventType &&
          "Cancelled Reservation" !== eventType &&
          "Changed Store" !== eventType &&
          "Added to Store Reservation" !== eventType &&
          "Quick Add" !== eventType && "Click" !== eventType &&
          "Product Click" !== eventType && "Added to Store" !== eventType &&
          "None" !== eventType && "Shipping Address" !== eventType &&
          "Shipping Type" !== eventType && "Payment Info" !== eventType &&
          "Item Removed - Out of Stock" !== eventType &&
          "Check" !== eventType && "Uncheck" !== eventType &&
          "Add to Babylist" !== eventType && "Page Viewed" !== eventType &&
          "Search Results Viewed" !== eventType &&
          "Submitted" !== eventType && "Dismissed" !== eventType &&
          "Copy" !== eventType && "Successful" !== eventType &&
          "Error - Unrecognized Email" !== eventType &&
          "Error - Incorrect Password" !== eventType &&
          "Error - SSO Token Failed" !== eventType &&
          "Error - Existing Email" !== eventType &&
          "Email - Invalid Email" !== eventType &&
          "Error - Invalid Credentials" !== eventType &&
          "Modal" !== eventType && "Pop-Up" !== eventType &&
          "Shop" !== eventType && "Guides" !== eventType &&
          "Registries" !== eventType && "Unified" !== eventType &&
          "Registry" !== eventType && "Unknown" !== eventType &&
          "FSA/HSA" !== eventType && "Shown With Next Add" !== eventType &&
          "Shown Without Next Add" !== eventType &&
          "Quick View" !== eventType && "Swiped" !== eventType &&
          "Bulk Edit" !== eventType) {
      var message = (label_ ? "event_type" + ": " + label_ : "event_type") + " should match one of the following values [ Item Quantity Updated | Item Removed | Mark as Unpurchased | Mark as Purchased | Cancelled Reservation | Changed Store | Added to Store Reservation | Quick Add | Click | Product Click | Added to Store | None | Shipping Address | Shipping Type | Payment Info | Item Removed - Out of Stock | Check | Uncheck | Add to Babylist | Page Viewed | Search Results Viewed | Submitted | Dismissed | Copy | Successful | Error - Unrecognized Email | Error - Incorrect Password | Error - SSO Token Failed | Error - Existing Email | Email - Invalid Email | Error - Invalid Credentials | Modal | Pop-Up | Shop | Guides | Registries | Unified | Registry | Unknown | FSA/HSA | Shown With Next Add | Shown Without Next Add | Quick View | Swiped | Bulk Edit ] but you provided the value " + eventType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "_w-bj6EA-b", message: message}]);
    }
    return messages;
  }

  function assertUserId_(userId_, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("avo-enriched-type-user-id", label_ ? "User Id" + ": " + label_ : "User Id", userId_));
    return messages;
  }

  function assertOptionalIsFsaHsaOrder(isFsaHsaOrder, label_) {
    var messages = [];
    if (isFsaHsaOrder !== undefined && isFsaHsaOrder !== null) {
      messages = messages.concat(AvoAssert.assertBool("bpGjPMI2NX", label_ ? "is_fsa_hsa_order" + ": " + label_ : "is_fsa_hsa_order", isFsaHsaOrder));
    }
    return messages;
  }

  function assertOptionalUtmSource(utmSource, label_) {
    var messages = [];
    if (utmSource !== undefined && utmSource !== null) {
      messages = messages.concat(AvoAssert.assertString("c8vjcYacK2", label_ ? "utm_source" + ": " + label_ : "utm_source", utmSource));
    }
    return messages;
  }

  function assertExternalStoreName(externalStoreName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("czcBAIKvtf", label_ ? "external_store_name" + ": " + label_ : "external_store_name", externalStoreName));
    return messages;
  }

  function assertStoreAdded(storeAdded, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("d1zSLf5RRz", label_ ? "store_added" + ": " + label_ : "store_added", storeAdded));
    if ("Amazon" !== storeAdded && "Babylist" !== storeAdded) {
      var message = (label_ ? "store_added" + ": " + label_ : "store_added") + " should match one of the following values [ Amazon | Babylist ] but you provided the value " + storeAdded
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "d1zSLf5RRz", message: message}]);
    }
    return messages;
  }

  function assertOptionalReqUtmContent(reqUtmContent, label_) {
    var messages = [];
    if (reqUtmContent !== undefined && reqUtmContent !== null) {
      messages = messages.concat(AvoAssert.assertString("e2tQHS2Tb5", label_ ? "req_utm_content" + ": " + label_ : "req_utm_content", reqUtmContent));
    }
    return messages;
  }

  function assertOptionalSearchPreviewIds(searchPreviewIds, label_) {
    var messages = [];
    if (searchPreviewIds !== undefined && searchPreviewIds !== null) {
      messages = messages.concat(AvoAssert.assertString("eVYsq2XJU", label_ ? "search_preview_ids" + ": " + label_ : "search_preview_ids", searchPreviewIds));
    }
    return messages;
  }

  function assertCoregistrationPartnerName(coregistrationPartnerName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("fWTvqwtoDs", label_ ? "coregistration_partner_name" + ": " + label_ : "coregistration_partner_name", coregistrationPartnerName));
    return messages;
  }

  function assertOptionalReqPlatform(reqPlatform, label_) {
    var messages = [];
    if (reqPlatform !== undefined && reqPlatform !== null) {
      messages = messages.concat(AvoAssert.assertString("fjC5ZBjHZ5", label_ ? "req_platform" + ": " + label_ : "req_platform", reqPlatform));
    }
    return messages;
  }

  function assertInsuredState(insuredState, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("gEYP33E4tC", label_ ? "insured_state" + ": " + label_ : "insured_state", insuredState));
    return messages;
  }

  function assertShipmentId(shipmentId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("gMuGQxPhZs", label_ ? "shipment_id" + ": " + label_ : "shipment_id", shipmentId));
    return messages;
  }

  function assertOptionalFocusedSection(focusedSection, label_) {
    var messages = [];
    if (focusedSection !== undefined && focusedSection !== null) {
      messages = messages.concat(AvoAssert.assertString("gOgPFKH8H1", label_ ? "focused_section" + ": " + label_ : "focused_section", focusedSection));
    }
    return messages;
  }

  function assertOptionalLandingPage(landingPage, label_) {
    var messages = [];
    if (landingPage !== undefined && landingPage !== null) {
      messages = messages.concat(AvoAssert.assertString("gelTZbhh9", label_ ? "landing_page" + ": " + label_ : "landing_page", landingPage));
    }
    return messages;
  }

  function assertOptionalIsRegistryOwner(isRegistryOwner, label_) {
    var messages = [];
    if (isRegistryOwner !== undefined && isRegistryOwner !== null) {
      messages = messages.concat(AvoAssert.assertBool("gjtXFSi923", label_ ? "is_registry_owner" + ": " + label_ : "is_registry_owner", isRegistryOwner));
    }
    return messages;
  }

  function assertOptionalUtmGroup(utmGroup, label_) {
    var messages = [];
    if (utmGroup !== undefined && utmGroup !== null) {
      messages = messages.concat(AvoAssert.assertString("gyskR7Tl0j", label_ ? "utm_group" + ": " + label_ : "utm_group", utmGroup));
    }
    return messages;
  }

  function assertOptionalPdpType(pdpType, label_) {
    var messages = [];
    if (pdpType !== undefined && pdpType !== null) {
      messages = messages.concat(AvoAssert.assertString("h12bnVZfao", label_ ? "pdp_type" + ": " + label_ : "pdp_type", pdpType));
      if ("product" !== pdpType && "gift_giver" !== pdpType &&
            "favor" !== pdpType && "cash_fund" !== pdpType &&
            "gift_card" !== pdpType && "universal" !== pdpType) {
        var message = (label_ ? "pdp_type" + ": " + label_ : "pdp_type") + " should match one of the following values [ product | gift_giver | favor | cash_fund | gift_card | universal ] but you provided the value " + pdpType
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "h12bnVZfao", message: message}]);
      }
    }
    return messages;
  }

  function assertOptionalReqUtmSource(reqUtmSource, label_) {
    var messages = [];
    if (reqUtmSource !== undefined && reqUtmSource !== null) {
      messages = messages.concat(AvoAssert.assertString("hH2iVCa9I1", label_ ? "req_utm_source" + ": " + label_ : "req_utm_source", reqUtmSource));
    }
    return messages;
  }

  function assertProductPrice(productPrice, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertFloat("hHOUpzCIx2", label_ ? "product_price" + ": " + label_ : "product_price", productPrice));
    return messages;
  }

  function assertOptionalUtmCampaign(utmCampaign, label_) {
    var messages = [];
    if (utmCampaign !== undefined && utmCampaign !== null) {
      messages = messages.concat(AvoAssert.assertString("hSwRq6Rl5g", label_ ? "utm_campaign" + ": " + label_ : "utm_campaign", utmCampaign));
    }
    return messages;
  }

  function assertConsolidationValue(consolidationValue, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("hgLh5g6P_", label_ ? "consolidation_value" + ": " + label_ : "consolidation_value", consolidationValue));
    if ("rolling" !== consolidationValue && "none" !== consolidationValue &&
          "modal not viewed" !== consolidationValue) {
      var message = (label_ ? "consolidation_value" + ": " + label_ : "consolidation_value") + " should match one of the following values [ rolling | none | modal not viewed ] but you provided the value " + consolidationValue
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "hgLh5g6P_", message: message}]);
    }
    return messages;
  }

  function assertProductType(productType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("hh5IW9vG8X", label_ ? "product_type" + ": " + label_ : "product_type", productType));
    if ("Product" !== productType && "Gift Card" !== productType) {
      var message = (label_ ? "product_type" + ": " + label_ : "product_type") + " should match one of the following values [ Product | Gift Card ] but you provided the value " + productType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "hh5IW9vG8X", message: message}]);
    }
    return messages;
  }

  function assertOptionalWillArriveBeforeShower(willArriveBeforeShower,
    label_) {
    var messages = [];
    if (willArriveBeforeShower !== undefined && willArriveBeforeShower !== null) {
      messages = messages.concat(AvoAssert.assertBool("hzjHBfm4F", label_ ? "will_arrive_before_shower" + ": " + label_ : "will_arrive_before_shower", willArriveBeforeShower));
    }
    return messages;
  }

  function assertStatus(status, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("iC2fNqDR8", label_ ? "status" + ": " + label_ : "status", status));
    if ("success" !== status && "fail" !== status &&
          "validation error" !== status) {
      var message = (label_ ? "status" + ": " + label_ : "status") + " should match one of the following values [ success | fail | validation error ] but you provided the value " + status
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "iC2fNqDR8", message: message}]);
    }
    return messages;
  }

  function assertBrand(brand, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("iU_xUwLyJf", label_ ? "brand" + ": " + label_ : "brand", brand));
    return messages;
  }

  function assertOptionalIsFsaHsaEligible(isFsaHsaEligible, label_) {
    var messages = [];
    if (isFsaHsaEligible !== undefined && isFsaHsaEligible !== null) {
      messages = messages.concat(AvoAssert.assertBool("kN_aicHWKA", label_ ? "is_fsa_hsa_eligible" + ": " + label_ : "is_fsa_hsa_eligible", isFsaHsaEligible));
    }
    return messages;
  }

  function assertRegItemPrice(regItemPrice, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertFloat("keBt2ma-zt", label_ ? "reg_item_price" + ": " + label_ : "reg_item_price", regItemPrice));
    return messages;
  }

  function assertCoregistrationIsExistingBabylistUser(
    coregistrationIsExistingBabylistUser, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("klPDZ6kUlA", label_ ? "coregistration_is_existing_babylist_user" + ": " + label_ : "coregistration_is_existing_babylist_user", coregistrationIsExistingBabylistUser));
    return messages;
  }

  function assertUserLoggedIn(userLoggedIn, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("kwcveeFcRU", label_ ? "user_logged_in" + ": " + label_ : "user_logged_in", userLoggedIn));
    return messages;
  }

  function assertIsLeafCategory(isLeafCategory, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("l-ZBlkTiq4", label_ ? "is_leaf_category" + ": " + label_ : "is_leaf_category", isLeafCategory));
    return messages;
  }

  function assertOptionalLastExternalReferrer(lastExternalReferrer, label_) {
    var messages = [];
    if (lastExternalReferrer !== undefined && lastExternalReferrer !== null) {
      messages = messages.concat(AvoAssert.assertString("lbx7p9h9EN", label_ ? "last_external_referrer" + ": " + label_ : "last_external_referrer", lastExternalReferrer));
    }
    return messages;
  }

  function assertManualReviewRequired(manualReviewRequired, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("lnMhThe37", label_ ? "manual_review_required" + ": " + label_ : "manual_review_required", manualReviewRequired));
    return messages;
  }

  function assertIsOpen(isOpen, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("mSLIa7zt_t", label_ ? "is_open" + ": " + label_ : "is_open", isOpen));
    return messages;
  }

  function assertPostSlug(postSlug, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("nFzKmDrJrr", label_ ? "post_slug" + ": " + label_ : "post_slug", postSlug));
    return messages;
  }

  function assertOptionalPostSlug(postSlug, label_) {
    var messages = [];
    if (postSlug !== undefined && postSlug !== null) {
      messages = messages.concat(AvoAssert.assertString("nFzKmDrJrr", label_ ? "post_slug" + ": " + label_ : "post_slug", postSlug));
    }
    return messages;
  }

  function assertExecutedSearch(executedSearch, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("o1QaPjYEr", label_ ? "executed_search" + ": " + label_ : "executed_search", executedSearch));
    return messages;
  }

  function assertOptionalCartStores(cartStores, label_) {
    var messages = [];
    if (cartStores !== undefined && cartStores !== null) {
      messages = messages.concat(AvoAssert.assertList("pTXZlXuqdY", "cart_stores", cartStores));
      cartStores.forEach(function (value, index) {
        messages = messages.concat(AvoAssert.assertString("pTXZlXuqdY", "item at index " + index + " in cart_stores", value));
        if ("Amazon" !== value && "Babylist Store" !== value) {
          var message = (label_ ? "item at index " + index + " in cart_stores" + ": " + label_ : "item at index " + index + " in cart_stores") + " should match one of the following values [ Amazon | Babylist Store ] but you provided the value " + value
          messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "pTXZlXuqdY", message: message}]);
        }
      });
    }
    return messages;
  }

  function assertStore(store, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("pXW3Y4FTB3", label_ ? "store" + ": " + label_ : "store", store));
    return messages;
  }

  function assertUserEmail(userEmail, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("pZYqGD_5jw", label_ ? "user_email" + ": " + label_ : "user_email", userEmail));
    return messages;
  }

  function assertChecklistCategoryName(checklistCategoryName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("pb82BUpUN-", label_ ? "checklist_category_name" + ": " + label_ : "checklist_category_name", checklistCategoryName));
    return messages;
  }

  function assertSubscribeToMarketingEmail(subscribeToMarketingEmail, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("q4NPS9mkk", label_ ? "subscribe_to_marketing_email" + ": " + label_ : "subscribe_to_marketing_email", subscribeToMarketingEmail));
    return messages;
  }

  function assertOptionalSearchKeyword(searchKeyword, label_) {
    var messages = [];
    if (searchKeyword !== undefined && searchKeyword !== null) {
      messages = messages.concat(AvoAssert.assertString("q52hxkLks3", label_ ? "search_keyword" + ": " + label_ : "search_keyword", searchKeyword));
    }
    return messages;
  }

  function assertPrimaryRegistryId(primaryRegistryId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("rJz3f4zZDl", label_ ? "primary_registry_id" + ": " + label_ : "primary_registry_id", primaryRegistryId));
    return messages;
  }

  function assertOptionalSortOrder(sortOrder, label_) {
    var messages = [];
    if (sortOrder !== undefined && sortOrder !== null) {
      messages = messages.concat(AvoAssert.assertString("rTzwntEiBQ", label_ ? "sort_order" + ": " + label_ : "sort_order", sortOrder));
      if ("ASC" !== sortOrder && "DESC" !== sortOrder) {
        var message = (label_ ? "sort_order" + ": " + label_ : "sort_order") + " should match one of the following values [ ASC | DESC ] but you provided the value " + sortOrder
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "rTzwntEiBQ", message: message}]);
      }
    }
    return messages;
  }

  function assertExternalRegistryMergeType(externalRegistryMergeType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("rUGWKcAvL", label_ ? "external_registry_merge_type" + ": " + label_ : "external_registry_merge_type", externalRegistryMergeType));
    if ("link" !== externalRegistryMergeType &&
          "transfer" !== externalRegistryMergeType) {
      var message = (label_ ? "external_registry_merge_type" + ": " + label_ : "external_registry_merge_type") + " should match one of the following values [ link | transfer ] but you provided the value " + externalRegistryMergeType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "rUGWKcAvL", message: message}]);
    }
    return messages;
  }

  function assertOptionalFacebookPixelId(facebookPixelId, label_) {
    var messages = [];
    if (facebookPixelId !== undefined && facebookPixelId !== null) {
      messages = messages.concat(AvoAssert.assertString("sEHY-H0aij", label_ ? "facebook_pixel_id" + ": " + label_ : "facebook_pixel_id", facebookPixelId));
    }
    return messages;
  }

  function assertOptionalShowerDate(showerDate, label_) {
    var messages = [];
    if (showerDate !== undefined && showerDate !== null) {
      messages = messages.concat(AvoAssert.assertString("sY02y0eaV", label_ ? "shower_date" + ": " + label_ : "shower_date", showerDate));
    }
    return messages;
  }

  function assertOptionalReqUtmMedium(reqUtmMedium, label_) {
    var messages = [];
    if (reqUtmMedium !== undefined && reqUtmMedium !== null) {
      messages = messages.concat(AvoAssert.assertString("sjQiDoAwhk", label_ ? "req_utm_medium" + ": " + label_ : "req_utm_medium", reqUtmMedium));
    }
    return messages;
  }

  function assertOptionalContentName(contentName, label_) {
    var messages = [];
    if (contentName !== undefined && contentName !== null) {
      messages = messages.concat(AvoAssert.assertString("spXyE0RLQ", label_ ? "content_name" + ": " + label_ : "content_name", contentName));
    }
    return messages;
  }

  function assertOptionalShopifyOrderId(shopifyOrderId, label_) {
    var messages = [];
    if (shopifyOrderId !== undefined && shopifyOrderId !== null) {
      messages = messages.concat(AvoAssert.assertString("syfZNcLEPY", label_ ? "shopify_order_id" + ": " + label_ : "shopify_order_id", shopifyOrderId));
    }
    return messages;
  }

  function assertOptionalExperimentName(experimentName, label_) {
    var messages = [];
    if (experimentName !== undefined && experimentName !== null) {
      messages = messages.concat(AvoAssert.assertString("tN6DzKw_AQ", label_ ? "experiment_name" + ": " + label_ : "experiment_name", experimentName));
    }
    return messages;
  }

  function assertExperimentName(experimentName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("tN6DzKw_AQ", label_ ? "experiment_name" + ": " + label_ : "experiment_name", experimentName));
    return messages;
  }

  function assertPostRevision(postRevision, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("tVeza_1Hvq", label_ ? "post_revision" + ": " + label_ : "post_revision", postRevision));
    return messages;
  }

  function assertOptionalPostRevision(postRevision, label_) {
    var messages = [];
    if (postRevision !== undefined && postRevision !== null) {
      messages = messages.concat(AvoAssert.assertInt("tVeza_1Hvq", label_ ? "post_revision" + ": " + label_ : "post_revision", postRevision));
    }
    return messages;
  }

  function assertCollaboratorRole(collaboratorRole, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("uW2-VB6Xl3", label_ ? "collaborator_role" + ": " + label_ : "collaborator_role", collaboratorRole));
    if ("Partner" !== collaboratorRole &&
          "Collaborator" !== collaboratorRole &&
          "Registrant" !== collaboratorRole) {
      var message = (label_ ? "collaborator_role" + ": " + label_ : "collaborator_role") + " should match one of the following values [ Partner | Collaborator | Registrant ] but you provided the value " + collaboratorRole
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "uW2-VB6Xl3", message: message}]);
    }
    return messages;
  }

  function assertFeatureName(featureName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("vWgDaXFfgR", label_ ? "feature_name" + ": " + label_ : "feature_name", featureName));
    return messages;
  }

  function assertOptionalSplitTests(splitTests, label_) {
    var messages = [];
    if (splitTests !== undefined && splitTests !== null) {
      messages = messages.concat(AvoAssert.assertList("vkFxnsX-JA", "split_tests", splitTests));
      splitTests.forEach(function (value, index) {
        messages = messages.concat(AvoAssert.assertObject("vkFxnsX-JA", "item at index " + index + " in split_tests", value));
      });
    }
    return messages;
  }

  function assertLibrary(library, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("vn2eM76CG-", label_ ? "library" + ": " + label_ : "library", library));
    if ("android" !== library && "ios" !== library && "web" !== library &&
          "ruby" !== library) {
      var message = (label_ ? "library" + ": " + label_ : "library") + " should match one of the following values [ android | ios | web | ruby ] but you provided the value " + library
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "vn2eM76CG-", message: message}]);
    }
    return messages;
  }

  function assertOptionalIsSponsoredProduct(isSponsoredProduct, label_) {
    var messages = [];
    if (isSponsoredProduct !== undefined && isSponsoredProduct !== null) {
      messages = messages.concat(AvoAssert.assertBool("vtBpfRY_B", label_ ? "is_sponsored_product" + ": " + label_ : "is_sponsored_product", isSponsoredProduct));
    }
    return messages;
  }

  function assertOptionalRegItemIds(regItemIds, label_) {
    var messages = [];
    if (regItemIds !== undefined && regItemIds !== null) {
      messages = messages.concat(AvoAssert.assertList("w4Er1Tq_Sl", "reg_item_ids", regItemIds));
      regItemIds.forEach(function (value, index) {
      });
    }
    return messages;
  }

  function assertUserCreatedAt(userCreatedAt, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("wIEnmk0K8", label_ ? "user_created_at" + ": " + label_ : "user_created_at", userCreatedAt));
    return messages;
  }

  function assertOptionalReservationCancellationReason(
    reservationCancellationReason, label_) {
    var messages = [];
    if (reservationCancellationReason !== undefined && reservationCancellationReason !== null) {
      messages = messages.concat(AvoAssert.assertString("wJOhkP_Ev4", label_ ? "reservation_cancellation_reason" + ": " + label_ : "reservation_cancellation_reason", reservationCancellationReason));
      if ("later" !== reservationCancellationReason &&
            "looking" !== reservationCancellationReason &&
            "changed_mind" !== reservationCancellationReason &&
            "not_available" !== reservationCancellationReason &&
            "none" !== reservationCancellationReason) {
        var message = (label_ ? "reservation_cancellation_reason" + ": " + label_ : "reservation_cancellation_reason") + " should match one of the following values [ later | looking | changed_mind | not_available | none ] but you provided the value " + reservationCancellationReason
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "wJOhkP_Ev4", message: message}]);
      }
    }
    return messages;
  }

  function assertOptionalEmailExperimentGroup(emailExperimentGroup, label_) {
    var messages = [];
    if (emailExperimentGroup !== undefined && emailExperimentGroup !== null) {
      messages = messages.concat(AvoAssert.assertString("wf5l_8C4a", label_ ? "email_experiment_group" + ": " + label_ : "email_experiment_group", emailExperimentGroup));
    }
    return messages;
  }

  function assertOptionalUtmContent(utmContent, label_) {
    var messages = [];
    if (utmContent !== undefined && utmContent !== null) {
      messages = messages.concat(AvoAssert.assertString("wgx9ZN1Pi1", label_ ? "utm_content" + ": " + label_ : "utm_content", utmContent));
    }
    return messages;
  }

  function assertOptionalReqUtmCampaign(reqUtmCampaign, label_) {
    var messages = [];
    if (reqUtmCampaign !== undefined && reqUtmCampaign !== null) {
      messages = messages.concat(AvoAssert.assertString("x4OTktHTFo", label_ ? "req_utm_campaign" + ": " + label_ : "req_utm_campaign", reqUtmCampaign));
    }
    return messages;
  }

  function assertOptionalReqReferrer(reqReferrer, label_) {
    var messages = [];
    if (reqReferrer !== undefined && reqReferrer !== null) {
      messages = messages.concat(AvoAssert.assertString("xIHFyif3OA", label_ ? "req_referrer" + ": " + label_ : "req_referrer", reqReferrer));
    }
    return messages;
  }

  function assertOptionalStoreName(storeName, label_) {
    var messages = [];
    if (storeName !== undefined && storeName !== null) {
      messages = messages.concat(AvoAssert.assertString("xO6nLm6j6K", label_ ? "store_name" + ": " + label_ : "store_name", storeName));
      if ("Babylist Health" !== storeName && "Babylist" !== storeName &&
            "Expectful" !== storeName) {
        var message = (label_ ? "store_name" + ": " + label_ : "store_name") + " should match one of the following values [ Babylist Health | Babylist | Expectful ] but you provided the value " + storeName
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "xO6nLm6j6K", message: message}]);
      }
    }
    return messages;
  }

  function assertOptionalSuggestedCategoryId(suggestedCategoryId, label_) {
    var messages = [];
    if (suggestedCategoryId !== undefined && suggestedCategoryId !== null) {
      messages = messages.concat(AvoAssert.assertString("xUsHwGgkXG", label_ ? "suggested_category_id" + ": " + label_ : "suggested_category_id", suggestedCategoryId));
    }
    return messages;
  }

  function assertOptionalUtmMedium(utmMedium, label_) {
    var messages = [];
    if (utmMedium !== undefined && utmMedium !== null) {
      messages = messages.concat(AvoAssert.assertString("xaXhMYt66p", label_ ? "utm_medium" + ": " + label_ : "utm_medium", utmMedium));
    }
    return messages;
  }

  function assertPostId(postId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("yI66F6Raat", label_ ? "post_id" + ": " + label_ : "post_id", postId));
    return messages;
  }

  function assertOptionalPostId(postId, label_) {
    var messages = [];
    if (postId !== undefined && postId !== null) {
      messages = messages.concat(AvoAssert.assertString("yI66F6Raat", label_ ? "post_id" + ": " + label_ : "post_id", postId));
    }
    return messages;
  }

  function assertDiaperCalculatorPromptText(diaperCalculatorPromptText,
    label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("yOclZpdxTw", label_ ? "diaper_calculator_prompt_text" + ": " + label_ : "diaper_calculator_prompt_text", diaperCalculatorPromptText));
    return messages;
  }

  function assertInteractionTarget(interactionTarget, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("yZMbs_5CI", label_ ? "interaction_target" + ": " + label_ : "interaction_target", interactionTarget));
    if ("pdp_breadcrumb_link" !== interactionTarget &&
          "pdp_breadcrumb_expand" !== interactionTarget &&
          "pdp_image_thumbnail" !== interactionTarget &&
          "pdp_reviews_quick_link" !== interactionTarget &&
          "pdp_qna_quick_link" !== interactionTarget &&
          "pdp_back_to_top" !== interactionTarget &&
          "pdp_expand_description" !== interactionTarget &&
          "pdp_collapse_description" !== interactionTarget &&
          "pdp_expand_details" !== interactionTarget &&
          "pdp_collapse_details" !== interactionTarget) {
      var message = (label_ ? "interaction_target" + ": " + label_ : "interaction_target") + " should match one of the following values [ pdp_breadcrumb_link | pdp_breadcrumb_expand | pdp_image_thumbnail | pdp_reviews_quick_link | pdp_qna_quick_link | pdp_back_to_top | pdp_expand_description | pdp_collapse_description | pdp_expand_details | pdp_collapse_details ] but you provided the value " + interactionTarget
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "yZMbs_5CI", message: message}]);
    }
    return messages;
  }

  function assertOptionalAnswer(answer, label_) {
    var messages = [];
    if (answer !== undefined && answer !== null) {
      messages = messages.concat(AvoAssert.assertString("yh6-rYtio8", label_ ? "answer" + ": " + label_ : "answer", answer));
    }
    return messages;
  }

  function assertStoreCategorySlug(storeCategorySlug, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("yyDNRm_pnV", label_ ? "store_category_slug" + ": " + label_ : "store_category_slug", storeCategorySlug));
    return messages;
  }

  function assertOptionalStoreCategorySlug(storeCategorySlug, label_) {
    var messages = [];
    if (storeCategorySlug !== undefined && storeCategorySlug !== null) {
      messages = messages.concat(AvoAssert.assertString("yyDNRm_pnV", label_ ? "store_category_slug" + ": " + label_ : "store_category_slug", storeCategorySlug));
    }
    return messages;
  }

  function assertError(error, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("z0zvXpwNs7", label_ ? "error" + ": " + label_ : "error", error));
    return messages;
  }

  function assertDiaperCalculatorResultSlug(diaperCalculatorResultSlug,
    label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("z3PyHKYGVu", label_ ? "diaper_calculator_result_slug" + ": " + label_ : "diaper_calculator_result_slug", diaperCalculatorResultSlug));
    return messages;
  }

  function assertOptionalExternalRegistryCanonicalUrl(
    externalRegistryCanonicalUrl, label_) {
    var messages = [];
    if (externalRegistryCanonicalUrl !== undefined && externalRegistryCanonicalUrl !== null) {
      messages = messages.concat(AvoAssert.assertString("z_s_3ch01", label_ ? "external_registry_canonical_url" + ": " + label_ : "external_registry_canonical_url", externalRegistryCanonicalUrl));
    }
    return messages;
  }

  function assertDiaperCalculatorOptionText(diaperCalculatorOptionText,
    label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("zbblqMkef3", label_ ? "diaper_calculator_option_text" + ": " + label_ : "diaper_calculator_option_text", diaperCalculatorOptionText));
    return messages;
  }

  function assertEventLocation(eventLocation, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("zseEDZJCEW", label_ ? "event_location" + ": " + label_ : "event_location", eventLocation));
    if ("PDP" !== eventLocation && "Feed" !== eventLocation &&
          "Guide" !== eventLocation && "Registry" !== eventLocation &&
          "Cart" !== eventLocation && "Shopify" !== eventLocation &&
          "Home Page" !== eventLocation && "Store" !== eventLocation &&
          "None" !== eventLocation &&
          "Next Add Recommender" !== eventLocation &&
          "Store - Search" !== eventLocation &&
          "Store - Category" !== eventLocation &&
          "Store - Product Collections" !== eventLocation &&
          "Add to Babylist Button" !== eventLocation &&
          "Registry Discount Screen" !== eventLocation &&
          "Reg Item Edit Screen" !== eventLocation &&
          "Shop Registry" !== eventLocation &&
          "Store - Product List" !== eventLocation &&
          "Cart Details Page" !== eventLocation &&
          "Add Item For Store" !== eventLocation &&
          "Core Item Wizard" !== eventLocation &&
          "Buying Options Modal" !== eventLocation &&
          "Add Item" !== eventLocation &&
          "Add Item - Share Extension" !== eventLocation &&
          "Onboarding" !== eventLocation &&
          "Diaper Calculator" !== eventLocation &&
          "Gift Tracker" !== eventLocation &&
          "Review Listings Page" !== eventLocation &&
          "Q&A Page" !== eventLocation &&
          "Review Customer Photos" !== eventLocation &&
          "Order History" !== eventLocation &&
          "Clothing Calculator" !== eventLocation &&
          "Organize Registry" !== eventLocation &&
          "Banner Button" !== eventLocation &&
          "Sign-up Widget" !== eventLocation &&
          "Product Carousel" !== eventLocation &&
          "Checklist Quiz - Gender" !== eventLocation &&
          "Checklist Quiz - Feeling" !== eventLocation &&
          "Checklist Quiz - Budget" !== eventLocation &&
          "Checklist Quiz - Breastfeeding" !== eventLocation &&
          "Checklist Quiz - Pumping" !== eventLocation &&
          "Checklist Quiz - Sleep Area" !== eventLocation &&
          "Checklist Quiz - Diapers" !== eventLocation &&
          "Checklist Quiz - Laundry Plans" !== eventLocation &&
          "Checklist Quiz - Nursery" !== eventLocation &&
          "Checklist Quiz - Gender Color" !== eventLocation &&
          "Checklist Quiz - Laundry Frequency" !== eventLocation &&
          "Checklist Quiz - Celebrity" !== eventLocation &&
          "Checklist Quiz - Season" !== eventLocation &&
          "Checklist Quiz - Planning" !== eventLocation &&
          "Checklist Quiz - Food" !== eventLocation &&
          "Checklist Quiz - Cars" !== eventLocation &&
          "Checklist Quiz - Know Us" !== eventLocation &&
          "Checklist Quiz - Coregistration" !== eventLocation &&
          "Checklist Quiz - Email Collection" !== eventLocation &&
          "Onboarding - Road Ahead" !== eventLocation &&
          "Onboarding - Arrival Date" !== eventLocation &&
          "Onboarding - Milestone" !== eventLocation &&
          "Onboarding - Adoption Affirmation" !== eventLocation &&
          "Onboarding - Still Trying Affirmation" !== eventLocation &&
          "Onboarding - Adoption Age" !== eventLocation &&
          "Onboarding - First Time Parent" !== eventLocation &&
          "Onboarding - Sentiment" !== eventLocation &&
          "Onboarding - Partner" !== eventLocation &&
          "Onboarding - You Got This" !== eventLocation &&
          "Onboarding - Partner Name" !== eventLocation &&
          "Onboarding - Invite Partner" !== eventLocation &&
          "Onboarding - Partner Email Collection" !== eventLocation &&
          "Onboarding - Partner Email Invite Sent" !== eventLocation &&
          "Onboarding - Value Proposition" !== eventLocation &&
          "Onboarding - Babylist Button" !== eventLocation &&
          "Checklist Quiz - Expecting Status" !== eventLocation &&
          "Checklist Quiz - Have Registry" !== eventLocation &&
          "Store - Brand" !== eventLocation &&
          "Add Items" !== eventLocation &&
          "Cart - Recommendations Carousel" !== eventLocation &&
          "Cart - Recommendations Quick View Modal" !== eventLocation &&
          "Add Item For Brand" !== eventLocation &&
          "Gift Giver - Email Collection" !== eventLocation &&
          "Guides" !== eventLocation && "PLP" !== eventLocation &&
          "Onboarding - App Download" !== eventLocation &&
          "Toolbar - App Download" !== eventLocation &&
          "Tile - App Download" !== eventLocation &&
          "Deep Link" !== eventLocation && "Checklist" !== eventLocation &&
          "Checklist Category" !== eventLocation &&
          "Settings" !== eventLocation &&
          "Registry Preview Page" !== eventLocation &&
          "Registry Starter Page" !== eventLocation &&
          "Registry Create Form" !== eventLocation &&
          "Onboarding - List Type" !== eventLocation &&
          "Tab Bar" !== eventLocation &&
          "List - Empty List" !== eventLocation &&
          "Add Items - Search" !== eventLocation &&
          "Add Items - Tile" !== eventLocation &&
          "Search Text" !== eventLocation &&
          "Search Photo" !== eventLocation &&
          "Registry Empty State" !== eventLocation &&
          "Insurance Panel - Top Insurances" !== eventLocation &&
          "Insurance Panel - All Insurances" !== eventLocation &&
          "Insurance Panel - Search Results" !== eventLocation &&
          "Mobile Web Top Utility Bar" !== eventLocation &&
          "Mobile Web Bottom Nav" !== eventLocation &&
          "Mobile Web Hamburger" !== eventLocation &&
          "Web Top Nav" !== eventLocation &&
          "Store - Carousel" !== eventLocation &&
          "Account Creation Form" !== eventLocation &&
          "Settings - Shipping Address" !== eventLocation &&
          "Settings - Shipping Consolidation" !== eventLocation &&
          "Find My Registry" !== eventLocation &&
          "Store - Search Suggestions" !== eventLocation &&
          "Menu" !== eventLocation &&
          "PDP - Add To Babylist" !== eventLocation &&
          "PDP - Add To Cart" !== eventLocation &&
          "Onboarding - Email Collection" !== eventLocation &&
          "All Lists" !== eventLocation &&
          "Registry - Preferences Row" !== eventLocation &&
          "Registry - Stats Row" !== eventLocation &&
          "Subscription Modal - Desktop Nav" !== eventLocation &&
          "Subscription Modal - Footer" !== eventLocation &&
          "Subscription Modal - Mobile Nav" !== eventLocation &&
          "Subscription Modal - Article Sidebar" !== eventLocation &&
          "Subscription Modal - Article In-Line" !== eventLocation &&
          "Subscription Modal - Journey Stage" !== eventLocation &&
          "Subscription Modal - Due Date" !== eventLocation &&
          "Subscription Modal - Baby Birth Date" !== eventLocation &&
          "List Adoption Modal - Feed" !== eventLocation &&
          "List Adoption Modal - Registry" !== eventLocation &&
          "List Adoption Modal - Store" !== eventLocation &&
          "List Adoption Modal - Guides" !== eventLocation &&
          "Copy Reg Item - Category List" !== eventLocation &&
          "Log In - Forgot Password" !== eventLocation &&
          "Log In - Log In Screen" !== eventLocation &&
          "Log In - Log In Modal" !== eventLocation &&
          "Holiday Landing Page" !== eventLocation &&
          "Log In - Start" !== eventLocation &&
          "Log In - Try Google" !== eventLocation &&
          "Log In - Submit Email Password" !== eventLocation &&
          "Log In - Google No Account" !== eventLocation &&
          "Log In - Verify Email Password" !== eventLocation &&
          "Sign Up - Existing Account" !== eventLocation &&
          "Sign Up - Name" !== eventLocation &&
          "Sign Up - Email Confirmation" !== eventLocation &&
          "Onboarding - Add Walkthrough Intro" !== eventLocation &&
          "Onboarding - Add Walkthrough" !== eventLocation &&
          "Log In - No Account" !== eventLocation &&
          "Sign Up - Start" !== eventLocation &&
          "Sign Up - Name Confirmation" !== eventLocation &&
          "Sign Up - Name And Email Confirmation" !== eventLocation &&
          "External Registry Transfer" !== eventLocation &&
          "Sign Up - Babylist Bookmarklet" !== eventLocation &&
          "Sign Up - Babylist Embedded Partner Button" !== eventLocation &&
          "Sign Up - Babylist Extension" !== eventLocation &&
          "Sign Up - Guides - Add Items" !== eventLocation &&
          "Add Items - Babylist Bookmarklet" !== eventLocation &&
          "Add Items - Babylist Embedded Partner Button" !== eventLocation &&
          "Add Items - Babylist Extension" !== eventLocation &&
          "Log In - Babylist Bookmarklet" !== eventLocation &&
          "Log In - Babylist Embedded Partner Button" !== eventLocation &&
          "Log In - Babylist Extension" !== eventLocation &&
          "Health Replacement Parts Order Form" !== eventLocation &&
          "Product" !== eventLocation &&
          "App Bottom Nav" !== eventLocation &&
          "Push Notification" !== eventLocation &&
          "Message Center Inbox" !== eventLocation &&
          "Shop" !== eventLocation && "Unified Search" !== eventLocation &&
          "Log In - Guides - Add Items" !== eventLocation &&
          "Health Insurance Verifier Tool" !== eventLocation &&
          "Hello Baby Box - Shipping Consolidation" !== eventLocation &&
          "Shop - Flyout Nav" !== eventLocation &&
          "Shop - Left Nav" !== eventLocation &&
          "Shop - Image Nav" !== eventLocation &&
          "Shop - Breadcrumbs" !== eventLocation &&
          "Footer" !== eventLocation &&
          "Mobile Web - Category Drop Down" !== eventLocation &&
          "Hello Baby Box Requirements" !== eventLocation &&
          "Registry - Gift Giver View" !== eventLocation &&
          "Registry - Buying Options Modal" !== eventLocation &&
          "Log In - Deep Link" !== eventLocation &&
          "Push Notification Opt-In Modal" !== eventLocation &&
          "Device - Push Notification Opt-In Modal" !== eventLocation &&
          "Device - Message Center Inbox" !== eventLocation &&
          "Shipments" !== eventLocation &&
          "Shipment Details" !== eventLocation &&
          "Orders" !== eventLocation && "Order Details" !== eventLocation &&
          "Home - Right Rail" !== eventLocation &&
          "Home - Left Rail" !== eventLocation &&
          "Bottom Nav Bar" !== eventLocation &&
          "Store - Product Card Quick View" !== eventLocation &&
          "Store - Product Card" !== eventLocation &&
          "Registry - Buying Option Reg Item Card" !== eventLocation &&
          "Registry - Organize Item Screen" !== eventLocation) {
      var message = (label_ ? "event_location" + ": " + label_ : "event_location") + " should match one of the following values [ PDP | Feed | Guide | Registry | Cart | Shopify | Home Page | Store | None | Next Add Recommender | Store - Search | Store - Category | Store - Product Collections | Add to Babylist Button | Registry Discount Screen | Reg Item Edit Screen | Shop Registry | Store - Product List | Cart Details Page | Add Item For Store | Core Item Wizard | Buying Options Modal | Add Item | Add Item - Share Extension | Onboarding | Diaper Calculator | Gift Tracker | Review Listings Page | Q&A Page | Review Customer Photos | Order History | Clothing Calculator | Organize Registry | Banner Button | Sign-up Widget | Product Carousel | Checklist Quiz - Gender | Checklist Quiz - Feeling | Checklist Quiz - Budget | Checklist Quiz - Breastfeeding | Checklist Quiz - Pumping | Checklist Quiz - Sleep Area | Checklist Quiz - Diapers | Checklist Quiz - Laundry Plans | Checklist Quiz - Nursery | Checklist Quiz - Gender Color | Checklist Quiz - Laundry Frequency | Checklist Quiz - Celebrity | Checklist Quiz - Season | Checklist Quiz - Planning | Checklist Quiz - Food | Checklist Quiz - Cars | Checklist Quiz - Know Us | Checklist Quiz - Coregistration | Checklist Quiz - Email Collection | Onboarding - Road Ahead | Onboarding - Arrival Date | Onboarding - Milestone | Onboarding - Adoption Affirmation | Onboarding - Still Trying Affirmation | Onboarding - Adoption Age | Onboarding - First Time Parent | Onboarding - Sentiment | Onboarding - Partner | Onboarding - You Got This | Onboarding - Partner Name | Onboarding - Invite Partner | Onboarding - Partner Email Collection | Onboarding - Partner Email Invite Sent | Onboarding - Value Proposition | Onboarding - Babylist Button | Checklist Quiz - Expecting Status | Checklist Quiz - Have Registry | Store - Brand | Add Items | Cart - Recommendations Carousel | Cart - Recommendations Quick View Modal | Add Item For Brand | Gift Giver - Email Collection | Guides | PLP | Onboarding - App Download | Toolbar - App Download | Tile - App Download | Deep Link | Checklist | Checklist Category | Settings | Registry Preview Page | Registry Starter Page | Registry Create Form | Onboarding - List Type | Tab Bar | List - Empty List | Add Items - Search | Add Items - Tile | Search Text | Search Photo | Registry Empty State | Insurance Panel - Top Insurances | Insurance Panel - All Insurances | Insurance Panel - Search Results | Mobile Web Top Utility Bar | Mobile Web Bottom Nav | Mobile Web Hamburger | Web Top Nav | Store - Carousel | Account Creation Form | Settings - Shipping Address | Settings - Shipping Consolidation | Find My Registry | Store - Search Suggestions | Menu | PDP - Add To Babylist | PDP - Add To Cart | Onboarding - Email Collection | All Lists | Registry - Preferences Row | Registry - Stats Row | Subscription Modal - Desktop Nav | Subscription Modal - Footer | Subscription Modal - Mobile Nav | Subscription Modal - Article Sidebar | Subscription Modal - Article In-Line | Subscription Modal - Journey Stage | Subscription Modal - Due Date | Subscription Modal - Baby Birth Date | List Adoption Modal - Feed | List Adoption Modal - Registry | List Adoption Modal - Store | List Adoption Modal - Guides | Copy Reg Item - Category List | Log In - Forgot Password | Log In - Log In Screen | Log In - Log In Modal | Holiday Landing Page | Log In - Start | Log In - Try Google | Log In - Submit Email Password | Log In - Google No Account | Log In - Verify Email Password | Sign Up - Existing Account | Sign Up - Name | Sign Up - Email Confirmation | Onboarding - Add Walkthrough Intro | Onboarding - Add Walkthrough | Log In - No Account | Sign Up - Start | Sign Up - Name Confirmation | Sign Up - Name And Email Confirmation | External Registry Transfer | Sign Up - Babylist Bookmarklet | Sign Up - Babylist Embedded Partner Button | Sign Up - Babylist Extension | Sign Up - Guides - Add Items | Add Items - Babylist Bookmarklet | Add Items - Babylist Embedded Partner Button | Add Items - Babylist Extension | Log In - Babylist Bookmarklet | Log In - Babylist Embedded Partner Button | Log In - Babylist Extension | Health Replacement Parts Order Form | Product | App Bottom Nav | Push Notification | Message Center Inbox | Shop | Unified Search | Log In - Guides - Add Items | Health Insurance Verifier Tool | Hello Baby Box - Shipping Consolidation | Shop - Flyout Nav | Shop - Left Nav | Shop - Image Nav | Shop - Breadcrumbs | Footer | Mobile Web - Category Drop Down | Hello Baby Box Requirements | Registry - Gift Giver View | Registry - Buying Options Modal | Log In - Deep Link | Push Notification Opt-In Modal | Device - Push Notification Opt-In Modal | Device - Message Center Inbox | Shipments | Shipment Details | Orders | Order Details | Home - Right Rail | Home - Left Rail | Bottom Nav Bar | Store - Product Card Quick View | Store - Product Card | Registry - Buying Option Reg Item Card | Registry - Organize Item Screen ] but you provided the value " + eventLocation
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "zseEDZJCEW", message: message}]);
    }
    return messages;
  }

  function setAvoLogger(avoLogger) {
    __AVO_LOGGER__ = avoLogger;
  }

  var sysUtmCampaign;
  var sysUtmMedium;
  var sysUtmSource;
  var sysUtmContent;
  var sysUtmTerm;
  var sysLandingPage;
  var sysReferrer;
  var sysSearchKeyword;
  var sysLibrary;
  var sysPlatform;
  var sysDeviceType;
  var sysBranchId;
  var sysAppVersion;
  var sysUtmCoop;
  var sysUtmGroup;
  var sysSplitTests;
  var sysLastExternalReferrer;
  var sysBlAnonId;
  var sysIsSynthetic;

  function setSystemProperties(properties) {
    if (properties.utmCampaign !== null && properties.utmCampaign !== undefined) {
      sysUtmCampaign = properties.utmCampaign;
      assertOptionalUtmCampaign(sysUtmCampaign);
    }
    if (properties.utmMedium !== null && properties.utmMedium !== undefined) {
      sysUtmMedium = properties.utmMedium;
      assertOptionalUtmMedium(sysUtmMedium);
    }
    if (properties.utmSource !== null && properties.utmSource !== undefined) {
      sysUtmSource = properties.utmSource;
      assertOptionalUtmSource(sysUtmSource);
    }
    if (properties.utmContent !== null && properties.utmContent !== undefined) {
      sysUtmContent = properties.utmContent;
      assertOptionalUtmContent(sysUtmContent);
    }
    if (properties.utmTerm !== null && properties.utmTerm !== undefined) {
      sysUtmTerm = properties.utmTerm;
      assertOptionalUtmTerm(sysUtmTerm);
    }
    if (properties.landingPage !== null && properties.landingPage !== undefined) {
      sysLandingPage = properties.landingPage;
      assertOptionalLandingPage(sysLandingPage);
    }
    if (properties.referrer !== null && properties.referrer !== undefined) {
      sysReferrer = properties.referrer;
      assertOptionalReferrer(sysReferrer);
    }
    if (properties.searchKeyword !== null && properties.searchKeyword !== undefined) {
      sysSearchKeyword = properties.searchKeyword;
      assertOptionalSearchKeyword(sysSearchKeyword);
    }
    if (properties.library !== null && properties.library !== undefined) {
      sysLibrary = properties.library;
      assertLibrary(sysLibrary);
    }
    if (properties.platform !== null && properties.platform !== undefined) {
      sysPlatform = properties.platform;
      assertPlatform(sysPlatform);
    }
    if (properties.deviceType !== null && properties.deviceType !== undefined) {
      sysDeviceType = properties.deviceType;
      assertDeviceType(sysDeviceType);
    }
    if (properties.branchId !== null && properties.branchId !== undefined) {
      sysBranchId = properties.branchId;
      assertBranchId(sysBranchId);
    }
    if (properties.appVersion !== null && properties.appVersion !== undefined) {
      sysAppVersion = properties.appVersion;
      assertAppVersion(sysAppVersion);
    }
    if (properties.utmCoop !== null && properties.utmCoop !== undefined) {
      sysUtmCoop = properties.utmCoop;
      assertOptionalUtmCoop(sysUtmCoop);
    }
    if (properties.utmGroup !== null && properties.utmGroup !== undefined) {
      sysUtmGroup = properties.utmGroup;
      assertOptionalUtmGroup(sysUtmGroup);
    }
    if (properties.splitTests !== null && properties.splitTests !== undefined) {
      sysSplitTests = properties.splitTests;
      assertOptionalSplitTests(sysSplitTests);
    }
    if (properties.lastExternalReferrer !== null && properties.lastExternalReferrer !== undefined) {
      sysLastExternalReferrer = properties.lastExternalReferrer;
      assertOptionalLastExternalReferrer(sysLastExternalReferrer);
    }
    if (properties.blAnonId !== null && properties.blAnonId !== undefined) {
      sysBlAnonId = properties.blAnonId;
      assertOptionalBlAnonId(sysBlAnonId);
    }
    if (properties.isSynthetic !== null && properties.isSynthetic !== undefined) {
      sysIsSynthetic = properties.isSynthetic;
      assertOptionalIsSynthetic(sysIsSynthetic);
    }
  }

  function setSystemProperties_(properties) {
    if (properties.utmCampaign !== null && properties.utmCampaign !== undefined) {
      sysUtmCampaign = properties.utmCampaign;
      assertOptionalUtmCampaign(sysUtmCampaign);
    }
    if (properties.utmMedium !== null && properties.utmMedium !== undefined) {
      sysUtmMedium = properties.utmMedium;
      assertOptionalUtmMedium(sysUtmMedium);
    }
    if (properties.utmSource !== null && properties.utmSource !== undefined) {
      sysUtmSource = properties.utmSource;
      assertOptionalUtmSource(sysUtmSource);
    }
    if (properties.utmContent !== null && properties.utmContent !== undefined) {
      sysUtmContent = properties.utmContent;
      assertOptionalUtmContent(sysUtmContent);
    }
    if (properties.utmTerm !== null && properties.utmTerm !== undefined) {
      sysUtmTerm = properties.utmTerm;
      assertOptionalUtmTerm(sysUtmTerm);
    }
    if (properties.landingPage !== null && properties.landingPage !== undefined) {
      sysLandingPage = properties.landingPage;
      assertOptionalLandingPage(sysLandingPage);
    }
    if (properties.referrer !== null && properties.referrer !== undefined) {
      sysReferrer = properties.referrer;
      assertOptionalReferrer(sysReferrer);
    }
    if (properties.searchKeyword !== null && properties.searchKeyword !== undefined) {
      sysSearchKeyword = properties.searchKeyword;
      assertOptionalSearchKeyword(sysSearchKeyword);
    }
    if (properties.library !== null && properties.library !== undefined) {
      sysLibrary = properties.library;
      assertLibrary(sysLibrary);
    }
    if (properties.platform !== null && properties.platform !== undefined) {
      sysPlatform = properties.platform;
      assertPlatform(sysPlatform);
    }
    if (properties.deviceType !== null && properties.deviceType !== undefined) {
      sysDeviceType = properties.deviceType;
      assertDeviceType(sysDeviceType);
    }
    if (properties.branchId !== null && properties.branchId !== undefined) {
      sysBranchId = properties.branchId;
      assertBranchId(sysBranchId);
    }
    if (properties.appVersion !== null && properties.appVersion !== undefined) {
      sysAppVersion = properties.appVersion;
      assertAppVersion(sysAppVersion);
    }
    if (properties.utmCoop !== null && properties.utmCoop !== undefined) {
      sysUtmCoop = properties.utmCoop;
      assertOptionalUtmCoop(sysUtmCoop);
    }
    if (properties.utmGroup !== null && properties.utmGroup !== undefined) {
      sysUtmGroup = properties.utmGroup;
      assertOptionalUtmGroup(sysUtmGroup);
    }
    if (properties.splitTests !== null && properties.splitTests !== undefined) {
      sysSplitTests = properties.splitTests;
      assertOptionalSplitTests(sysSplitTests);
    }
    if (properties.lastExternalReferrer !== null && properties.lastExternalReferrer !== undefined) {
      sysLastExternalReferrer = properties.lastExternalReferrer;
      assertOptionalLastExternalReferrer(sysLastExternalReferrer);
    }
    if (properties.blAnonId !== null && properties.blAnonId !== undefined) {
      sysBlAnonId = properties.blAnonId;
      assertOptionalBlAnonId(sysBlAnonId);
    }
    if (properties.isSynthetic !== null && properties.isSynthetic !== undefined) {
      sysIsSynthetic = properties.isSynthetic;
      assertOptionalIsSynthetic(sysIsSynthetic);
    }
  }

  function setup_(options, systemProperties, destinationOptions) {
    __WEB_DEBUGGER__ = false;
    if (options.validateProperties === true) {
      __AVO_DEV__ = true;
    }

    setSystemProperties_(systemProperties);

    destinationOptions = destinationOptions || {};

    if (!__AVO_NOOP__) {
      if (options.useProductionKey) {
        Segment.make(
          "LL0hAYZEpxxw6w3AECtek3EM75UT67l7",
          destinationOptions.segment
        );
      } else {
        Segment.make(
          "VSBJwklO58gNkesuINfdZhFs1I2PO9rG",
          destinationOptions.segment
        );
      }
      if (__AVO_DEV__) {
        // debug console in Avo
        _avo_invoke_meta(__AVO_ENV__, 'setup', [], 'setup');
      }
    }
  }

  function initAvo(options, systemProperties, destinationOptions) {
    if (__AVO_ENV__ !== null) {
      return;
    }
    __AVO_ENV__ = options.env.toLowerCase();
    if (options.avoLogger !== undefined) {
      __AVO_LOGGER__ = options.avoLogger;
    }
    if (options.noop === true) {
      __AVO_NOOP__ = true;
    }
    if (__AVO_NOOP__ && __AVO_ENV__ == 'prod') {
      InternalAvoLogger.warn("****************************************************");
      InternalAvoLogger.warn("WARNING Avo cannot be initialized in noop mode in production:");
      InternalAvoLogger.warn("- Overwriting configuration with noop=false.");
      InternalAvoLogger.warn("- Please reach out if you want to be able to run Avo in production mode with noop=true");
      InternalAvoLogger.warn("****************************************************");
      __AVO_NOOP__ = false;
    }
    if (__AVO_NOOP__) {
      InternalAvoLogger.log("****************************************************");
      InternalAvoLogger.log("Avo is now initialized in noop mode. This means:");
      InternalAvoLogger.log("- No events will be sent");
      InternalAvoLogger.log("- No network requests are made");
      InternalAvoLogger.log("****************************************************");
    }
    if (options.strict !== undefined) {
      __STRICT__ = options.strict !== false;
    }
    if (options.reportFailureAs !== undefined) {
      __REPORT_FAILURE_AS__ = options.reportFailureAs;
    }
    __WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && window.location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== 'prod'));
    if (!__AVO_NOOP__ && options.inspector !== undefined) {
      __INSPECTOR__ = options.inspector;
    } else if (__AVO_ENV__ !== 'prod') {
      InternalAvoLogger.warn("Avo Inspector not provided in initAvo() call");
    }
    if (__AVO_ENV__ !== 'prod') {
      __AVO_DEV__ = true;
    }

    setSystemProperties(systemProperties);

    destinationOptions = destinationOptions || {};

    if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions && options.webDebuggerOptions.position) {
      const {
        BOTTOM_RIGHT,
        BOTTOM_LEFT,
        TOP_RIGHT,
        TOP_LEFT,
        } =
        WebDebuggerPosition.position;

      try {
        WebDebuggerAssertions.assertKey(
          options.webDebuggerOptions.position,
          "position",
          position => {
            return position === BOTTOM_RIGHT ||
            position === BOTTOM_LEFT ||
            position === TOP_RIGHT ||
            position === TOP_LEFT;
          }
        )
      } catch (e) {
        throw new Error('WebDebugger: Position object incorrect. Use methods from WebDebuggerPosition.');
      }

      const top = options.webDebuggerOptions.position.top || 0;
      const right = options.webDebuggerOptions.position.right || 0;
      const bottom = options.webDebuggerOptions.position.bottom || 0;
      const left = options.webDebuggerOptions.position.left || 0;

      let positionParams;

      switch (options.webDebuggerOptions.position.position) {
        case BOTTOM_RIGHT:
          positionParams = {
            position: BOTTOM_RIGHT,
            bottom,
            right,
          };
          break;
        case BOTTOM_LEFT:
          positionParams = {
            position: BOTTOM_LEFT,
            bottom,
            left,
          };
          break;
        case TOP_RIGHT:
          positionParams = {
            position: TOP_RIGHT,
            top,
            right,
          };
          break;
        case TOP_LEFT:
          positionParams = {
            position: TOP_LEFT,
            top,
            left,
          };
          break;
        default: throw new Error('WebDebugger: Position object incorrect. Use methods from WebDebuggerPosition.');
      }

      _avo_debugger_send_position(positionParams);
    }

(function() {
  if (typeof window === 'undefined') { return; }
  var init = function() {
    if (document.getElementById("avo-debugger") === null) {
      var iframe = document.createElement("iframe");
      document.body.appendChild(iframe);
      iframe.id = "avo-debugger";
      iframe.src = "https://www.avo.app/_debugger";
      iframe.style = "display: none;";
    }
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

    }
    if (!__AVO_NOOP__) {
      if (__AVO_ENV__ === 'prod') {
        Segment.make(
          "LL0hAYZEpxxw6w3AECtek3EM75UT67l7",
          destinationOptions.segment
        );
      }
      if (__AVO_ENV__ === 'dev') {
        Segment.make(
          "VSBJwklO58gNkesuINfdZhFs1I2PO9rG",
          destinationOptions.segment
        );
      }
      if (__AVO_ENV__ === 'staging') {
        Segment.make(
          "",
          destinationOptions.segment
        );
      }
      if (__AVO_DEV__) {
        // debug console in Avo
        _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
      }
    }
  }

  /**
   * Added to Cart: This event is fired when a user clicks a button that results in a babylist item added to the user's cart.

When
- from PDP -> add to "store" cart
- from Registry -> creating a reservation (gift giver or registrant)

event_properties
- event_cta: None
- event_location: PDP | Registry | Shop Registry | Buying Options Modal | Store - Product Card Quick View
- event_type: Added to Store Reservation || Added to Store  || Quick View

When this event is fired from web the cart_stores property will always be ["Babylist Store"] because web doesn't allow adding amazon items to cart anymore. There is an edge case where a user might add amazon items to the cart on the iOS app then switch to web and more items from web. In this case "Amazon" will not be included on the cart_stores property for events sent from web.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {int} properties.cartItemQuantity - Quantity of item added to the cart
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {float} properties.productPrice - Price displayed for the product
   * @param {string} properties.productType - Type of the product
   * @param {bool} [properties.isFsaHsaEligible] - This property describes whether a product is eligible for FSA/HSA.
   * @param {Array<string>} properties.cartTypes - Type of the cart
   * @param {float} [properties.cartTotalValue] - no description
   * @param {Array<string>} [properties.cartStores] - Defines which stores were included in the cart. In Dec 2020, we added Amazon to the cart (which was previously Babylist Store only). In the future, we may add other stores to our cart.
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {Array<int>} [properties.regItemIds] - This is the targeted list of reg item ids. For events that operate on a single product like Added to Registry, it is a list of 1 reg_item_id.
   * @param {string} [properties.searchId] - ID of Algolia query which generated the original list of search results. Used by Algolia to attribute an event to a specific query for click conversion metrics. Segment maps this property to Algolia event.queryID in Algolia Insights destination.
   * @param {bool} properties.subscribeToMarketingEmail - Indicate whether user (or anonymous gift giver) checked subscription to (gift giver) marketing email
   * @param {string} properties.storeAdded - The store that was added to cart.
   * @param {string} [properties.searchPreviewIds] - This event property is a JSON string describing the Algolia Ids which generated the search preview results. Each Algolia Id corresponds to a different Algolia index. The JSON string should be encoded in the following format:

{"AlgoliaIndexName": "AlgoliaId", "AlgoliaIndexName": "AlgoliaId", "AlgoliaIndexName": "AlgoliaId"}
   * @param {string} [properties.strategy] - Babylist Health uses a discriminant key called "strategy" to differentiate between the pumps vs parts flow
   * @param {string} [properties.pdpType] - We have several different PDP variations. This will give us insight into which variation of the PDP the user is currently on.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/9IkjZ41sS1}
   */
  function addedToCart(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertCartItemQuantity(properties.cartItemQuantity));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertProductPrice(properties.productPrice));
      messages = messages.concat(assertProductType(properties.productType));
      messages = messages.concat(assertOptionalIsFsaHsaEligible(properties.isFsaHsaEligible));
      messages = messages.concat(assertCartTypes(properties.cartTypes));
      messages = messages.concat(assertOptionalCartTotalValue(properties.cartTotalValue));
      messages = messages.concat(assertOptionalCartStores(properties.cartStores));
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalRegItemIds(properties.regItemIds));
      messages = messages.concat(assertOptionalSearchId(properties.searchId));
      messages = messages.concat(assertSubscribeToMarketingEmail(properties.subscribeToMarketingEmail));
      messages = messages.concat(assertStoreAdded(properties.storeAdded));
      messages = messages.concat(assertOptionalSearchPreviewIds(properties.searchPreviewIds));
      messages = messages.concat(assertOptionalStrategy(properties.strategy));
      messages = messages.concat(assertOptionalPdpType(properties.pdpType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "9IkjZ41sS1", "19f675447781db4b932a495c46d52f013b1e95d90ea3c5a9a2b91e302039fcbd", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Added to Cart", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "cart_item_quantity": properties.cartItemQuantity,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
        "cart_types": properties.cartTypes,
        "cart_total_value": properties.cartTotalValue,
        "cart_stores": properties.cartStores,
        "store_name": properties.storeName,
        "product_ids": properties.productIds,
        "reg_item_ids": properties.regItemIds,
        "search_id": properties.searchId,
        "subscribe_to_marketing_email": properties.subscribeToMarketingEmail,
        "store_added": properties.storeAdded,
        "search_preview_ids": properties.searchPreviewIds,
        "strategy": properties.strategy,
        "pdp_type": properties.pdpType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("9IkjZ41sS1", "Added to Cart", messages, [
        {id: "1Vdhmd-w_5", name: "cart_item_quantity", value: properties.cartItemQuantity},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "AbcCBgMrrb", name: "cart_total_value", value: properties.cartTotalValue},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "FjngcQv7h", name: "strategy", value: properties.strategy},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "JKdXRUiKFn", name: "cart_types", value: properties.cartTypes},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "VlL55_rwx1", name: "search_id", value: properties.searchId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "d1zSLf5RRz", name: "store_added", value: properties.storeAdded},
        {id: "eVYsq2XJU", name: "search_preview_ids", value: properties.searchPreviewIds},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "h12bnVZfao", name: "pdp_type", value: properties.pdpType},
        {id: "hHOUpzCIx2", name: "product_price", value: properties.productPrice},
        {id: "hh5IW9vG8X", name: "product_type", value: properties.productType},
        {id: "kN_aicHWKA", name: "is_fsa_hsa_eligible", value: properties.isFsaHsaEligible},
        {id: "pTXZlXuqdY", name: "cart_stores", value: properties.cartStores},
        {id: "q4NPS9mkk", name: "subscribe_to_marketing_email", value: properties.subscribeToMarketingEmail},
        {id: "w4Er1Tq_Sl", name: "reg_item_ids", value: properties.regItemIds},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Added to Cart': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Added to Cart", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "cart_item_quantity": properties.cartItemQuantity,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "product_price": properties.productPrice,
          "product_type": properties.productType,
          "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
          "cart_types": properties.cartTypes,
          "cart_total_value": properties.cartTotalValue,
          "cart_stores": properties.cartStores,
          "store_name": properties.storeName,
          "product_ids": properties.productIds,
          "reg_item_ids": properties.regItemIds,
          "search_id": properties.searchId,
          "subscribe_to_marketing_email": properties.subscribeToMarketingEmail,
          "store_added": properties.storeAdded,
          "search_preview_ids": properties.searchPreviewIds,
          "strategy": properties.strategy,
          "pdp_type": properties.pdpType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "9IkjZ41sS1", "19f675447781db4b932a495c46d52f013b1e95d90ea3c5a9a2b91e302039fcbd");
      }
      // destination Segment
      Segment.logEvent("Added to Cart", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "cart_item_quantity": properties.cartItemQuantity,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
        "cart_types": properties.cartTypes,
        "cart_total_value": properties.cartTotalValue,
        "cart_stores": properties.cartStores,
        "store_name": properties.storeName,
        "product_ids": properties.productIds,
        "reg_item_ids": properties.regItemIds,
        "search_id": properties.searchId,
        "subscribe_to_marketing_email": properties.subscribeToMarketingEmail,
        "store_added": properties.storeAdded,
        "search_preview_ids": properties.searchPreviewIds,
        "strategy": properties.strategy,
        "pdp_type": properties.pdpType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Added to Registry: This event is fired when a registrant adds an item to their registry.

event_properties
• event_type: Quick Add | Copy | None | Quick View
• event_cta: Add to Babylist | None
• event_location:
      - Add Item
      - PDP
      - Feed
      - Next Add Recommender
      - Copy Reg Item - Category List (iOS)
      - Add Items - Babylist Bookmarklet (web)
      - Add Items - Babylist Extension (web)
      - Add Items - Babylist Embedded Partner Button (web)
      - Add Items - Share Extension (iOS)
      - Guide
      - Add to Babylist Button (web)
      - Add Item For Store (iOS)
      - Onboarding - Add Walkthrough (web)
      - Search Text (iOS)
      - Search Photo (iOS)
      - Store - Product Card Quick View

registry_categorization_properties
• category_id
• category_title
• suggested_category_viewed: True/False
• suggested_category_id
• suggested_category_title

list_type
• baby_registry
• birthday
• holiday

Notes:
event_type = Copy (when a reg item is copied from one list to another)
event_location = Copy Reg Item - Category List (iOS copy reg item flow)

Example
https://babylist.com/gp/babybjorn-baby-carrier-mini/14379/30640
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {float} properties.regItemPrice - Registry item price
   * @param {int} properties.regItemQuantity - Registry item quantity
   * @param {float} properties.productPrice - Price displayed for the product
   * @param {string} properties.productType - Type of the product
   * @param {bool} [properties.isFsaHsaEligible] - This property describes whether a product is eligible for FSA/HSA.
   * @param {string} [properties.categoryId] - The Category ID of the item in the registry experience (e.g. ID that maps to the registry categories like: General, Feeding, Baby Gear)

**Does not map to any Merchandising/Checklist category
   * @param {string} [properties.categoryTitle] - The Category Title of the item in the registry experience (e.g. General, Feeding, Baby Gear)

**Does not map to any Merchandising/Checklist category
   * @param {string} [properties.suggestedCategoryReturned] - Boolean field (True/False) returned for the Categorization Service response. "True" if the category API returns a value before the user hits add, "False" if the user hits add before the response is returned.
   * @param {string} [properties.suggestedCategoryId] - The Suggested Category ID of the item in the registry experience provided by the Categorization Service (e.g. ID that maps to the registry categories like: General, Feeding, Baby Gear)

**Does not map to any Merchandising/Checklist category
   * @param {string} [properties.suggestedCategoryTitle] - The Suggested Category Title of the item in the registry experience provided by the Categorization Service (e.g. General, Feeding, Baby Gear)

**Does not map to any Merchandising/Checklist category
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {Array<int>} [properties.regItemIds] - This is the targeted list of reg item ids. For events that operate on a single product like Added to Registry, it is a list of 1 reg_item_id.
   * @param {string} [properties.searchId] - ID of Algolia query which generated the original list of search results. Used by Algolia to attribute an event to a specific query for click conversion metrics. Segment maps this property to Algolia event.queryID in Algolia Insights destination.
   * @param {bool} properties.isFirstRegItem - Denotes whether or not the item added was the first item a user added to their registry
   * @param {string} properties.email - Email the user used to sign up.
   * @param {int} properties.userId - The id of the registry owner
   * @param {string} properties.collaboratorRole - no description
   * @param {string} [properties.productBrand] - The brand name of the product item
   * @param {bool} [properties.isSponsoredProduct] - Whether or not the product was sponsored.
   * @param {string} [properties.itemType] - A reg item type. Only required if the reg item is a text or photo item.
   * @param {string} [properties.searchPreviewIds] - This event property is a JSON string describing the Algolia Ids which generated the search preview results. Each Algolia Id corresponds to a different Algolia index. The JSON string should be encoded in the following format:

{"AlgoliaIndexName": "AlgoliaId", "AlgoliaIndexName": "AlgoliaId", "AlgoliaIndexName": "AlgoliaId"}
   * @param {string} [properties.pdpType] - We have several different PDP variations. This will give us insight into which variation of the PDP the user is currently on.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/JXMNx4T2p_}
   */
  function addedToRegistry(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertRegItemPrice(properties.regItemPrice));
      messages = messages.concat(assertRegItemQuantity(properties.regItemQuantity));
      messages = messages.concat(assertProductPrice(properties.productPrice));
      messages = messages.concat(assertProductType(properties.productType));
      messages = messages.concat(assertOptionalIsFsaHsaEligible(properties.isFsaHsaEligible));
      messages = messages.concat(assertOptionalCategoryId(properties.categoryId));
      messages = messages.concat(assertOptionalCategoryTitle(properties.categoryTitle));
      messages = messages.concat(assertOptionalSuggestedCategoryReturned(properties.suggestedCategoryReturned));
      messages = messages.concat(assertOptionalSuggestedCategoryId(properties.suggestedCategoryId));
      messages = messages.concat(assertOptionalSuggestedCategoryTitle(properties.suggestedCategoryTitle));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalRegItemIds(properties.regItemIds));
      messages = messages.concat(assertOptionalSearchId(properties.searchId));
      messages = messages.concat(assertIsFirstRegItem(properties.isFirstRegItem));
      messages = messages.concat(assertEmail(properties.email));
      messages = messages.concat(assertUserId(properties.userId));
      messages = messages.concat(assertCollaboratorRole(properties.collaboratorRole));
      messages = messages.concat(assertOptionalProductBrand(properties.productBrand));
      messages = messages.concat(assertOptionalIsSponsoredProduct(properties.isSponsoredProduct));
      messages = messages.concat(assertOptionalItemType(properties.itemType));
      messages = messages.concat(assertOptionalSearchPreviewIds(properties.searchPreviewIds));
      messages = messages.concat(assertOptionalPdpType(properties.pdpType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "JXMNx4T2p_", "3af968c3d494dd50df75630d5ca77e721dad668f56a57b55c1315df99b18b9f7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Added to Registry", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "reg_item_price": properties.regItemPrice,
        "reg_item_quantity": properties.regItemQuantity,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
        "category_id": properties.categoryId,
        "category_title": properties.categoryTitle,
        "suggested_category_returned": properties.suggestedCategoryReturned,
        "suggested_category_id": properties.suggestedCategoryId,
        "suggested_category_title": properties.suggestedCategoryTitle,
        "product_ids": properties.productIds,
        "reg_item_ids": properties.regItemIds,
        "search_id": properties.searchId,
        "is_first_reg_item": properties.isFirstRegItem,
        "email": properties.email,
        "user_id": properties.userId,
        "collaborator_role": properties.collaboratorRole,
        "product_brand": properties.productBrand,
        "is_sponsored_product": properties.isSponsoredProduct,
        "item_type": properties.itemType,
        "search_preview_ids": properties.searchPreviewIds,
        "pdp_type": properties.pdpType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("JXMNx4T2p_", "Added to Registry", messages, [
        {id: "6aTdu1v9r8", name: "category_id", value: properties.categoryId},
        {id: "7ZAoZUrw6e", name: "suggested_category_title", value: properties.suggestedCategoryTitle},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "B17latt6RY", name: "category_title", value: properties.categoryTitle},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "EUdmleR_r0", name: "product_brand", value: properties.productBrand},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "Mzj1HBhPg9", name: "user_id", value: properties.userId},
        {id: "RKqhBhnmEV", name: "email", value: properties.email},
        {id: "SqR4V-W1h", name: "is_first_reg_item", value: properties.isFirstRegItem},
        {id: "VZ1_hmw_sP", name: "item_type", value: properties.itemType},
        {id: "VlL55_rwx1", name: "search_id", value: properties.searchId},
        {id: "Zqh3aYRqWf", name: "suggested_category_returned", value: properties.suggestedCategoryReturned},
        {id: "_IP9QswtZC", name: "reg_item_quantity", value: properties.regItemQuantity},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "eVYsq2XJU", name: "search_preview_ids", value: properties.searchPreviewIds},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "h12bnVZfao", name: "pdp_type", value: properties.pdpType},
        {id: "hHOUpzCIx2", name: "product_price", value: properties.productPrice},
        {id: "hh5IW9vG8X", name: "product_type", value: properties.productType},
        {id: "kN_aicHWKA", name: "is_fsa_hsa_eligible", value: properties.isFsaHsaEligible},
        {id: "keBt2ma-zt", name: "reg_item_price", value: properties.regItemPrice},
        {id: "uW2-VB6Xl3", name: "collaborator_role", value: properties.collaboratorRole},
        {id: "vtBpfRY_B", name: "is_sponsored_product", value: properties.isSponsoredProduct},
        {id: "w4Er1Tq_Sl", name: "reg_item_ids", value: properties.regItemIds},
        {id: "xUsHwGgkXG", name: "suggested_category_id", value: properties.suggestedCategoryId},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Added to Registry': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Added to Registry", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "reg_item_price": properties.regItemPrice,
          "reg_item_quantity": properties.regItemQuantity,
          "product_price": properties.productPrice,
          "product_type": properties.productType,
          "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
          "category_id": properties.categoryId,
          "category_title": properties.categoryTitle,
          "suggested_category_returned": properties.suggestedCategoryReturned,
          "suggested_category_id": properties.suggestedCategoryId,
          "suggested_category_title": properties.suggestedCategoryTitle,
          "product_ids": properties.productIds,
          "reg_item_ids": properties.regItemIds,
          "search_id": properties.searchId,
          "is_first_reg_item": properties.isFirstRegItem,
          "email": properties.email,
          "user_id": properties.userId,
          "collaborator_role": properties.collaboratorRole,
          "product_brand": properties.productBrand,
          "is_sponsored_product": properties.isSponsoredProduct,
          "item_type": properties.itemType,
          "search_preview_ids": properties.searchPreviewIds,
          "pdp_type": properties.pdpType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "JXMNx4T2p_", "3af968c3d494dd50df75630d5ca77e721dad668f56a57b55c1315df99b18b9f7");
      }
      // destination Segment
      Segment.logEvent("Added to Registry", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "reg_item_price": properties.regItemPrice,
        "reg_item_quantity": properties.regItemQuantity,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
        "category_id": properties.categoryId,
        "category_title": properties.categoryTitle,
        "suggested_category_returned": properties.suggestedCategoryReturned,
        "suggested_category_id": properties.suggestedCategoryId,
        "suggested_category_title": properties.suggestedCategoryTitle,
        "product_ids": properties.productIds,
        "reg_item_ids": properties.regItemIds,
        "search_id": properties.searchId,
        "is_first_reg_item": properties.isFirstRegItem,
        "email": properties.email,
        "user_id": properties.userId,
        "collaborator_role": properties.collaboratorRole,
        "product_brand": properties.productBrand,
        "is_sponsored_product": properties.isSponsoredProduct,
        "item_type": properties.itemType,
        "search_preview_ids": properties.searchPreviewIds,
        "pdp_type": properties.pdpType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Log In Completed: Triggered when the User logs into the app. Used for the Identify call.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
   * @param {string} properties.userEmail - email address of actor triggering the event. For anonymous users, this will be null.
   * @param {int} properties.primaryRegistryId - The primary registry id that this user is the owner on or partner on.
   * @param {string} properties.userCreatedAt - Date the user_id was created in Babylist. Helps distinguish new vs legacy users
   * @param {string} properties.arrivalDate - Arrival_date (formatted: "yyyy-mm-dd") for the primary_registry_id associated with the user.
   * @param {bool} properties.isPartner - Is the user a primary (false) or a partner on the registry
   * @param {string} properties.userAuthenticationMethod - The method they authenticated with.
   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/mA7aRWVrq2}
   */
  function logInCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUserId_(properties.userId_));
      messages = messages.concat(assertUserEmail(properties.userEmail));
      messages = messages.concat(assertPrimaryRegistryId(properties.primaryRegistryId));
      messages = messages.concat(assertUserCreatedAt(properties.userCreatedAt));
      messages = messages.concat(assertArrivalDate(properties.arrivalDate));
      messages = messages.concat(assertIsPartner(properties.isPartner));
      messages = messages.concat(assertUserAuthenticationMethod(properties.userAuthenticationMethod));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "mA7aRWVrq2", "335e792d688824f4a635d1a093a104326df33399239806e34b052bf74223cafe", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Log In Completed", {
        "user_authentication_method": properties.userAuthenticationMethod,
        "event_location": properties.eventLocation,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {
        "user_email": properties.userEmail,
        "primary_registry_id": properties.primaryRegistryId,
        "user_created_at": properties.userCreatedAt,
        "arrival_date": properties.arrivalDate,
        "is_partner": properties.isPartner,
        }, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("mA7aRWVrq2", "Log In Completed", messages, [
        {id: "-5fcT2VKC", name: "user_authentication_method", value: properties.userAuthenticationMethod},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [
        {id:"0Sl7tZu61R", name: "arrival_date", value: properties.arrivalDate},
        {id:"JFNgXwT9Pn", name: "is_partner", value: properties.isPartner},
        {id:"pZYqGD_5jw", name: "user_email", value: properties.userEmail},
        {id:"rJz3f4zZDl", name: "primary_registry_id", value: properties.primaryRegistryId},
        {id:"wIEnmk0K8", name: "user_created_at", value: properties.userCreatedAt},
        ], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Log In Completed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Log In Completed", {
          "user_authentication_method": properties.userAuthenticationMethod,
          "event_location": properties.eventLocation,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "mA7aRWVrq2", "335e792d688824f4a635d1a093a104326df33399239806e34b052bf74223cafe");
      }
      // destination Segment
      Segment.identify(properties.userId_, {});
      Segment.setUserProperties({
        "user_email": properties.userEmail,
        "primary_registry_id": properties.primaryRegistryId,
        "user_created_at": properties.userCreatedAt,
        "arrival_date": properties.arrivalDate,
        "is_partner": properties.isPartner,
        }, {});
      Segment.logEvent("Log In Completed", {
        "user_authentication_method": properties.userAuthenticationMethod,
        "event_location": properties.eventLocation,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Sign Up Completed: This event is triggered when the user signs up on Babylist and creates a registry
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
   * @param {string} properties.userEmail - email address of actor triggering the event. For anonymous users, this will be null.
   * @param {int} properties.primaryRegistryId - The primary registry id that this user is the owner on or partner on.
   * @param {string} properties.userCreatedAt - Date the user_id was created in Babylist. Helps distinguish new vs legacy users
   * @param {string} properties.arrivalDate - Arrival_date (formatted: "yyyy-mm-dd") for the primary_registry_id associated with the user.
   * @param {bool} properties.isPartner - Is the user a primary (false) or a partner on the registry
   * @param {string} properties.capiEventId - A redundant event ID that is specifically used for Facebook Conversions API (cAPI), generated by concatenating 'registryCreated:' with the user property 'primary_registry_id'. This capi event ID is used to reconcile web events generated by the Facebook Pixel with those sent to Segment directly from the Babylist back-end. This is a workaround to accommodate a limitation in Segment which does not allow for the ID to be dynamically generated.
   * @param {string} properties.email - Email the user used to sign up.
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {int} properties.userId - The id of the registry owner
   * @param {string} properties.userAuthenticationMethod - The method they authenticated with.
   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.facebookClickId] - This is read from a first-party cookie (_fbc) that captures the fbclid query parameter for a user/visitor that has clicked on a Facebook ad that brought them to Babylist.  This value will only be present for web traffic with Facebook ad clicks.
   * @param {string} [properties.facebookPixelId] - The Meta pixel installs a browser first-party cookie (_fbp) as a unique identifier.  This value will only be present for web traffic,  but isn't guaranteed to be present due to the presence of script blockers.
   * @param {string} [properties.userFirstName] - First name of the actor triggering the event. Marked as 'Sometimes sent' for compatibility w/ legacy mobile.
   * @param {string} [properties.userLastName] - Last name of the actor triggering the event. Marked as 'Sometimes sent' for compatibility w/ legacy mobile.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/0ZBk2MDRq}
   */
  function signUpCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUserId_(properties.userId_));
      messages = messages.concat(assertUserEmail(properties.userEmail));
      messages = messages.concat(assertPrimaryRegistryId(properties.primaryRegistryId));
      messages = messages.concat(assertUserCreatedAt(properties.userCreatedAt));
      messages = messages.concat(assertArrivalDate(properties.arrivalDate));
      messages = messages.concat(assertIsPartner(properties.isPartner));
      messages = messages.concat(assertCapiEventId(properties.capiEventId));
      messages = messages.concat(assertEmail(properties.email));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertUserId(properties.userId));
      messages = messages.concat(assertUserAuthenticationMethod(properties.userAuthenticationMethod));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalFacebookClickId(properties.facebookClickId));
      messages = messages.concat(assertOptionalFacebookPixelId(properties.facebookPixelId));
      messages = messages.concat(assertOptionalUserFirstName(properties.userFirstName));
      messages = messages.concat(assertOptionalUserLastName(properties.userLastName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "0ZBk2MDRq", "34f280b98de5a3b95ed2bd4df87c083c6c846c3847611702edd7df944cf97d9c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Sign Up Completed", {
        "capi_event_id": properties.capiEventId,
        "email": properties.email,
        "registry_id": properties.registryId,
        "user_id": properties.userId,
        "user_authentication_method": properties.userAuthenticationMethod,
        "event_location": properties.eventLocation,
        "facebook_click_id": properties.facebookClickId,
        "facebook_pixel_id": properties.facebookPixelId,
        "user_first_name": properties.userFirstName,
        "user_last_name": properties.userLastName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {
        "user_email": properties.userEmail,
        "primary_registry_id": properties.primaryRegistryId,
        "user_created_at": properties.userCreatedAt,
        "arrival_date": properties.arrivalDate,
        "is_partner": properties.isPartner,
        }, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("0ZBk2MDRq", "Sign Up Completed", messages, [
        {id: "-5fcT2VKC", name: "user_authentication_method", value: properties.userAuthenticationMethod},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "JUHzVfzt_p", name: "user_last_name", value: properties.userLastName},
        {id: "Mzj1HBhPg9", name: "user_id", value: properties.userId},
        {id: "P1RHrSlsWX", name: "capi_event_id", value: properties.capiEventId},
        {id: "RKqhBhnmEV", name: "email", value: properties.email},
        {id: "UqqJyK4STl", name: "user_first_name", value: properties.userFirstName},
        {id: "YcHHHs516", name: "facebook_click_id", value: properties.facebookClickId},
        {id: "sEHY-H0aij", name: "facebook_pixel_id", value: properties.facebookPixelId},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [
        {id:"0Sl7tZu61R", name: "arrival_date", value: properties.arrivalDate},
        {id:"JFNgXwT9Pn", name: "is_partner", value: properties.isPartner},
        {id:"pZYqGD_5jw", name: "user_email", value: properties.userEmail},
        {id:"rJz3f4zZDl", name: "primary_registry_id", value: properties.primaryRegistryId},
        {id:"wIEnmk0K8", name: "user_created_at", value: properties.userCreatedAt},
        ], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Sign Up Completed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Sign Up Completed", {
          "capi_event_id": properties.capiEventId,
          "email": properties.email,
          "registry_id": properties.registryId,
          "user_id": properties.userId,
          "user_authentication_method": properties.userAuthenticationMethod,
          "event_location": properties.eventLocation,
          "facebook_click_id": properties.facebookClickId,
          "facebook_pixel_id": properties.facebookPixelId,
          "user_first_name": properties.userFirstName,
          "user_last_name": properties.userLastName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "0ZBk2MDRq", "34f280b98de5a3b95ed2bd4df87c083c6c846c3847611702edd7df944cf97d9c");
      }
      // destination Segment
      Segment.identify(properties.userId_, {});
      Segment.setUserProperties({
        "user_email": properties.userEmail,
        "primary_registry_id": properties.primaryRegistryId,
        "user_created_at": properties.userCreatedAt,
        "arrival_date": properties.arrivalDate,
        "is_partner": properties.isPartner,
        }, {});
      Segment.logEvent("Sign Up Completed", {
        "capi_event_id": properties.capiEventId,
        "email": properties.email,
        "registry_id": properties.registryId,
        "user_id": properties.userId,
        "user_authentication_method": properties.userAuthenticationMethod,
        "event_location": properties.eventLocation,
        "facebook_click_id": properties.facebookClickId,
        "facebook_pixel_id": properties.facebookPixelId,
        "user_first_name": properties.userFirstName,
        "user_last_name": properties.userLastName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Log Out Completed: Track when user logs out of the session. For now the source is set to web, but this is a good candidate for tracking server side.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/D0pwqefStz}
   */
  function logOutCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "D0pwqefStz", "0c0b421eaca8672c36e0be6c3a97a4ea59b8dae9ad3352523ec1570a1fc58694", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Log Out Completed", {
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("D0pwqefStz", "Log Out Completed", messages, [
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Log Out Completed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Log Out Completed", {
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "D0pwqefStz", "0c0b421eaca8672c36e0be6c3a97a4ea59b8dae9ad3352523ec1570a1fc58694");
      }
      // destination Segment
      Segment.logEvent("Log Out Completed", {
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
      Segment.unidentify({});
    } else {
      // do nothing
    }
  }

  /**
   * Checkout Started: Action:
- This event is triggered when the user clicks the Checkout button within their Cart or if a Gift Giver or Registrant (user) click on Checkout within their Reserved Gifts. This is the step that drops the user into the Shopify checkout flow.

event_properties:
- event_location: Cart
- event_type: None
- event_cta: None
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {Array<string>} properties.cartTypes - Type of the cart
   * @param {float} [properties.cartTotalValue] - no description
   * @param {Array<string>} [properties.cartStores] - Defines which stores were included in the cart. In Dec 2020, we added Amazon to the cart (which was previously Babylist Store only). In the future, we may add other stores to our cart.
   * @param {bool} properties.regDiscountApplied - Boolean flag indicating whether the reg discount was applied or not when this event triggered

   * @param {Array<int>} [properties.regItemIds] - This is the targeted list of reg item ids. For events that operate on a single product like Added to Registry, it is a list of 1 reg_item_id.
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {bool} [properties.isFsaHsaOrder] - This property describes whether an order contains 1 or more items that are FSA/HSA eligible.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/sjuLJweFd4}
   */
  function checkoutStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertCartTypes(properties.cartTypes));
      messages = messages.concat(assertOptionalCartTotalValue(properties.cartTotalValue));
      messages = messages.concat(assertOptionalCartStores(properties.cartStores));
      messages = messages.concat(assertRegDiscountApplied(properties.regDiscountApplied));
      messages = messages.concat(assertOptionalRegItemIds(properties.regItemIds));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalIsFsaHsaOrder(properties.isFsaHsaOrder));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "sjuLJweFd4", "f755d7eb4e25f08bb361471f9888d64ef8194f41839a173141928ed9bba8b2ad", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Checkout Started", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "cart_types": properties.cartTypes,
        "cart_total_value": properties.cartTotalValue,
        "cart_stores": properties.cartStores,
        "reg_discount_applied": properties.regDiscountApplied,
        "reg_item_ids": properties.regItemIds,
        "product_ids": properties.productIds,
        "is_fsa_hsa_order": properties.isFsaHsaOrder,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("sjuLJweFd4", "Checkout Started", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "AbcCBgMrrb", name: "cart_total_value", value: properties.cartTotalValue},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "JKdXRUiKFn", name: "cart_types", value: properties.cartTypes},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "__MYG2YQnE", name: "reg_discount_applied", value: properties.regDiscountApplied},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "bpGjPMI2NX", name: "is_fsa_hsa_order", value: properties.isFsaHsaOrder},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "pTXZlXuqdY", name: "cart_stores", value: properties.cartStores},
        {id: "w4Er1Tq_Sl", name: "reg_item_ids", value: properties.regItemIds},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Checkout Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Checkout Started", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "cart_types": properties.cartTypes,
          "cart_total_value": properties.cartTotalValue,
          "cart_stores": properties.cartStores,
          "reg_discount_applied": properties.regDiscountApplied,
          "reg_item_ids": properties.regItemIds,
          "product_ids": properties.productIds,
          "is_fsa_hsa_order": properties.isFsaHsaOrder,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "sjuLJweFd4", "f755d7eb4e25f08bb361471f9888d64ef8194f41839a173141928ed9bba8b2ad");
      }
      // destination Segment
      Segment.logEvent("Checkout Started", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "cart_types": properties.cartTypes,
        "cart_total_value": properties.cartTotalValue,
        "cart_stores": properties.cartStores,
        "reg_discount_applied": properties.regDiscountApplied,
        "reg_item_ids": properties.regItemIds,
        "product_ids": properties.productIds,
        "is_fsa_hsa_order": properties.isFsaHsaOrder,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Discount Toggled: Action:
- This event is triggered when the user applies or removes a registry discount on the cart before check-out. The event sets reg_discount_applied to True if the user turns reg discount from off to on and False if vice-versa.

event_properties:
- event_location: Cart (if reg discount toggled in cart)
- event_cta: None
- event_type: None
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {bool} properties.regDiscountApplied - Boolean flag indicating whether the reg discount was applied or not when this event triggered

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/A-VS8EqNbg}
   */
  function registryDiscountToggled(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertRegDiscountApplied(properties.regDiscountApplied));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "A-VS8EqNbg", "330a13d1b44c55c189fd5cbd3c298c439c72e1048ce8e87da4f9ae2c694d5af3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Discount Toggled", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "reg_discount_applied": properties.regDiscountApplied,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("A-VS8EqNbg", "Registry Discount Toggled", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "__MYG2YQnE", name: "reg_discount_applied", value: properties.regDiscountApplied},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Discount Toggled': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Discount Toggled", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "reg_discount_applied": properties.regDiscountApplied,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "A-VS8EqNbg", "330a13d1b44c55c189fd5cbd3c298c439c72e1048ce8e87da4f9ae2c694d5af3");
      }
      // destination Segment
      Segment.logEvent("Registry Discount Toggled", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "reg_discount_applied": properties.regDiscountApplied,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Cart Opened: Action:
- Event is triggered when the user clicks on their cart or hits "View All" on the cart dropdown.
- Event is triggered when user clicks on Cart icon in the app

event_properties:
- event_location: Location in the app where the user clicked the cart from e.g. Store, Registry, Home Page etc.
- event_cta: None (if clicked on cart) | View All (if clicked on cart drop-down)
- event_type: None

cart_properties:
- cart_type:
- cart_stores: identifies the Stores in the Cart

registry_properties:
- is_registry_owner: boolean
- registry_owner_id: [value]
- registry_id: [value] This is helpful if the user has more than 1 registry.



   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {Array<string>} properties.cartTypes - Type of the cart
   * @param {float} [properties.cartTotalValue] - no description
   * @param {Array<string>} [properties.cartStores] - Defines which stores were included in the cart. In Dec 2020, we added Amazon to the cart (which was previously Babylist Store only). In the future, we may add other stores to our cart.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/87bAEeI_RW}
   */
  function cartOpened(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertCartTypes(properties.cartTypes));
      messages = messages.concat(assertOptionalCartTotalValue(properties.cartTotalValue));
      messages = messages.concat(assertOptionalCartStores(properties.cartStores));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "87bAEeI_RW", "bad4305e0c4af33d3f91f1c35aeab037023f7cbc55d7360fd73964c75d72bacd", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Cart Opened", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "cart_types": properties.cartTypes,
        "cart_total_value": properties.cartTotalValue,
        "cart_stores": properties.cartStores,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("87bAEeI_RW", "Cart Opened", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "AbcCBgMrrb", name: "cart_total_value", value: properties.cartTotalValue},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "JKdXRUiKFn", name: "cart_types", value: properties.cartTypes},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "pTXZlXuqdY", name: "cart_stores", value: properties.cartStores},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Cart Opened': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Cart Opened", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "cart_types": properties.cartTypes,
          "cart_total_value": properties.cartTotalValue,
          "cart_stores": properties.cartStores,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "87bAEeI_RW", "bad4305e0c4af33d3f91f1c35aeab037023f7cbc55d7360fd73964c75d72bacd");
      }
      // destination Segment
      Segment.logEvent("Cart Opened", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "cart_types": properties.cartTypes,
        "cart_total_value": properties.cartTotalValue,
        "cart_stores": properties.cartStores,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Cart Modified: Action:
- This event is triggered when the user modifies any items in their Cart or Cart Details Page.

event_properties:
- event_location: Cart OR Cart Details Page
- event_cta: None
- event_type: Item Removed | Item Quantity Updated | Item Removed - Out of Stock | Marked As Purchased
   *
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.cartItemQuantity - Quantity of item added to the cart
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {float} properties.productPrice - Price displayed for the product
   * @param {string} properties.productType - Type of the product
   * @param {bool} [properties.isFsaHsaEligible] - This property describes whether a product is eligible for FSA/HSA.
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {Array<string>} [properties.cartStores] - Defines which stores were included in the cart. In Dec 2020, we added Amazon to the cart (which was previously Babylist Store only). In the future, we may add other stores to our cart.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/EGZ8WgHD4-}
   */
  function cartModified(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertCartItemQuantity(properties.cartItemQuantity));
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertProductPrice(properties.productPrice));
      messages = messages.concat(assertProductType(properties.productType));
      messages = messages.concat(assertOptionalIsFsaHsaEligible(properties.isFsaHsaEligible));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalCartStores(properties.cartStores));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "EGZ8WgHD4-", "7c229a9a4b4fb903fc62dfc052fecae2186c92b3ef8eec884e8972d40e818728", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Cart Modified", {
        "cart_item_quantity": properties.cartItemQuantity,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
        "product_ids": properties.productIds,
        "cart_stores": properties.cartStores,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("EGZ8WgHD4-", "Cart Modified", messages, [
        {id: "1Vdhmd-w_5", name: "cart_item_quantity", value: properties.cartItemQuantity},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "hHOUpzCIx2", name: "product_price", value: properties.productPrice},
        {id: "hh5IW9vG8X", name: "product_type", value: properties.productType},
        {id: "kN_aicHWKA", name: "is_fsa_hsa_eligible", value: properties.isFsaHsaEligible},
        {id: "pTXZlXuqdY", name: "cart_stores", value: properties.cartStores},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Cart Modified': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Cart Modified", {
          "cart_item_quantity": properties.cartItemQuantity,
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "product_price": properties.productPrice,
          "product_type": properties.productType,
          "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
          "product_ids": properties.productIds,
          "cart_stores": properties.cartStores,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "EGZ8WgHD4-", "7c229a9a4b4fb903fc62dfc052fecae2186c92b3ef8eec884e8972d40e818728");
      }
      // destination Segment
      Segment.logEvent("Cart Modified", {
        "cart_item_quantity": properties.cartItemQuantity,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
        "product_ids": properties.productIds,
        "cart_stores": properties.cartStores,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Reservation Updated: Action:
- Event is triggered when the user or gift giver updates a reservation that they previously made.


event_properties:
- event_location: Registry | Cart
- event_cta: None
- event_type: Marked as Purchased, Cancel Reservation, Change Store
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.reservationStoreOriginal] - If the reservation_update_type is a Store change event, then record the original store of the item
   * @param {string} [properties.reservationStoreUpdated] - If the reservation_update_type is a Store change event, then record the updated store of the item
   * @param {string} [properties.reservationCancellationReason] - Reason the user cancelled their reservation.
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {float} properties.regItemPrice - Registry item price
   * @param {int} properties.regItemQuantity - Registry item quantity
   * @param {float} properties.productPrice - Price displayed for the product
   * @param {string} properties.productType - Type of the product
   * @param {bool} [properties.isFsaHsaEligible] - This property describes whether a product is eligible for FSA/HSA.
   * @param {Array<int>} [properties.regItemIds] - This is the targeted list of reg item ids. For events that operate on a single product like Added to Registry, it is a list of 1 reg_item_id.
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/S1MlsXeiKK}
   */
  function reservationUpdated(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalReservationStoreOriginal(properties.reservationStoreOriginal));
      messages = messages.concat(assertOptionalReservationStoreUpdated(properties.reservationStoreUpdated));
      messages = messages.concat(assertOptionalReservationCancellationReason(properties.reservationCancellationReason));
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertRegItemPrice(properties.regItemPrice));
      messages = messages.concat(assertRegItemQuantity(properties.regItemQuantity));
      messages = messages.concat(assertProductPrice(properties.productPrice));
      messages = messages.concat(assertProductType(properties.productType));
      messages = messages.concat(assertOptionalIsFsaHsaEligible(properties.isFsaHsaEligible));
      messages = messages.concat(assertOptionalRegItemIds(properties.regItemIds));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "S1MlsXeiKK", "e6b08acdcc12723c84a02c1a38a2c53cc98105a7fad3bb6000dc9d69857f25e2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Reservation Updated", {
        "reservation_store_original": properties.reservationStoreOriginal,
        "reservation_store_updated": properties.reservationStoreUpdated,
        "reservation_cancellation_reason": properties.reservationCancellationReason,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "reg_item_price": properties.regItemPrice,
        "reg_item_quantity": properties.regItemQuantity,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
        "reg_item_ids": properties.regItemIds,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("S1MlsXeiKK", "Reservation Updated", messages, [
        {id: "-2YWaZ1CaG", name: "reservation_store_original", value: properties.reservationStoreOriginal},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "Ds1npU9g2O", name: "reservation_store_updated", value: properties.reservationStoreUpdated},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_IP9QswtZC", name: "reg_item_quantity", value: properties.regItemQuantity},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "hHOUpzCIx2", name: "product_price", value: properties.productPrice},
        {id: "hh5IW9vG8X", name: "product_type", value: properties.productType},
        {id: "kN_aicHWKA", name: "is_fsa_hsa_eligible", value: properties.isFsaHsaEligible},
        {id: "keBt2ma-zt", name: "reg_item_price", value: properties.regItemPrice},
        {id: "w4Er1Tq_Sl", name: "reg_item_ids", value: properties.regItemIds},
        {id: "wJOhkP_Ev4", name: "reservation_cancellation_reason", value: properties.reservationCancellationReason},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Reservation Updated': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Reservation Updated", {
          "reservation_store_original": properties.reservationStoreOriginal,
          "reservation_store_updated": properties.reservationStoreUpdated,
          "reservation_cancellation_reason": properties.reservationCancellationReason,
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "reg_item_price": properties.regItemPrice,
          "reg_item_quantity": properties.regItemQuantity,
          "product_price": properties.productPrice,
          "product_type": properties.productType,
          "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
          "reg_item_ids": properties.regItemIds,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "S1MlsXeiKK", "e6b08acdcc12723c84a02c1a38a2c53cc98105a7fad3bb6000dc9d69857f25e2");
      }
      // destination Segment
      Segment.logEvent("Reservation Updated", {
        "reservation_store_original": properties.reservationStoreOriginal,
        "reservation_store_updated": properties.reservationStoreUpdated,
        "reservation_cancellation_reason": properties.reservationCancellationReason,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "reg_item_price": properties.regItemPrice,
        "reg_item_quantity": properties.regItemQuantity,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
        "reg_item_ids": properties.regItemIds,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Proceeded to Buy: Action:
- Event is triggered when a Gift Giver clicks on the "Click to Buy" on items they reserved that takes them to third-party stores like Amazon, Target etc.
- Event is triggered when a Registry Owner clicks "Buy" on items sold by third-party retailers


event_properties:
- event_location: the page/screen from where the user clicked "Buy"
- event_cta: None
- event_type: None

   *
   * When to trigger this event:
   * 1. Third-party store that the user is re-directed to when they hit "Click to Buy" for a non-babylist store.

Pass the actual value of the store name if possible.
   * View in Avo: https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/ZzctzRDqfF/trigger/5bUv9NJmw
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} properties.externalStoreName - Name of an external (third-party) store

When Triggered From External Registry Transfer
Pass the store domain of the external registry

When Triggered From Proceeded to Buy:
Pass the actual value of the store name.
   * @param {Array<int>} [properties.regItemIds] - This is the targeted list of reg item ids. For events that operate on a single product like Added to Registry, it is a list of 1 reg_item_id.
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {Array<string>} [properties.cartStores] - Defines which stores were included in the cart. In Dec 2020, we added Amazon to the cart (which was previously Babylist Store only). In the future, we may add other stores to our cart.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/ZzctzRDqfF}
   */
  function proceededToBuy(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertExternalStoreName(properties.externalStoreName));
      messages = messages.concat(assertOptionalRegItemIds(properties.regItemIds));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalCartStores(properties.cartStores));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ZzctzRDqfF", "b5c9918532347372abcca07341ece3b492283754255cce289bb836b5dcb71629", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Proceeded to Buy", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "external_store_name": properties.externalStoreName,
        "reg_item_ids": properties.regItemIds,
        "product_ids": properties.productIds,
        "cart_stores": properties.cartStores,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ZzctzRDqfF", "Proceeded to Buy", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "czcBAIKvtf", name: "external_store_name", value: properties.externalStoreName},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "pTXZlXuqdY", name: "cart_stores", value: properties.cartStores},
        {id: "w4Er1Tq_Sl", name: "reg_item_ids", value: properties.regItemIds},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Proceeded to Buy': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Proceeded to Buy", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "external_store_name": properties.externalStoreName,
          "reg_item_ids": properties.regItemIds,
          "product_ids": properties.productIds,
          "cart_stores": properties.cartStores,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "ZzctzRDqfF", "b5c9918532347372abcca07341ece3b492283754255cce289bb836b5dcb71629");
      }
      // destination Segment
      Segment.logEvent("Proceeded to Buy", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "external_store_name": properties.externalStoreName,
        "reg_item_ids": properties.regItemIds,
        "product_ids": properties.productIds,
        "cart_stores": properties.cartStores,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * User Identified: Identify an already logged in user (this is NOT a logged event)
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/CdE1KHrxtM}
   */
  function userIdentified(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertUserId_(properties.userId_));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "CdE1KHrxtM", "70fd37a7cdc18fddd7ec833a190dbe10d47d9a40529fd87b9adbb6adb9ebd3f7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("User Identified", {
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("CdE1KHrxtM", "User Identified", messages, [
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'User Identified': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("User Identified", {
          "store_name": properties.storeName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "CdE1KHrxtM", "70fd37a7cdc18fddd7ec833a190dbe10d47d9a40529fd87b9adbb6adb9ebd3f7");
      }
      // destination Segment
      Segment.identify(properties.userId_, {});
      Segment.logEvent("User Identified", {
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Feed Item Viewed: This event is triggered whenever the user lands on the homepage and the feed is visible or when the user scrolls to a feed item.

event_properties:
- event_location: Feed
- event_type: None
- event_cta: None


Notes:
- product_ids is the list of product visible on the feed item
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {int} properties.feedSessionId - This is the session number for the user's current feed session.

We keep incrementing the session number over time as the user returns to Feed even if the user has run out of the first 30 sessions of planned Feed content in Contentful. (This allowed us to easily continue showing WbW and priority items beyond the first 30 sessions.) If we have 30 planned sessions of content and you're at session 40, then yeah, session 30 would be the last planned session you saw in your feed. WbW and priority items could get added to your feed between session 30 and 40. Otherwise session 30 would still appear at the top of your feed.
   * @param {string} properties.feedItemId - This is the contentful ID for the Feed Card.
   * @param {int} properties.feedItemSession - This is the session id that the item originally appeared on in the user's feed.

e.g. My user is currently at session 40. I scroll down feed and tap an item that appeared in session 20. feed_session_id would be 40 and item_session would be 20.
   * @param {string} properties.feedItemTitle - Title on the Feed Card that the user viewed or clicked
   * @param {string} properties.feedItemType - This is the type of feed card (Guide, WeekbyWeek, Welcome, Product, Video, etc).
   * @param {string} [properties.productRecommenderModelVersion] - A model version from the data API for a set of recommended products.
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/lPyfNffAeF}
   */
  function feedItemViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertFeedSessionId(properties.feedSessionId));
      messages = messages.concat(assertFeedItemId(properties.feedItemId));
      messages = messages.concat(assertFeedItemSession(properties.feedItemSession));
      messages = messages.concat(assertFeedItemTitle(properties.feedItemTitle));
      messages = messages.concat(assertFeedItemType(properties.feedItemType));
      messages = messages.concat(assertOptionalProductRecommenderModelVersion(properties.productRecommenderModelVersion));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "lPyfNffAeF", "744a508c6222a5da696e9be20cde35bfe685a679f0c9482237f4205b0b18ae20", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Feed Item Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "feed_session_id": properties.feedSessionId,
        "feed_item_id": properties.feedItemId,
        "feed_item_session": properties.feedItemSession,
        "feed_item_title": properties.feedItemTitle,
        "feed_item_type": properties.feedItemType,
        "product_recommender_model_version": properties.productRecommenderModelVersion,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("lPyfNffAeF", "Feed Item Viewed", messages, [
        {id: "05bQiKNQ-0", name: "feed_item_title", value: properties.feedItemTitle},
        {id: "40T5ce69rV", name: "feed_item_type", value: properties.feedItemType},
        {id: "7PziKxGyrH", name: "feed_session_id", value: properties.feedSessionId},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "HfvztBLQ9W", name: "feed_item_id", value: properties.feedItemId},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KNpC1hHEmV", name: "feed_item_session", value: properties.feedItemSession},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "YQ72-3ABf", name: "product_recommender_model_version", value: properties.productRecommenderModelVersion},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Feed Item Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Feed Item Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "feed_session_id": properties.feedSessionId,
          "feed_item_id": properties.feedItemId,
          "feed_item_session": properties.feedItemSession,
          "feed_item_title": properties.feedItemTitle,
          "feed_item_type": properties.feedItemType,
          "product_recommender_model_version": properties.productRecommenderModelVersion,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "lPyfNffAeF", "744a508c6222a5da696e9be20cde35bfe685a679f0c9482237f4205b0b18ae20");
      }
      // destination Segment
      Segment.logEvent("Feed Item Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "feed_session_id": properties.feedSessionId,
        "feed_item_id": properties.feedItemId,
        "feed_item_session": properties.feedItemSession,
        "feed_item_title": properties.feedItemTitle,
        "feed_item_type": properties.feedItemType,
        "product_recommender_model_version": properties.productRecommenderModelVersion,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Feed Item Clicked: This event is triggered when the user clicks on a feed content card.

event_properties:
- event_location: Feed
- event_type: Product Click | None
- event_cta: None

Notes:
- product_ids is the list of product visible on the feed item
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {int} properties.feedSessionId - This is the session number for the user's current feed session.

We keep incrementing the session number over time as the user returns to Feed even if the user has run out of the first 30 sessions of planned Feed content in Contentful. (This allowed us to easily continue showing WbW and priority items beyond the first 30 sessions.) If we have 30 planned sessions of content and you're at session 40, then yeah, session 30 would be the last planned session you saw in your feed. WbW and priority items could get added to your feed between session 30 and 40. Otherwise session 30 would still appear at the top of your feed.
   * @param {string} properties.feedItemId - This is the contentful ID for the Feed Card.
   * @param {int} properties.feedItemSession - This is the session id that the item originally appeared on in the user's feed.

e.g. My user is currently at session 40. I scroll down feed and tap an item that appeared in session 20. feed_session_id would be 40 and item_session would be 20.
   * @param {string} properties.feedItemTitle - Title on the Feed Card that the user viewed or clicked
   * @param {string} properties.feedItemType - This is the type of feed card (Guide, WeekbyWeek, Welcome, Product, Video, etc).
   * @param {string} [properties.productRecommenderModelVersion] - A model version from the data API for a set of recommended products.
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/UvX0RKxo1B}
   */
  function feedItemClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertFeedSessionId(properties.feedSessionId));
      messages = messages.concat(assertFeedItemId(properties.feedItemId));
      messages = messages.concat(assertFeedItemSession(properties.feedItemSession));
      messages = messages.concat(assertFeedItemTitle(properties.feedItemTitle));
      messages = messages.concat(assertFeedItemType(properties.feedItemType));
      messages = messages.concat(assertOptionalProductRecommenderModelVersion(properties.productRecommenderModelVersion));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UvX0RKxo1B", "fae2d83cf24ff1eca57e247cb9a73d63e43ef219b2ec78f7c059ccc7add7d6b4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Feed Item Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "feed_session_id": properties.feedSessionId,
        "feed_item_id": properties.feedItemId,
        "feed_item_session": properties.feedItemSession,
        "feed_item_title": properties.feedItemTitle,
        "feed_item_type": properties.feedItemType,
        "product_recommender_model_version": properties.productRecommenderModelVersion,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UvX0RKxo1B", "Feed Item Clicked", messages, [
        {id: "05bQiKNQ-0", name: "feed_item_title", value: properties.feedItemTitle},
        {id: "40T5ce69rV", name: "feed_item_type", value: properties.feedItemType},
        {id: "7PziKxGyrH", name: "feed_session_id", value: properties.feedSessionId},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "HfvztBLQ9W", name: "feed_item_id", value: properties.feedItemId},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KNpC1hHEmV", name: "feed_item_session", value: properties.feedItemSession},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "YQ72-3ABf", name: "product_recommender_model_version", value: properties.productRecommenderModelVersion},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Feed Item Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Feed Item Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "feed_session_id": properties.feedSessionId,
          "feed_item_id": properties.feedItemId,
          "feed_item_session": properties.feedItemSession,
          "feed_item_title": properties.feedItemTitle,
          "feed_item_type": properties.feedItemType,
          "product_recommender_model_version": properties.productRecommenderModelVersion,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "UvX0RKxo1B", "fae2d83cf24ff1eca57e247cb9a73d63e43ef219b2ec78f7c059ccc7add7d6b4");
      }
      // destination Segment
      Segment.logEvent("Feed Item Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "feed_session_id": properties.feedSessionId,
        "feed_item_id": properties.feedItemId,
        "feed_item_session": properties.feedItemSession,
        "feed_item_title": properties.feedItemTitle,
        "feed_item_type": properties.feedItemType,
        "product_recommender_model_version": properties.productRecommenderModelVersion,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Product Collection Clicked: This event is triggered when a user clicks on a product collection card on the store home page.


event_properties
- event_type: None
- event_location: Store
- event_cta: None

product_ids is ONLY the product id click on

   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.productCollectionId - ID for the product collections card
   * @param {string} properties.productCollectionTitle - Title for the product collections card
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/1rasUZJ8-t}
   */
  function productCollectionClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertProductCollectionId(properties.productCollectionId));
      messages = messages.concat(assertProductCollectionTitle(properties.productCollectionTitle));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "1rasUZJ8-t", "9fa91e232fcf0b48f8ca7d377b732a08b1eb784b97c5c999696b9de22f52caa1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Product Collection Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_collection_id": properties.productCollectionId,
        "product_collection_title": properties.productCollectionTitle,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("1rasUZJ8-t", "Product Collection Clicked", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "M9-9nF71Sp", name: "product_collection_id", value: properties.productCollectionId},
        {id: "QohJgPisdx", name: "product_collection_title", value: properties.productCollectionTitle},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Product Collection Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Collection Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "product_collection_id": properties.productCollectionId,
          "product_collection_title": properties.productCollectionTitle,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "1rasUZJ8-t", "9fa91e232fcf0b48f8ca7d377b732a08b1eb784b97c5c999696b9de22f52caa1");
      }
      // destination Segment
      Segment.logEvent("Product Collection Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_collection_id": properties.productCollectionId,
        "product_collection_title": properties.productCollectionTitle,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Product Collection Viewed: This event is triggered when a user scrolls over or views a product collection card on the store home page.

event_properties
- event_type: None
- event_location: Store
- event_cta: None
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.productCollectionId - ID for the product collections card
   * @param {string} properties.productCollectionTitle - Title for the product collections card
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/hdR_OgIPz4}
   */
  function productCollectionViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertProductCollectionId(properties.productCollectionId));
      messages = messages.concat(assertProductCollectionTitle(properties.productCollectionTitle));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hdR_OgIPz4", "85baf6dabb208ed2da9900c6565dcfbb8da515917663bbe73d184438f4b80ea1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Product Collection Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_collection_id": properties.productCollectionId,
        "product_collection_title": properties.productCollectionTitle,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hdR_OgIPz4", "Product Collection Viewed", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "M9-9nF71Sp", name: "product_collection_id", value: properties.productCollectionId},
        {id: "QohJgPisdx", name: "product_collection_title", value: properties.productCollectionTitle},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Product Collection Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Collection Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "product_collection_id": properties.productCollectionId,
          "product_collection_title": properties.productCollectionTitle,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "hdR_OgIPz4", "85baf6dabb208ed2da9900c6565dcfbb8da515917663bbe73d184438f4b80ea1");
      }
      // destination Segment
      Segment.logEvent("Product Collection Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_collection_id": properties.productCollectionId,
        "product_collection_title": properties.productCollectionTitle,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * PDP Viewed: This event is triggered as soon as the PDP is displayed.

event_properties:
event_type: None
event_cta: None
event_location: PDP

   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {float} properties.productPrice - Price displayed for the product
   * @param {string} properties.productType - Type of the product
   * @param {bool} [properties.isFsaHsaEligible] - This property describes whether a product is eligible for FSA/HSA.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {string} [properties.searchId] - ID of Algolia query which generated the original list of search results. Used by Algolia to attribute an event to a specific query for click conversion metrics. Segment maps this property to Algolia event.queryID in Algolia Insights destination.
   * @param {bool} [properties.inStockSoonMessage] - Indicates whether the "in stock soon" message was displayed on the PDP at time of view.
   * @param {bool} [properties.getNotifiedWhenThisIsInStockMessage] - Indicates whether the 'in stock notification' link is available. This offer is not universally displayed for OOS products (e.g. virtual bundles).
   * @param {string} [properties.searchPreviewIds] - This event property is a JSON string describing the Algolia Ids which generated the search preview results. Each Algolia Id corresponds to a different Algolia index. The JSON string should be encoded in the following format:

{"AlgoliaIndexName": "AlgoliaId", "AlgoliaIndexName": "AlgoliaId", "AlgoliaIndexName": "AlgoliaId"}
   * @param {string} [properties.pdpType] - We have several different PDP variations. This will give us insight into which variation of the PDP the user is currently on.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/eY3-lmHD8S}
   */
  function pdpViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertProductPrice(properties.productPrice));
      messages = messages.concat(assertProductType(properties.productType));
      messages = messages.concat(assertOptionalIsFsaHsaEligible(properties.isFsaHsaEligible));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalSearchId(properties.searchId));
      messages = messages.concat(assertOptionalInStockSoonMessage(properties.inStockSoonMessage));
      messages = messages.concat(assertOptionalGetNotifiedWhenThisIsInStockMessage(properties.getNotifiedWhenThisIsInStockMessage));
      messages = messages.concat(assertOptionalSearchPreviewIds(properties.searchPreviewIds));
      messages = messages.concat(assertOptionalPdpType(properties.pdpType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "eY3-lmHD8S", "dab755653b58c560036e910eb47f9f50547778ad022801065c1241078fad35ea", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("PDP Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "store_name": properties.storeName,
        "product_ids": properties.productIds,
        "search_id": properties.searchId,
        "in_stock_soon_message": properties.inStockSoonMessage,
        "get_notified_when_this_is_in_stock_message": properties.getNotifiedWhenThisIsInStockMessage,
        "search_preview_ids": properties.searchPreviewIds,
        "pdp_type": properties.pdpType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("eY3-lmHD8S", "PDP Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "FymJ-MEah", name: "in_stock_soon_message", value: properties.inStockSoonMessage},
        {id: "Gd7BtoYo_", name: "get_notified_when_this_is_in_stock_message", value: properties.getNotifiedWhenThisIsInStockMessage},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "VlL55_rwx1", name: "search_id", value: properties.searchId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "eVYsq2XJU", name: "search_preview_ids", value: properties.searchPreviewIds},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "h12bnVZfao", name: "pdp_type", value: properties.pdpType},
        {id: "hHOUpzCIx2", name: "product_price", value: properties.productPrice},
        {id: "hh5IW9vG8X", name: "product_type", value: properties.productType},
        {id: "kN_aicHWKA", name: "is_fsa_hsa_eligible", value: properties.isFsaHsaEligible},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'PDP Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("PDP Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "product_price": properties.productPrice,
          "product_type": properties.productType,
          "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "store_name": properties.storeName,
          "product_ids": properties.productIds,
          "search_id": properties.searchId,
          "in_stock_soon_message": properties.inStockSoonMessage,
          "get_notified_when_this_is_in_stock_message": properties.getNotifiedWhenThisIsInStockMessage,
          "search_preview_ids": properties.searchPreviewIds,
          "pdp_type": properties.pdpType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "eY3-lmHD8S", "dab755653b58c560036e910eb47f9f50547778ad022801065c1241078fad35ea");
      }
      // destination Segment
      Segment.logEvent("PDP Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "store_name": properties.storeName,
        "product_ids": properties.productIds,
        "search_id": properties.searchId,
        "in_stock_soon_message": properties.inStockSoonMessage,
        "get_notified_when_this_is_in_stock_message": properties.getNotifiedWhenThisIsInStockMessage,
        "search_preview_ids": properties.searchPreviewIds,
        "pdp_type": properties.pdpType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Guide Viewed: This event is triggered when the user views a specific guide post

event_properties
- event_type: None
- event_location: Guide
- event_cta: None
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.postId - Contentful ID for the Guide post
   * @param {string} properties.postType - Guide post type
   * @param {int} properties.postRevision - Guide post revision number
   * @param {string} properties.postSlug - Guide post URL slug
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {Array<string>} [properties.guideTopics] - This property contains the topics assigned to a Hello Baby guide
   * @param {string} [properties.searchId] - ID of Algolia query which generated the original list of search results. Used by Algolia to attribute an event to a specific query for click conversion metrics. Segment maps this property to Algolia event.queryID in Algolia Insights destination.
   * @param {string} [properties.searchPreviewIds] - This event property is a JSON string describing the Algolia Ids which generated the search preview results. Each Algolia Id corresponds to a different Algolia index. The JSON string should be encoded in the following format:

{"AlgoliaIndexName": "AlgoliaId", "AlgoliaIndexName": "AlgoliaId", "AlgoliaIndexName": "AlgoliaId"}
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/prwQgwZE8s}
   */
  function guideViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertPostId(properties.postId));
      messages = messages.concat(assertPostType(properties.postType));
      messages = messages.concat(assertPostRevision(properties.postRevision));
      messages = messages.concat(assertPostSlug(properties.postSlug));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalGuideTopics(properties.guideTopics));
      messages = messages.concat(assertOptionalSearchId(properties.searchId));
      messages = messages.concat(assertOptionalSearchPreviewIds(properties.searchPreviewIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "prwQgwZE8s", "aebf611e9375193a22f25bc18284ad5413aa67299ea18d3e460b231c8338eee2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Guide Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "post_id": properties.postId,
        "post_type": properties.postType,
        "post_revision": properties.postRevision,
        "post_slug": properties.postSlug,
        "product_ids": properties.productIds,
        "Guide Topics": properties.guideTopics,
        "search_id": properties.searchId,
        "search_preview_ids": properties.searchPreviewIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("prwQgwZE8s", "Guide Viewed", messages, [
        {id: "94vyME35Ha", name: "post_type", value: properties.postType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "G6bkpcJWx", name: "Guide Topics", value: properties.guideTopics},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "VlL55_rwx1", name: "search_id", value: properties.searchId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "eVYsq2XJU", name: "search_preview_ids", value: properties.searchPreviewIds},
        {id: "nFzKmDrJrr", name: "post_slug", value: properties.postSlug},
        {id: "tVeza_1Hvq", name: "post_revision", value: properties.postRevision},
        {id: "yI66F6Raat", name: "post_id", value: properties.postId},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Guide Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Guide Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "post_id": properties.postId,
          "post_type": properties.postType,
          "post_revision": properties.postRevision,
          "post_slug": properties.postSlug,
          "product_ids": properties.productIds,
          "Guide Topics": properties.guideTopics,
          "search_id": properties.searchId,
          "search_preview_ids": properties.searchPreviewIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "prwQgwZE8s", "aebf611e9375193a22f25bc18284ad5413aa67299ea18d3e460b231c8338eee2");
      }
      // destination Segment
      Segment.logEvent("Guide Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "post_id": properties.postId,
        "post_type": properties.postType,
        "post_revision": properties.postRevision,
        "post_slug": properties.postSlug,
        "product_ids": properties.productIds,
        "Guide Topics": properties.guideTopics,
        "search_id": properties.searchId,
        "search_preview_ids": properties.searchPreviewIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Store Landing Viewed: This event when user browse the store landing page -> https://babylist.com/store

event properties
- event_cta: None
- event_location: Store
- event_type: None
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/ilel9buada}
   */
  function storeLandingViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ilel9buada", "bf36729fd63f6f471fd0bbdd5c0f325fbbc6bc38b14e9fe072be41b63fb3c5aa", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Store Landing Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ilel9buada", "Store Landing Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Store Landing Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Store Landing Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "ilel9buada", "bf36729fd63f6f471fd0bbdd5c0f325fbbc6bc38b14e9fe072be41b63fb3c5aa");
      }
      // destination Segment
      Segment.logEvent("Store Landing Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Store Search Viewed: DEPRECATED IN FAVOR of Search Results Page Viewed

This event is triggered when the user hits enter after typing in a search string into the search bar on the store page.

event_properties
- event_type: None
- event_cta: None
- event_location: Store
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.storeSearchTerms - This is the search string that the user typed into the store search bar
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/crH-WSzN_H}
   */
  function storeSearchViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertStoreSearchTerms(properties.storeSearchTerms));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "crH-WSzN_H", "94fe0ff11a33c0e4905daef58d72557a94814d87f453fa8ccc37e5b888da9f5d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Store Search Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "store_search_terms": properties.storeSearchTerms,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("crH-WSzN_H", "Store Search Viewed", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "GEjpAADWrj", name: "store_search_terms", value: properties.storeSearchTerms},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Store Search Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Store Search Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "store_search_terms": properties.storeSearchTerms,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "crH-WSzN_H", "94fe0ff11a33c0e4905daef58d72557a94814d87f453fa8ccc37e5b888da9f5d");
      }
      // destination Segment
      Segment.logEvent("Store Search Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "store_search_terms": properties.storeSearchTerms,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Store Category Viewed: This event is triggered when a store category is displayed (regardless of where the action is initiated, so after user click on store top nav category, left hand nav, right sub category images)

event_properties
- event_type: None
- event_location: Store
- event_cta: None
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.storeCategoryName - Name of the store category that the user clicked on inside the left hand or top nav
   * @param {bool} properties.isLeafCategory - no description
   * @param {string} properties.storeCategorySlug - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/HYcvrkRjQH}
   */
  function storeCategoryViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertStoreCategoryName(properties.storeCategoryName));
      messages = messages.concat(assertIsLeafCategory(properties.isLeafCategory));
      messages = messages.concat(assertStoreCategorySlug(properties.storeCategorySlug));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "HYcvrkRjQH", "ad20b0f51edd3e7a8b013e91f73baa1d468e9e81ef0c076d0956e2265d6a3ce8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Store Category Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "store_category_name": properties.storeCategoryName,
        "is_leaf_category": properties.isLeafCategory,
        "store_category_slug": properties.storeCategorySlug,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("HYcvrkRjQH", "Store Category Viewed", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IT3W1-U_HY", name: "store_category_name", value: properties.storeCategoryName},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "l-ZBlkTiq4", name: "is_leaf_category", value: properties.isLeafCategory},
        {id: "yyDNRm_pnV", name: "store_category_slug", value: properties.storeCategorySlug},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Store Category Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Store Category Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "store_category_name": properties.storeCategoryName,
          "is_leaf_category": properties.isLeafCategory,
          "store_category_slug": properties.storeCategorySlug,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "HYcvrkRjQH", "ad20b0f51edd3e7a8b013e91f73baa1d468e9e81ef0c076d0956e2265d6a3ce8");
      }
      // destination Segment
      Segment.logEvent("Store Category Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "store_category_name": properties.storeCategoryName,
        "is_leaf_category": properties.isLeafCategory,
        "store_category_slug": properties.storeCategorySlug,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Product Clicked: This event is triggered when the user clicks anywhere on a single product card within Feed, Store, Store Search, Guide or Next Add including Babylist Health

This includes clicking on the "+" button i.e. Quick Add.

This is the step that leads to the PDP page. Note that when the event is fired from Feed for an item that is sold at multiple stores including Babylist, it leads into the Store Picked Modal.

event_properties
- event_cta: None
- event_location: Feed | Guide | Next Add Recommender | Registry | Cart | Store - Search | Store - Category | Store - Product Collections | Store - Product Card Quick View
- event_type: None | Quick Add | Click


Required: Feed | Guide | Next Add Recommender | Store (category / search terms)



   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {float} properties.productPrice - Price displayed for the product
   * @param {string} properties.productType - Type of the product
   * @param {bool} [properties.isFsaHsaEligible] - This property describes whether a product is eligible for FSA/HSA.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {int} [properties.positionInList] - Position of object in a list of objects. Position starts at 1.

Use Cases:
- Used to calculate average click position in Algolia. Segment maps this property to Algolia event.positions in Algolia Insights destination.
- To determine the position of a message in Message Center

   * @param {string} [properties.searchId] - ID of Algolia query which generated the original list of search results. Used by Algolia to attribute an event to a specific query for click conversion metrics. Segment maps this property to Algolia event.queryID in Algolia Insights destination.
   * @param {int} [properties.rank] - The ranks represents the n-th index of the product that clicked on. For example, if the 5th product on the UI was clicked by a user, the rank value is 5.
   * @param {bool} [properties.isSponsoredProduct] - Whether or not the product was sponsored.
   * @param {string} [properties.searchPreviewIds] - This event property is a JSON string describing the Algolia Ids which generated the search preview results. Each Algolia Id corresponds to a different Algolia index. The JSON string should be encoded in the following format:

{"AlgoliaIndexName": "AlgoliaId", "AlgoliaIndexName": "AlgoliaId", "AlgoliaIndexName": "AlgoliaId"}
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/UB5o2WG-oa}
   */
  function productClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertProductPrice(properties.productPrice));
      messages = messages.concat(assertProductType(properties.productType));
      messages = messages.concat(assertOptionalIsFsaHsaEligible(properties.isFsaHsaEligible));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalPositionInList(properties.positionInList));
      messages = messages.concat(assertOptionalSearchId(properties.searchId));
      messages = messages.concat(assertOptionalRank(properties.rank));
      messages = messages.concat(assertOptionalIsSponsoredProduct(properties.isSponsoredProduct));
      messages = messages.concat(assertOptionalSearchPreviewIds(properties.searchPreviewIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UB5o2WG-oa", "291e8901bec8d8bd780fa62541afd3ff7fcc0b8c3ec079187c842ae33b5d721f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Product Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "store_name": properties.storeName,
        "product_ids": properties.productIds,
        "position_in_list": properties.positionInList,
        "search_id": properties.searchId,
        "rank": properties.rank,
        "is_sponsored_product": properties.isSponsoredProduct,
        "search_preview_ids": properties.searchPreviewIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UB5o2WG-oa", "Product Clicked", messages, [
        {id: "11Ict5JuI9", name: "rank", value: properties.rank},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "9hIUmuT0nS", name: "position_in_list", value: properties.positionInList},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "VlL55_rwx1", name: "search_id", value: properties.searchId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "eVYsq2XJU", name: "search_preview_ids", value: properties.searchPreviewIds},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "hHOUpzCIx2", name: "product_price", value: properties.productPrice},
        {id: "hh5IW9vG8X", name: "product_type", value: properties.productType},
        {id: "kN_aicHWKA", name: "is_fsa_hsa_eligible", value: properties.isFsaHsaEligible},
        {id: "vtBpfRY_B", name: "is_sponsored_product", value: properties.isSponsoredProduct},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Product Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "product_price": properties.productPrice,
          "product_type": properties.productType,
          "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "store_name": properties.storeName,
          "product_ids": properties.productIds,
          "position_in_list": properties.positionInList,
          "search_id": properties.searchId,
          "rank": properties.rank,
          "is_sponsored_product": properties.isSponsoredProduct,
          "search_preview_ids": properties.searchPreviewIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "UB5o2WG-oa", "291e8901bec8d8bd780fa62541afd3ff7fcc0b8c3ec079187c842ae33b5d721f");
      }
      // destination Segment
      Segment.logEvent("Product Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "store_name": properties.storeName,
        "product_ids": properties.productIds,
        "position_in_list": properties.positionInList,
        "search_id": properties.searchId,
        "rank": properties.rank,
        "is_sponsored_product": properties.isSponsoredProduct,
        "search_preview_ids": properties.searchPreviewIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Add Modal Clicked: (OPTIONAL) This event fires when the user clicks on the Add to Babylist modal that opens when clicking on a product on Guide. The modal is called "Add to Babylist".

event_properties
- event_location: Guide | Babylist Button
- event_type: none
- event_cta: Cancel | Add to Babylist


   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {float} properties.productPrice - Price displayed for the product
   * @param {string} properties.productType - Type of the product
   * @param {bool} [properties.isFsaHsaEligible] - This property describes whether a product is eligible for FSA/HSA.
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/7bVzLu_clO}
   */
  function registryAddModalClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertProductPrice(properties.productPrice));
      messages = messages.concat(assertProductType(properties.productType));
      messages = messages.concat(assertOptionalIsFsaHsaEligible(properties.isFsaHsaEligible));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "7bVzLu_clO", "e51f6abb97ef414cf71b556b6fab886bcc2fc70fa699440f8879acd53c2409a3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Add Modal Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("7bVzLu_clO", "Registry Add Modal Clicked", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "hHOUpzCIx2", name: "product_price", value: properties.productPrice},
        {id: "hh5IW9vG8X", name: "product_type", value: properties.productType},
        {id: "kN_aicHWKA", name: "is_fsa_hsa_eligible", value: properties.isFsaHsaEligible},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Add Modal Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Add Modal Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "product_price": properties.productPrice,
          "product_type": properties.productType,
          "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "7bVzLu_clO", "e51f6abb97ef414cf71b556b6fab886bcc2fc70fa699440f8879acd53c2409a3");
      }
      // destination Segment
      Segment.logEvent("Registry Add Modal Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Next Add Viewed: This event is fired when the user sees the Next Add Recommendation modal.

event_properties
- event_type: None
- event_location: PDP
- event_cta: None

product ids is the list of the next to add

   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/KR3uZAJR6r}
   */
  function nextAddViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "KR3uZAJR6r", "10a22a833ef5d8b672ede4d95f3a68e9d3f7feab2daa8ca9746583d5452d1e36", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Next Add Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("KR3uZAJR6r", "Next Add Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Next Add Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Next Add Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "KR3uZAJR6r", "10a22a833ef5d8b672ede4d95f3a68e9d3f7feab2daa8ca9746583d5452d1e36");
      }
      // destination Segment
      Segment.logEvent("Next Add Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Guide Clicked: This event is triggered when the user clicks a link while on a guide

event_properties
- event_location: Guide
- event_cta: Guide
- event_type: None

when clicking on a product:
- event_type: Product Clicked
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.postId - Contentful ID for the Guide post
   * @param {string} properties.postType - Guide post type
   * @param {int} properties.postRevision - Guide post revision number
   * @param {string} properties.postSlug - Guide post URL slug
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {int} [properties.positionInList] - Position of object in a list of objects. Position starts at 1.

Use Cases:
- Used to calculate average click position in Algolia. Segment maps this property to Algolia event.positions in Algolia Insights destination.
- To determine the position of a message in Message Center

   * @param {string} [properties.searchId] - ID of Algolia query which generated the original list of search results. Used by Algolia to attribute an event to a specific query for click conversion metrics. Segment maps this property to Algolia event.queryID in Algolia Insights destination.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/ZSw1bBIXC_}
   */
  function guideClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPostId(properties.postId));
      messages = messages.concat(assertPostType(properties.postType));
      messages = messages.concat(assertPostRevision(properties.postRevision));
      messages = messages.concat(assertPostSlug(properties.postSlug));
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalPositionInList(properties.positionInList));
      messages = messages.concat(assertOptionalSearchId(properties.searchId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ZSw1bBIXC_", "a5f1d26401411ad4c4ef3f158de246f2d5eb58a8b3a6c6fb1c5557284ff4d219", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Guide Clicked", {
        "post_id": properties.postId,
        "post_type": properties.postType,
        "post_revision": properties.postRevision,
        "post_slug": properties.postSlug,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "store_name": properties.storeName,
        "product_ids": properties.productIds,
        "position_in_list": properties.positionInList,
        "search_id": properties.searchId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ZSw1bBIXC_", "Guide Clicked", messages, [
        {id: "94vyME35Ha", name: "post_type", value: properties.postType},
        {id: "9hIUmuT0nS", name: "position_in_list", value: properties.positionInList},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "VlL55_rwx1", name: "search_id", value: properties.searchId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "nFzKmDrJrr", name: "post_slug", value: properties.postSlug},
        {id: "tVeza_1Hvq", name: "post_revision", value: properties.postRevision},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "yI66F6Raat", name: "post_id", value: properties.postId},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Guide Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Guide Clicked", {
          "post_id": properties.postId,
          "post_type": properties.postType,
          "post_revision": properties.postRevision,
          "post_slug": properties.postSlug,
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "store_name": properties.storeName,
          "product_ids": properties.productIds,
          "position_in_list": properties.positionInList,
          "search_id": properties.searchId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "ZSw1bBIXC_", "a5f1d26401411ad4c4ef3f158de246f2d5eb58a8b3a6c6fb1c5557284ff4d219");
      }
      // destination Segment
      Segment.logEvent("Guide Clicked", {
        "post_id": properties.postId,
        "post_type": properties.postType,
        "post_revision": properties.postRevision,
        "post_slug": properties.postSlug,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "store_name": properties.storeName,
        "product_ids": properties.productIds,
        "position_in_list": properties.positionInList,
        "search_id": properties.searchId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Filters Panel Toggled: This event is triggered when opening the product filters on a PLP.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {bool} properties.isOpen - no description
   * @param {string} [properties.focusedSection] - no description
   * @param {string} [properties.storeCategorySlug] - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/aDgyEylYqj}
   */
  function filtersPanelToggled(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertIsOpen(properties.isOpen));
      messages = messages.concat(assertOptionalFocusedSection(properties.focusedSection));
      messages = messages.concat(assertOptionalStoreCategorySlug(properties.storeCategorySlug));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "aDgyEylYqj", "e93685203e063db0519458fae4dc3939488b3cd1585a374302a8d03c246a9a46", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Filters Panel Toggled", {
        "is_open": properties.isOpen,
        "focused_section": properties.focusedSection,
        "store_category_slug": properties.storeCategorySlug,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("aDgyEylYqj", "Filters Panel Toggled", messages, [
        {id: "gOgPFKH8H1", name: "focused_section", value: properties.focusedSection},
        {id: "mSLIa7zt_t", name: "is_open", value: properties.isOpen},
        {id: "yyDNRm_pnV", name: "store_category_slug", value: properties.storeCategorySlug},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Filters Panel Toggled': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Filters Panel Toggled", {
          "is_open": properties.isOpen,
          "focused_section": properties.focusedSection,
          "store_category_slug": properties.storeCategorySlug,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "aDgyEylYqj", "e93685203e063db0519458fae4dc3939488b3cd1585a374302a8d03c246a9a46");
      }
      // destination Segment
      Segment.logEvent("Filters Panel Toggled", {
        "is_open": properties.isOpen,
        "focused_section": properties.focusedSection,
        "store_category_slug": properties.storeCategorySlug,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Filters Applied: Fired when a user sorts/filters the products in the store
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {string} properties.filters - no description
   * @param {string} [properties.sortOrder] - no description
   * @param {string} [properties.sortCriteria] - no description
   * @param {string} [properties.storeCategorySlug] - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/3LI_7I9lVr}
   */
  function filtersApplied(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertFilters(properties.filters));
      messages = messages.concat(assertOptionalSortOrder(properties.sortOrder));
      messages = messages.concat(assertOptionalSortCriteria(properties.sortCriteria));
      messages = messages.concat(assertOptionalStoreCategorySlug(properties.storeCategorySlug));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "3LI_7I9lVr", "b137ba44b2ed489a7d1e56c5d87fb3f564e826b569c87150ffe3fb19ae4174a8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Filters Applied", {
        "store_name": properties.storeName,
        "filters": properties.filters,
        "sort_order": properties.sortOrder,
        "sort_criteria": properties.sortCriteria,
        "store_category_slug": properties.storeCategorySlug,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("3LI_7I9lVr", "Filters Applied", messages, [
        {id: "4K1X2mTbIS", name: "filters", value: properties.filters},
        {id: "LAMqRUVdxT", name: "sort_criteria", value: properties.sortCriteria},
        {id: "rTzwntEiBQ", name: "sort_order", value: properties.sortOrder},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "yyDNRm_pnV", name: "store_category_slug", value: properties.storeCategorySlug},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Filters Applied': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Filters Applied", {
          "store_name": properties.storeName,
          "filters": properties.filters,
          "sort_order": properties.sortOrder,
          "sort_criteria": properties.sortCriteria,
          "store_category_slug": properties.storeCategorySlug,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "3LI_7I9lVr", "b137ba44b2ed489a7d1e56c5d87fb3f564e826b569c87150ffe3fb19ae4174a8");
      }
      // destination Segment
      Segment.logEvent("Filters Applied", {
        "store_name": properties.storeName,
        "filters": properties.filters,
        "sort_order": properties.sortOrder,
        "sort_criteria": properties.sortCriteria,
        "store_category_slug": properties.storeCategorySlug,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Purchase Confirmed: This event is triggered when a user confirms a purchase. The CTA is typically a checkbox next to the word "Purchased".

NOTE: There is a very similar event which is Reservation Updated with a property of marked_as_purchased. This new specific Purchase Confirmed event was created because Reg Owners do NOT first "reserve" an item and then update the reservation. The reservation gets *created* when the user confirms purchase.

• event_cta: Purchased
• event_location: Shop Registry | Reg Item Detail Screen | Cart Detail Page
• event_type: Mark as Purchased
• reg_item_ids: [value]
• reg_item_quantity: [value]
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {Array<int>} [properties.regItemIds] - This is the targeted list of reg item ids. For events that operate on a single product like Added to Registry, it is a list of 1 reg_item_id.
   * @param {int} properties.regItemQuantity - Registry item quantity
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/wxVqVkruDU}
   */
  function purchaseConfirmed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalRegItemIds(properties.regItemIds));
      messages = messages.concat(assertRegItemQuantity(properties.regItemQuantity));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wxVqVkruDU", "662e1e8b96c4a0b4425e88ef46889c8083e97da1c3af827d64866311b5e8ac02", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Purchase Confirmed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "reg_item_ids": properties.regItemIds,
        "reg_item_quantity": properties.regItemQuantity,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wxVqVkruDU", "Purchase Confirmed", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "_IP9QswtZC", name: "reg_item_quantity", value: properties.regItemQuantity},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "w4Er1Tq_Sl", name: "reg_item_ids", value: properties.regItemIds},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Purchase Confirmed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Purchase Confirmed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "reg_item_ids": properties.regItemIds,
          "reg_item_quantity": properties.regItemQuantity,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "wxVqVkruDU", "662e1e8b96c4a0b4425e88ef46889c8083e97da1c3af827d64866311b5e8ac02");
      }
      // destination Segment
      Segment.logEvent("Purchase Confirmed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "reg_item_ids": properties.regItemIds,
        "reg_item_quantity": properties.regItemQuantity,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Product Review Started: Action:
- This event is triggered when the user clicks the "write a review" button on a PDP (it's actually when TurnTo ask us if the user is logged in, which happen when a user start a review/question/answer... -> https://docs.turnto.com/en/speedflex-widget-implementation/authentication/speedflex-single-sign-on--sso--integration.html#step-3--get-details-about-the-logged-in-user)
- event_location: [PDP, Review Listings Page, Gift Tracker]
- event_type: None
- event_cta: None

Apps:
This event is fired when a user presses "write a review" button which opens the modal web view.
- event_location: PDP | Review List Page | Gift Tracker
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {bool} properties.userLoggedIn - indicate wether the user/actor is logged in at the time of the event
   * @param {string} [properties.pdpType] - We have several different PDP variations. This will give us insight into which variation of the PDP the user is currently on.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/_dLn8aFatJ}
   */
  function productReviewStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertUserLoggedIn(properties.userLoggedIn));
      messages = messages.concat(assertOptionalPdpType(properties.pdpType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "_dLn8aFatJ", "cc5dce25e100b26950eada1900b902fcca6dd638f779bb89c91e301a04a00f63", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Product Review Started", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_ids": properties.productIds,
        "user_logged_in": properties.userLoggedIn,
        "pdp_type": properties.pdpType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("_dLn8aFatJ", "Product Review Started", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "h12bnVZfao", name: "pdp_type", value: properties.pdpType},
        {id: "kwcveeFcRU", name: "user_logged_in", value: properties.userLoggedIn},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Product Review Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Review Started", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "product_ids": properties.productIds,
          "user_logged_in": properties.userLoggedIn,
          "pdp_type": properties.pdpType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "_dLn8aFatJ", "cc5dce25e100b26950eada1900b902fcca6dd638f779bb89c91e301a04a00f63");
      }
      // destination Segment
      Segment.logEvent("Product Review Started", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_ids": properties.productIds,
        "user_logged_in": properties.userLoggedIn,
        "pdp_type": properties.pdpType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Product Review Completed: Action:
- This event is triggered when the user complete a review (ie.: https://docs.turnto.com/en/speedflex-widget-implementation/event-callbacks.html#event-handlers).
- event_location: [PDP, Review Listings Page, Gift Tracker]
- event_type: None
- event_cta: None

NOTE: there is a bug on TurnTo side, so we currently DO NOT have any callback on review Completion. So we've move this event to be triggered just AFTER user logged (or is logged in) which happens just BEFORE TurnTo actually submit the review
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {string} [properties.pdpType] - We have several different PDP variations. This will give us insight into which variation of the PDP the user is currently on.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/V6zs4kA4F3}
   */
  function productReviewCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalPdpType(properties.pdpType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "V6zs4kA4F3", "f2d4a87047732ed1c9c1107d7e041bf15c9d0bcc565dc7a24f38a6b4646f6d9d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Product Review Completed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_ids": properties.productIds,
        "pdp_type": properties.pdpType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("V6zs4kA4F3", "Product Review Completed", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "h12bnVZfao", name: "pdp_type", value: properties.pdpType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Product Review Completed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Review Completed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "product_ids": properties.productIds,
          "pdp_type": properties.pdpType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "V6zs4kA4F3", "f2d4a87047732ed1c9c1107d7e041bf15c9d0bcc565dc7a24f38a6b4646f6d9d");
      }
      // destination Segment
      Segment.logEvent("Product Review Completed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_ids": properties.productIds,
        "pdp_type": properties.pdpType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Product Question Started: Action:
- This event is triggered when the user clicks the "submit" button on a PDP question form (it's actually when TurnTo ask us if the user is logged in, which happen when a user start a review/question/answer... -> https://docs.turnto.com/en/speedflex-widget-implementation/authentication/speedflex-single-sign-on--sso--integration.html#step-3--get-details-about-the-logged-in-user)
- event_location: PDP
- event_type: None
- event_cta: None

NOTE: there is NO user interaction between question started and question completed IF the user is already logged in -- as there is no UI

Apps:
This event is triggered when the user clicks "Submit a new question" button.
- event_location: Q&A Page
- event_type: None
- event_cta: None
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {bool} properties.userLoggedIn - indicate wether the user/actor is logged in at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/aVH7jqoLVi}
   */
  function productQuestionStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertUserLoggedIn(properties.userLoggedIn));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "aVH7jqoLVi", "3f52374b42a67abebfe9b0caf273b4cd4aae52094a9391a81de4a4e236b81cff", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Product Question Started", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_ids": properties.productIds,
        "user_logged_in": properties.userLoggedIn,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("aVH7jqoLVi", "Product Question Started", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "kwcveeFcRU", name: "user_logged_in", value: properties.userLoggedIn},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Product Question Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Question Started", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "product_ids": properties.productIds,
          "user_logged_in": properties.userLoggedIn,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "aVH7jqoLVi", "3f52374b42a67abebfe9b0caf273b4cd4aae52094a9391a81de4a4e236b81cff");
      }
      // destination Segment
      Segment.logEvent("Product Question Started", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_ids": properties.productIds,
        "user_logged_in": properties.userLoggedIn,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Product Question Completed: Action:
- This event is triggered when the user complete a question (ie.: https://docs.turnto.com/en/speedflex-widget-implementation/event-callbacks.html#event-handlers).
- event_location: PDP
- event_type: Non
- event_cta: None

NOTE: there is a bug on TurnTo side, so we currently DO NOT have any callback on review Completion. So we've move this event to be triggered just AFTER user logged (or is logged in) which happens just BEFORE TurnTo actually submit the review

Apps:
This event is triggered when the user clicks "Submit a new question" button.
- event_location: Q&A Page
- event_type: None
- event_cta: None
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/xZK0FcBQpH}
   */
  function productQuestionCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "xZK0FcBQpH", "4e730d571c76600f7b52b880078f2194b3724cdc5971eca6e8b54cee126a908a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Product Question Completed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("xZK0FcBQpH", "Product Question Completed", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Product Question Completed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Question Completed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "xZK0FcBQpH", "4e730d571c76600f7b52b880078f2194b3724cdc5971eca6e8b54cee126a908a");
      }
      // destination Segment
      Segment.logEvent("Product Question Completed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Log In Started: Trigger when user is prompt with a login flow (ie: show the login modal on web)
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/GBgYDFSpnc}
   */
  function logInStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "GBgYDFSpnc", "37add218208b79e1eb05d7173d6279340dacadfc93607455dd81a0706489b110", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Log In Started", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("GBgYDFSpnc", "Log In Started", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Log In Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Log In Started", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "GBgYDFSpnc", "37add218208b79e1eb05d7173d6279340dacadfc93607455dd81a0706489b110");
      }
      // destination Segment
      Segment.logEvent("Log In Started", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Sign Up Started: This event is triggered whenever the user see the first step of the signup flow (/registry/new)

event_properties:
- event_location: Onboarding
- event_type: None
- event_cta: None
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/Og0sXSyqu-}
   */
  function signUpStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Og0sXSyqu-", "e2b8692bc9c751e43c3bc46b946322cefc8e1bb5fcf40de3422e96ab9214bd07", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Sign Up Started", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Og0sXSyqu-", "Sign Up Started", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Sign Up Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Sign Up Started", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "Og0sXSyqu-", "e2b8692bc9c751e43c3bc46b946322cefc8e1bb5fcf40de3422e96ab9214bd07");
      }
      // destination Segment
      Segment.logEvent("Sign Up Started", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Diaper Calculator Option Selected: When a user selects one of the available options from any prompt on babylist.com/diaper-calculator.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.diaperCalculatorOptionText - The copy/label text of the selected option.
   * @param {string} properties.diaperCalculatorPromptText - The copy/prompt text of the question the selected option belongs to.
   * @param {int} properties.diaperCalculatorPromptIndex - The index or order the prompt appears in the set of prompts.
   * @param {int} properties.diaperCalculatorPromptTotalCount - The count of all prompts presented to the user.
   * @param {string} properties.diaperCalculatorOptionKey - A string name/identifier unique to an option/answer for a given prompt or question on babylist.com/diaper-calculator. Typically something like 'a', 'b' or 'c'.
   * @param {string} properties.diaperCalculatorPromptKey - Lower case name/identifier unique to a given prompt or question on babylist.com/diaper-calculator.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/grMsBue5Kj}
   */
  function diaperCalculatorOptionSelected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertDiaperCalculatorOptionText(properties.diaperCalculatorOptionText));
      messages = messages.concat(assertDiaperCalculatorPromptText(properties.diaperCalculatorPromptText));
      messages = messages.concat(assertDiaperCalculatorPromptIndex(properties.diaperCalculatorPromptIndex));
      messages = messages.concat(assertDiaperCalculatorPromptTotalCount(properties.diaperCalculatorPromptTotalCount));
      messages = messages.concat(assertDiaperCalculatorOptionKey(properties.diaperCalculatorOptionKey));
      messages = messages.concat(assertDiaperCalculatorPromptKey(properties.diaperCalculatorPromptKey));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "grMsBue5Kj", "10f3c03ecdbfa1c1a2ba7dbe34a62f5e177a4c2c2130ea8d8f24b4a1954b9bfd", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Diaper Calculator Option Selected", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "diaper_calculator_option_text": properties.diaperCalculatorOptionText,
        "diaper_calculator_prompt_text": properties.diaperCalculatorPromptText,
        "diaper_calculator_prompt_index": properties.diaperCalculatorPromptIndex,
        "diaper_calculator_prompt_total_count": properties.diaperCalculatorPromptTotalCount,
        "diaper_calculator_option_key": properties.diaperCalculatorOptionKey,
        "diaper_calculator_prompt_key": properties.diaperCalculatorPromptKey,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("grMsBue5Kj", "Diaper Calculator Option Selected", messages, [
        {id: "-pTGCR-Pa9", name: "diaper_calculator_prompt_total_count", value: properties.diaperCalculatorPromptTotalCount},
        {id: "1QOf3CIcKI", name: "diaper_calculator_prompt_index", value: properties.diaperCalculatorPromptIndex},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "GtjrRtlHJ_", name: "diaper_calculator_option_key", value: properties.diaperCalculatorOptionKey},
        {id: "Q3tkWMgoe5", name: "diaper_calculator_prompt_key", value: properties.diaperCalculatorPromptKey},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "yOclZpdxTw", name: "diaper_calculator_prompt_text", value: properties.diaperCalculatorPromptText},
        {id: "zbblqMkef3", name: "diaper_calculator_option_text", value: properties.diaperCalculatorOptionText},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Diaper Calculator Option Selected': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Diaper Calculator Option Selected", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "diaper_calculator_option_text": properties.diaperCalculatorOptionText,
          "diaper_calculator_prompt_text": properties.diaperCalculatorPromptText,
          "diaper_calculator_prompt_index": properties.diaperCalculatorPromptIndex,
          "diaper_calculator_prompt_total_count": properties.diaperCalculatorPromptTotalCount,
          "diaper_calculator_option_key": properties.diaperCalculatorOptionKey,
          "diaper_calculator_prompt_key": properties.diaperCalculatorPromptKey,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "grMsBue5Kj", "10f3c03ecdbfa1c1a2ba7dbe34a62f5e177a4c2c2130ea8d8f24b4a1954b9bfd");
      }
      // destination Segment
      Segment.logEvent("Diaper Calculator Option Selected", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "diaper_calculator_option_text": properties.diaperCalculatorOptionText,
        "diaper_calculator_prompt_text": properties.diaperCalculatorPromptText,
        "diaper_calculator_prompt_index": properties.diaperCalculatorPromptIndex,
        "diaper_calculator_prompt_total_count": properties.diaperCalculatorPromptTotalCount,
        "diaper_calculator_option_key": properties.diaperCalculatorOptionKey,
        "diaper_calculator_prompt_key": properties.diaperCalculatorPromptKey,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Diaper Calculator Result Viewed: When a user views a result page either by navigating directly to it or as a result from submitting the form on babylist.com/diaper-calculator.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.diaperCalculatorResultSlug - String slug unique to a given diaper calculator result.
   * @param {string} properties.diaperCalculatorResultName - String presentable name for a given diaper calculator result.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/wCVWgt-w8x}
   */
  function diaperCalculatorResultViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertDiaperCalculatorResultSlug(properties.diaperCalculatorResultSlug));
      messages = messages.concat(assertDiaperCalculatorResultName(properties.diaperCalculatorResultName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wCVWgt-w8x", "fa7ecb7703365b0f016ff1e7d8974d3bcaab1772516039ef2f0c3f100ea79ff9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Diaper Calculator Result Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "diaper_calculator_result_slug": properties.diaperCalculatorResultSlug,
        "diaper_calculator_result_name": properties.diaperCalculatorResultName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wCVWgt-w8x", "Diaper Calculator Result Viewed", messages, [
        {id: "8AoVlXgXPn", name: "diaper_calculator_result_name", value: properties.diaperCalculatorResultName},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "z3PyHKYGVu", name: "diaper_calculator_result_slug", value: properties.diaperCalculatorResultSlug},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Diaper Calculator Result Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Diaper Calculator Result Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "diaper_calculator_result_slug": properties.diaperCalculatorResultSlug,
          "diaper_calculator_result_name": properties.diaperCalculatorResultName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "wCVWgt-w8x", "fa7ecb7703365b0f016ff1e7d8974d3bcaab1772516039ef2f0c3f100ea79ff9");
      }
      // destination Segment
      Segment.logEvent("Diaper Calculator Result Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "diaper_calculator_result_slug": properties.diaperCalculatorResultSlug,
        "diaper_calculator_result_name": properties.diaperCalculatorResultName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Coregistration Completed: When ever a coregistration successfully completed – registration results in a User in our database.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.coregistrationPartnerKey - Lower case name/identifier unique to a given coregistration partner.
   * @param {string} properties.coregistrationPartnerName - String readable/presentable name for a given coregistration partner.
   * @param {bool} properties.coregistrationIsExistingBabylistUser - Convenience boolean for determining if the actor taking action is anonymous or an existing user. Only here to make checking downstream a little more explicit than looking for a user id property.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/OaCEEvtqCp}
   */
  function coregistrationCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertCoregistrationPartnerKey(properties.coregistrationPartnerKey));
      messages = messages.concat(assertCoregistrationPartnerName(properties.coregistrationPartnerName));
      messages = messages.concat(assertCoregistrationIsExistingBabylistUser(properties.coregistrationIsExistingBabylistUser));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "OaCEEvtqCp", "edd62dbd604ce26905a3205cbef5cfd15581f524d887c4b4ae88148b07fb85ed", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Coregistration Completed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "coregistration_partner_key": properties.coregistrationPartnerKey,
        "coregistration_partner_name": properties.coregistrationPartnerName,
        "coregistration_is_existing_babylist_user": properties.coregistrationIsExistingBabylistUser,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("OaCEEvtqCp", "Coregistration Completed", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "MaKhICXQFA", name: "coregistration_partner_key", value: properties.coregistrationPartnerKey},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "fWTvqwtoDs", name: "coregistration_partner_name", value: properties.coregistrationPartnerName},
        {id: "klPDZ6kUlA", name: "coregistration_is_existing_babylist_user", value: properties.coregistrationIsExistingBabylistUser},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Coregistration Completed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Coregistration Completed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "coregistration_partner_key": properties.coregistrationPartnerKey,
          "coregistration_partner_name": properties.coregistrationPartnerName,
          "coregistration_is_existing_babylist_user": properties.coregistrationIsExistingBabylistUser,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "OaCEEvtqCp", "edd62dbd604ce26905a3205cbef5cfd15581f524d887c4b4ae88148b07fb85ed");
      }
      // destination Segment
      Segment.logEvent("Coregistration Completed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "coregistration_partner_key": properties.coregistrationPartnerKey,
        "coregistration_partner_name": properties.coregistrationPartnerName,
        "coregistration_is_existing_babylist_user": properties.coregistrationIsExistingBabylistUser,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Coregistration Prompt Viewed: When a coregistration UI/prompt or placement is viewed by a user.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.coregistrationPartnerKey - Lower case name/identifier unique to a given coregistration partner.
   * @param {string} properties.coregistrationPartnerName - String readable/presentable name for a given coregistration partner.
   * @param {string} properties.coregistrationPromptType - A string to help identify the type of treatment for the given coregistration prompt. Could be something like a modal or feed item placement for example.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/ikWwMNMgXr}
   */
  function coregistrationPromptViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertCoregistrationPartnerKey(properties.coregistrationPartnerKey));
      messages = messages.concat(assertCoregistrationPartnerName(properties.coregistrationPartnerName));
      messages = messages.concat(assertCoregistrationPromptType(properties.coregistrationPromptType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ikWwMNMgXr", "19b6bb6a2d28198493797899a9a6f3a9f8f5f721db043c351c8b16a1af57e392", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Coregistration Prompt Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "coregistration_partner_key": properties.coregistrationPartnerKey,
        "coregistration_partner_name": properties.coregistrationPartnerName,
        "coregistration_prompt_type": properties.coregistrationPromptType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ikWwMNMgXr", "Coregistration Prompt Viewed", messages, [
        {id: "Bep0RyMDTf", name: "coregistration_prompt_type", value: properties.coregistrationPromptType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "MaKhICXQFA", name: "coregistration_partner_key", value: properties.coregistrationPartnerKey},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "fWTvqwtoDs", name: "coregistration_partner_name", value: properties.coregistrationPartnerName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Coregistration Prompt Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Coregistration Prompt Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "coregistration_partner_key": properties.coregistrationPartnerKey,
          "coregistration_partner_name": properties.coregistrationPartnerName,
          "coregistration_prompt_type": properties.coregistrationPromptType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "ikWwMNMgXr", "19b6bb6a2d28198493797899a9a6f3a9f8f5f721db043c351c8b16a1af57e392");
      }
      // destination Segment
      Segment.logEvent("Coregistration Prompt Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "coregistration_partner_key": properties.coregistrationPartnerKey,
        "coregistration_partner_name": properties.coregistrationPartnerName,
        "coregistration_prompt_type": properties.coregistrationPromptType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Coregistration Prompt Dismissed: When a prompt is actively dismissed by a user. This assumes the prompt is dismissible such as a modal prompt.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.coregistrationPartnerKey - Lower case name/identifier unique to a given coregistration partner.
   * @param {string} properties.coregistrationPartnerName - String readable/presentable name for a given coregistration partner.
   * @param {string} properties.coregistrationPromptType - A string to help identify the type of treatment for the given coregistration prompt. Could be something like a modal or feed item placement for example.
   * @param {bool} properties.coregistrationIsExistingBabylistUser - Convenience boolean for determining if the actor taking action is anonymous or an existing user. Only here to make checking downstream a little more explicit than looking for a user id property.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/yBAoyph7zW}
   */
  function coregistrationPromptDismissed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertCoregistrationPartnerKey(properties.coregistrationPartnerKey));
      messages = messages.concat(assertCoregistrationPartnerName(properties.coregistrationPartnerName));
      messages = messages.concat(assertCoregistrationPromptType(properties.coregistrationPromptType));
      messages = messages.concat(assertCoregistrationIsExistingBabylistUser(properties.coregistrationIsExistingBabylistUser));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "yBAoyph7zW", "24ae895e1bbd4222c8dff670c99e7eb344a3ee10b7a1f5c24f507563eb687787", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Coregistration Prompt Dismissed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "coregistration_partner_key": properties.coregistrationPartnerKey,
        "coregistration_partner_name": properties.coregistrationPartnerName,
        "coregistration_prompt_type": properties.coregistrationPromptType,
        "coregistration_is_existing_babylist_user": properties.coregistrationIsExistingBabylistUser,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("yBAoyph7zW", "Coregistration Prompt Dismissed", messages, [
        {id: "Bep0RyMDTf", name: "coregistration_prompt_type", value: properties.coregistrationPromptType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "MaKhICXQFA", name: "coregistration_partner_key", value: properties.coregistrationPartnerKey},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "fWTvqwtoDs", name: "coregistration_partner_name", value: properties.coregistrationPartnerName},
        {id: "klPDZ6kUlA", name: "coregistration_is_existing_babylist_user", value: properties.coregistrationIsExistingBabylistUser},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Coregistration Prompt Dismissed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Coregistration Prompt Dismissed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "coregistration_partner_key": properties.coregistrationPartnerKey,
          "coregistration_partner_name": properties.coregistrationPartnerName,
          "coregistration_prompt_type": properties.coregistrationPromptType,
          "coregistration_is_existing_babylist_user": properties.coregistrationIsExistingBabylistUser,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "yBAoyph7zW", "24ae895e1bbd4222c8dff670c99e7eb344a3ee10b7a1f5c24f507563eb687787");
      }
      // destination Segment
      Segment.logEvent("Coregistration Prompt Dismissed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "coregistration_partner_key": properties.coregistrationPartnerKey,
        "coregistration_partner_name": properties.coregistrationPartnerName,
        "coregistration_prompt_type": properties.coregistrationPromptType,
        "coregistration_is_existing_babylist_user": properties.coregistrationIsExistingBabylistUser,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Diaper Calculator Form Viewed: Fired when babylist.com/diaper-calculator is viewed.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/I5VAyF04d}
   */
  function diaperCalculatorFormViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "I5VAyF04d", "398b62345801a0165f11212631923182225eddb0420334eb93c06edeb2d118b1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Diaper Calculator Form Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("I5VAyF04d", "Diaper Calculator Form Viewed", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Diaper Calculator Form Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Diaper Calculator Form Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "I5VAyF04d", "398b62345801a0165f11212631923182225eddb0420334eb93c06edeb2d118b1");
      }
      // destination Segment
      Segment.logEvent("Diaper Calculator Form Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Placement Viewed: This event represents when a user has arrived at a specific target location, such as landing a page.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.coregistrationPartnerKey - Lower case name/identifier unique to a given coregistration partner.
   * @param {string} properties.coregistrationPartnerName - String readable/presentable name for a given coregistration partner.
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/jiPx55O-Uk}
   */
  function placementViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertCoregistrationPartnerKey(properties.coregistrationPartnerKey));
      messages = messages.concat(assertCoregistrationPartnerName(properties.coregistrationPartnerName));
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "jiPx55O-Uk", "eee1a47c39d1941c16bfe82e9cc7e24b82c767351d255634107c877dc982a562", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Placement Viewed", {
        "coregistration_partner_key": properties.coregistrationPartnerKey,
        "coregistration_partner_name": properties.coregistrationPartnerName,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("jiPx55O-Uk", "Placement Viewed", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "MaKhICXQFA", name: "coregistration_partner_key", value: properties.coregistrationPartnerKey},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "fWTvqwtoDs", name: "coregistration_partner_name", value: properties.coregistrationPartnerName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Placement Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Placement Viewed", {
          "coregistration_partner_key": properties.coregistrationPartnerKey,
          "coregistration_partner_name": properties.coregistrationPartnerName,
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "jiPx55O-Uk", "eee1a47c39d1941c16bfe82e9cc7e24b82c767351d255634107c877dc982a562");
      }
      // destination Segment
      Segment.logEvent("Placement Viewed", {
        "coregistration_partner_key": properties.coregistrationPartnerKey,
        "coregistration_partner_name": properties.coregistrationPartnerName,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Product Recommendations Viewed: When a recommended products collection is viewed. The event should contain all recommended product ids.

Event Location: PDP
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {string} [properties.productRecommenderModelVersion] - A model version from the data API for a set of recommended products.
   * @param {string} [properties.pdpType] - We have several different PDP variations. This will give us insight into which variation of the PDP the user is currently on.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/0MLGQgf4_0}
   */
  function productRecommendationsViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalProductRecommenderModelVersion(properties.productRecommenderModelVersion));
      messages = messages.concat(assertOptionalPdpType(properties.pdpType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "0MLGQgf4_0", "110b3f63d7df9af23adc0d5af82a36ec033903fca261619d2430ec089180579e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Product Recommendations Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "product_ids": properties.productIds,
        "product_recommender_model_version": properties.productRecommenderModelVersion,
        "pdp_type": properties.pdpType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("0MLGQgf4_0", "Product Recommendations Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "YQ72-3ABf", name: "product_recommender_model_version", value: properties.productRecommenderModelVersion},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "h12bnVZfao", name: "pdp_type", value: properties.pdpType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Product Recommendations Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Recommendations Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "product_ids": properties.productIds,
          "product_recommender_model_version": properties.productRecommenderModelVersion,
          "pdp_type": properties.pdpType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "0MLGQgf4_0", "110b3f63d7df9af23adc0d5af82a36ec033903fca261619d2430ec089180579e");
      }
      // destination Segment
      Segment.logEvent("Product Recommendations Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "product_ids": properties.productIds,
        "product_recommender_model_version": properties.productRecommenderModelVersion,
        "pdp_type": properties.pdpType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Product Recommendation Clicked: When a product recommendation is clicked.

Event Location: PDP
Event Type: Product Click
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {string} [properties.productRecommenderModelVersion] - A model version from the data API for a set of recommended products.
   * @param {string} [properties.pdpType] - We have several different PDP variations. This will give us insight into which variation of the PDP the user is currently on.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/0cnR466sG5R}
   */
  function productRecommendationClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalProductRecommenderModelVersion(properties.productRecommenderModelVersion));
      messages = messages.concat(assertOptionalPdpType(properties.pdpType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "0cnR466sG5R", "c1fe540b5d2b0687c62edff044626d1d86bda7cc107eb317baaf05c1432c577c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Product Recommendation Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "product_ids": properties.productIds,
        "product_recommender_model_version": properties.productRecommenderModelVersion,
        "pdp_type": properties.pdpType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("0cnR466sG5R", "Product Recommendation Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "YQ72-3ABf", name: "product_recommender_model_version", value: properties.productRecommenderModelVersion},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "h12bnVZfao", name: "pdp_type", value: properties.pdpType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Product Recommendation Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Recommendation Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "product_ids": properties.productIds,
          "product_recommender_model_version": properties.productRecommenderModelVersion,
          "pdp_type": properties.pdpType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "0cnR466sG5R", "c1fe540b5d2b0687c62edff044626d1d86bda7cc107eb317baaf05c1432c577c");
      }
      // destination Segment
      Segment.logEvent("Product Recommendation Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "product_ids": properties.productIds,
        "product_recommender_model_version": properties.productRecommenderModelVersion,
        "pdp_type": properties.pdpType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * View Content: Event fired when a user makes a choice about how their pregnancy journey started during onboarding
   *
   * @param {object} properties - the properties associatied with this event
   * @param {Array<string>} properties.contentIds - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/HNoSgVbK_H}
   */
  function viewContent(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertContentIds(properties.contentIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "HNoSgVbK_H", "e5765ab226d6864da350c29b136d4a3e0eae0b27fb4e21f8e50519f1290cdbc1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("View Content", {
        "content_ids": properties.contentIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("HNoSgVbK_H", "View Content", messages, [
        {id: "HQ-Sfte1o2", name: "content_ids", value: properties.contentIds},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'View Content': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("View Content", {
          "content_ids": properties.contentIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "HNoSgVbK_H", "e5765ab226d6864da350c29b136d4a3e0eae0b27fb4e21f8e50519f1290cdbc1");
      }
      // destination Segment
      Segment.logEvent("View Content", {
        "content_ids": properties.contentIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Viewed: Registry Viewed

* Fired when NOT logged in and viewing anyone's registry.

* Fired when logged in and viewing someone else's registry.

* Not fired when user is looking at their own registry, or their own guest view.

* Not fired when user is a partner and looking at their own registry, or their own guest view.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} [properties.searchId] - ID of Algolia query which generated the original list of search results. Used by Algolia to attribute an event to a specific query for click conversion metrics. Segment maps this property to Algolia event.queryID in Algolia Insights destination.
   * @param {string} [properties.searchPreviewIds] - This event property is a JSON string describing the Algolia Ids which generated the search preview results. Each Algolia Id corresponds to a different Algolia index. The JSON string should be encoded in the following format:

{"AlgoliaIndexName": "AlgoliaId", "AlgoliaIndexName": "AlgoliaId", "AlgoliaIndexName": "AlgoliaId"}
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/KtrerwqSrj}
   */
  function registryViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalSearchId(properties.searchId));
      messages = messages.concat(assertOptionalSearchPreviewIds(properties.searchPreviewIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "KtrerwqSrj", "20ea00343449c753f834f4c53bbe830fa08392a534950df1a81d8f8a613ed5cb", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "search_id": properties.searchId,
        "search_preview_ids": properties.searchPreviewIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("KtrerwqSrj", "Registry Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "VlL55_rwx1", name: "search_id", value: properties.searchId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "eVYsq2XJU", name: "search_preview_ids", value: properties.searchPreviewIds},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "search_id": properties.searchId,
          "search_preview_ids": properties.searchPreviewIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "KtrerwqSrj", "20ea00343449c753f834f4c53bbe830fa08392a534950df1a81d8f8a613ed5cb");
      }
      // destination Segment
      Segment.logEvent("Registry Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "search_id": properties.searchId,
        "search_preview_ids": properties.searchPreviewIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Checklist Question Answered: This event represents the baby registry checklist quiz.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.answer] - The answer for the quiz question
   * @param {bool} properties.userLoggedIn - indicate wether the user/actor is logged in at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/SV4xj4XkoG}
   */
  function checklistQuestionAnswered(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalAnswer(properties.answer));
      messages = messages.concat(assertUserLoggedIn(properties.userLoggedIn));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "SV4xj4XkoG", "420fc28e78c32dc2bb7a8c2e5c02e966cbbca65b98f25d7d744534577e81d9c7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Checklist Question Answered", {
        "event_location": properties.eventLocation,
        "answer": properties.answer,
        "user_logged_in": properties.userLoggedIn,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("SV4xj4XkoG", "Checklist Question Answered", messages, [
        {id: "kwcveeFcRU", name: "user_logged_in", value: properties.userLoggedIn},
        {id: "yh6-rYtio8", name: "answer", value: properties.answer},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Checklist Question Answered': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Checklist Question Answered", {
          "event_location": properties.eventLocation,
          "answer": properties.answer,
          "user_logged_in": properties.userLoggedIn,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "SV4xj4XkoG", "420fc28e78c32dc2bb7a8c2e5c02e966cbbca65b98f25d7d744534577e81d9c7");
      }
      // destination Segment
      Segment.logEvent("Checklist Question Answered", {
        "event_location": properties.eventLocation,
        "answer": properties.answer,
        "user_logged_in": properties.userLoggedIn,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Checklist Quiz Results Viewed: Represents when a user views the baby checklist quiz results page
   *
   * @param {object} properties - the properties associatied with this event
   * @param {bool} properties.userLoggedIn - indicate wether the user/actor is logged in at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/2BH6rE27K6}
   */
  function checklistQuizResultsViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUserLoggedIn(properties.userLoggedIn));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "2BH6rE27K6", "51297b3cd6ec3a5f0fb938f37b9369f9ad586cae4d1064b1692c05c63b6750c7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Checklist Quiz Results Viewed", {
        "user_logged_in": properties.userLoggedIn,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("2BH6rE27K6", "Checklist Quiz Results Viewed", messages, [
        {id: "kwcveeFcRU", name: "user_logged_in", value: properties.userLoggedIn},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Checklist Quiz Results Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Checklist Quiz Results Viewed", {
          "user_logged_in": properties.userLoggedIn,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "2BH6rE27K6", "51297b3cd6ec3a5f0fb938f37b9369f9ad586cae4d1064b1692c05c63b6750c7");
      }
      // destination Segment
      Segment.logEvent("Checklist Quiz Results Viewed", {
        "user_logged_in": properties.userLoggedIn,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Onboarding Question Answered: Represents each step of a new user onboarding
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.answer] - The answer for the quiz question
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/zLaM3TaSkm}
   */
  function onboardingQuestionAnswered(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalAnswer(properties.answer));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "zLaM3TaSkm", "537333f9bf8a268c64c21539529addca8d7ab9d0202c8451bea38c9f2588a163", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Onboarding Question Answered", {
        "event_location": properties.eventLocation,
        "answer": properties.answer,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("zLaM3TaSkm", "Onboarding Question Answered", messages, [
        {id: "yh6-rYtio8", name: "answer", value: properties.answer},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Onboarding Question Answered': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding Question Answered", {
          "event_location": properties.eventLocation,
          "answer": properties.answer,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "zLaM3TaSkm", "537333f9bf8a268c64c21539529addca8d7ab9d0202c8451bea38c9f2588a163");
      }
      // destination Segment
      Segment.logEvent("Onboarding Question Answered", {
        "event_location": properties.eventLocation,
        "answer": properties.answer,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Store Brand Viewed: Viewed event for brand pages in the store.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.brand - A brand name
   * @param {string} [properties.pdpType] - We have several different PDP variations. This will give us insight into which variation of the PDP the user is currently on.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/9YrfrEkKcZu}
   */
  function storeBrandViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertBrand(properties.brand));
      messages = messages.concat(assertOptionalPdpType(properties.pdpType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "9YrfrEkKcZu", "825d897cdc2e27aaefa3dda8996cf2e381140804507424573fadfe3b1d590fb2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Store Brand Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "brand": properties.brand,
        "pdp_type": properties.pdpType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("9YrfrEkKcZu", "Store Brand Viewed", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "h12bnVZfao", name: "pdp_type", value: properties.pdpType},
        {id: "iU_xUwLyJf", name: "brand", value: properties.brand},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Store Brand Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Store Brand Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "brand": properties.brand,
          "pdp_type": properties.pdpType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "9YrfrEkKcZu", "825d897cdc2e27aaefa3dda8996cf2e381140804507424573fadfe3b1d590fb2");
      }
      // destination Segment
      Segment.logEvent("Store Brand Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "brand": properties.brand,
        "pdp_type": properties.pdpType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Collaborator Invited: Sent when a collaborator is invited to a registry.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} properties.collaboratorRole - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/1tQKu1PP7O}
   */
  function collaboratorInvited(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertCollaboratorRole(properties.collaboratorRole));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "1tQKu1PP7O", "cda2a15e636c90158dbbcb0cb2beddac8062f384da5f4c79f5175eb260b5b1ef", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Collaborator Invited", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "collaborator_role": properties.collaboratorRole,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("1tQKu1PP7O", "Collaborator Invited", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "uW2-VB6Xl3", name: "collaborator_role", value: properties.collaboratorRole},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Collaborator Invited': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Collaborator Invited", {
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "collaborator_role": properties.collaboratorRole,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "1tQKu1PP7O", "cda2a15e636c90158dbbcb0cb2beddac8062f384da5f4c79f5175eb260b5b1ef");
      }
      // destination Segment
      Segment.logEvent("Collaborator Invited", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "collaborator_role": properties.collaboratorRole,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Store Tile Clicked: Store tile clicked
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} properties.store - Name of the store clicked
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/Or2dHH5kmO}
   */
  function storeTileClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertStore(properties.store));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Or2dHH5kmO", "978540d913543fba117779e66cd2f63e44c369ccd0855ffc4c236764804ed142", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Store Tile Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "store": properties.store,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Or2dHH5kmO", "Store Tile Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "pXW3Y4FTB3", name: "store", value: properties.store},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Store Tile Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Store Tile Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "store": properties.store,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "Or2dHH5kmO", "978540d913543fba117779e66cd2f63e44c369ccd0855ffc4c236764804ed142");
      }
      // destination Segment
      Segment.logEvent("Store Tile Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "store": properties.store,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Account Deactivated: This event is fired when a user deactivates the account.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/u15aundMz3}
   */
  function accountDeactivated(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "u15aundMz3", "5c277d7b6cb877fce0b59f4c48c996d7a726c3987752b0e1dc170cba5ff90de9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Account Deactivated", {
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("u15aundMz3", "Account Deactivated", messages, [
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Account Deactivated': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Account Deactivated", {
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "u15aundMz3", "5c277d7b6cb877fce0b59f4c48c996d7a726c3987752b0e1dc170cba5ff90de9");
      }
      // destination Segment
      Segment.logEvent("Account Deactivated", {
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Account Deactivation Reason Given: This event is fired when the user submits the reason for deactivating the account.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.deactivationReason - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/t9rwXEK5QX}
   */
  function accountDeactivationReasonGiven(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertDeactivationReason(properties.deactivationReason));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "t9rwXEK5QX", "1bdeff288d104249bdb0fa3211d9c5ba05c4d523ddce474e9bc9d9b074112e13", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Account Deactivation Reason Given", {
        "deactivation_reason": properties.deactivationReason,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("t9rwXEK5QX", "Account Deactivation Reason Given", messages, [
        {id: "VwUny5mM2v", name: "deactivation_reason", value: properties.deactivationReason},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Account Deactivation Reason Given': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Account Deactivation Reason Given", {
          "deactivation_reason": properties.deactivationReason,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "t9rwXEK5QX", "1bdeff288d104249bdb0fa3211d9c5ba05c4d523ddce474e9bc9d9b074112e13");
      }
      // destination Segment
      Segment.logEvent("Account Deactivation Reason Given", {
        "deactivation_reason": properties.deactivationReason,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Product Offer Clicked: This event is fired when a gift giver clicks on any of the specific offers in the right-hand box on a reg item or when a registrant clicks on an offer from the Buying Options modal. This event is fired while the modal is being rendered.

It looks the same regardless if they click the “Add to Cart” button on a Babylist offer or on one of the individual offers from a third-party store for the “Registry - Gift Giver View” location.

event_location: Registry - Gift Giver View, Registry - Buying Options Modal, Registry Buying Option Reg Item Card
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} properties.store - Name of the store clicked
   * @param {int} properties.regItemId - The ID of the registry item
   * @param {int} [properties.minEstimate] - The min estimate in days from event day
   * @param {int} [properties.maxEstimate] - The max estimate in days from event day
   * @param {bool} [properties.willArriveBeforeShower] - Boolean that identifies if the registry item would arrive before the shower date
   * @param {Array<int>} properties.offerIds - IDs of Product Offers shown on a product
   * @param {string} [properties.showerDate] - Date of registry's soonest baby shower
   * @param {bool} [properties.willArriveBeforeArrivalDate] - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/ndN15DXPv}
   */
  function registryProductOfferClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertStore(properties.store));
      messages = messages.concat(assertRegItemId(properties.regItemId));
      messages = messages.concat(assertOptionalMinEstimate(properties.minEstimate));
      messages = messages.concat(assertOptionalMaxEstimate(properties.maxEstimate));
      messages = messages.concat(assertOptionalWillArriveBeforeShower(properties.willArriveBeforeShower));
      messages = messages.concat(assertOfferIds(properties.offerIds));
      messages = messages.concat(assertOptionalShowerDate(properties.showerDate));
      messages = messages.concat(assertOptionalWillArriveBeforeArrivalDate(properties.willArriveBeforeArrivalDate));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ndN15DXPv", "ef895b5b5b60b59958cef59bb2bc1df727b81755fe2172c919f504927ee6f2ee", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Product Offer Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "store": properties.store,
        "reg_item_id": properties.regItemId,
        "min_estimate": properties.minEstimate,
        "max_estimate": properties.maxEstimate,
        "will_arrive_before_shower": properties.willArriveBeforeShower,
        "offer_ids": properties.offerIds,
        "shower_date": properties.showerDate,
        "will_arrive_before_arrival_date": properties.willArriveBeforeArrivalDate,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ndN15DXPv", "Registry Product Offer Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "AwOV6QJA4", name: "min_estimate", value: properties.minEstimate},
        {id: "D9u-ew0U3", name: "max_estimate", value: properties.maxEstimate},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "GD_6h8Uh9", name: "reg_item_id", value: properties.regItemId},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "Ni97m-DIV", name: "will_arrive_before_arrival_date", value: properties.willArriveBeforeArrivalDate},
        {id: "P91IirEr8", name: "offer_ids", value: properties.offerIds},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "hzjHBfm4F", name: "will_arrive_before_shower", value: properties.willArriveBeforeShower},
        {id: "pXW3Y4FTB3", name: "store", value: properties.store},
        {id: "sY02y0eaV", name: "shower_date", value: properties.showerDate},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Product Offer Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Product Offer Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "store": properties.store,
          "reg_item_id": properties.regItemId,
          "min_estimate": properties.minEstimate,
          "max_estimate": properties.maxEstimate,
          "will_arrive_before_shower": properties.willArriveBeforeShower,
          "offer_ids": properties.offerIds,
          "shower_date": properties.showerDate,
          "will_arrive_before_arrival_date": properties.willArriveBeforeArrivalDate,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "ndN15DXPv", "ef895b5b5b60b59958cef59bb2bc1df727b81755fe2172c919f504927ee6f2ee");
      }
      // destination Segment
      Segment.logEvent("Registry Product Offer Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "store": properties.store,
        "reg_item_id": properties.regItemId,
        "min_estimate": properties.minEstimate,
        "max_estimate": properties.maxEstimate,
        "will_arrive_before_shower": properties.willArriveBeforeShower,
        "offer_ids": properties.offerIds,
        "shower_date": properties.showerDate,
        "will_arrive_before_arrival_date": properties.willArriveBeforeArrivalDate,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Carousel Product Added to Cart: This event is fired in cart when a user clicks Add to Cart on a product or Add to Cart on a product’s variant modal  in the product recommendation carousel
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {float} properties.originalCartTotal - when event is fired, record original cart total before the item is added to cart

   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/_UF0Grph8w}
   */
  function carouselProductAddedToCart(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOriginalCartTotal(properties.originalCartTotal));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "_UF0Grph8w", "7e461fc342a758f8f8ee3d822221cff5ed660de55a70ac94bcde938edef085d9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Carousel Product Added to Cart", {
        "event_location": properties.eventLocation,
        "original_cart_total": properties.originalCartTotal,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("_UF0Grph8w", "Carousel Product Added to Cart", messages, [
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "UFTlxllG8K", name: "original_cart_total", value: properties.originalCartTotal},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Carousel Product Added to Cart': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Carousel Product Added to Cart", {
          "event_location": properties.eventLocation,
          "original_cart_total": properties.originalCartTotal,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "_UF0Grph8w", "7e461fc342a758f8f8ee3d822221cff5ed660de55a70ac94bcde938edef085d9");
      }
      // destination Segment
      Segment.logEvent("Carousel Product Added to Cart", {
        "event_location": properties.eventLocation,
        "original_cart_total": properties.originalCartTotal,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Brand Tile Clicked: -iOS Add Items Screen Brands.
-iOS Feed Brands Card.
-As of Cycle B 2024, clicks on desktop Add Items brand tiles
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} properties.brand - A brand name
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/acKijPILW_}
   */
  function brandTileClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertBrand(properties.brand));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "acKijPILW_", "09c8e0c7eb3320a70e62661035ceb40798ee8a26c5fd9abe4fb6e633206b61ce", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Brand Tile Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "brand": properties.brand,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("acKijPILW_", "Brand Tile Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "iU_xUwLyJf", name: "brand", value: properties.brand},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Brand Tile Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Brand Tile Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "brand": properties.brand,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "acKijPILW_", "09c8e0c7eb3320a70e62661035ceb40798ee8a26c5fd9abe4fb6e633206b61ce");
      }
      // destination Segment
      Segment.logEvent("Brand Tile Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "brand": properties.brand,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Add Items Screen Viewed: Add Items Screen on iOS | Android or Mobile Web (/registry/add-items)
Also from desktop as of Cycle B 2024

On web, entry_point should take one of the following values:
  -Home - Left Rail
  -Home - Right Rail
  -Registry

On native, entry_point should take one of the following values:
  -Bottom Nav Bar
  -Feed
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} [properties.entryPoint] - Used for page view events.  Describes the method of entry used to access the view.  For any given event, this property should take on one of a small list of expected values (which will differ for each event).
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/1dxuyaMCTE}
   */
  function addItemsScreenViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalEntryPoint(properties.entryPoint));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "1dxuyaMCTE", "2161cb738cf4b0f929d3700b2d859cce81d3ca59bffb53f47641e90f8d148770", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Add Items Screen Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "entry_point": properties.entryPoint,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("1dxuyaMCTE", "Add Items Screen Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "SEpbyxPtUJ", name: "entry_point", value: properties.entryPoint},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Add Items Screen Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Add Items Screen Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "entry_point": properties.entryPoint,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "1dxuyaMCTE", "2161cb738cf4b0f929d3700b2d859cce81d3ca59bffb53f47641e90f8d148770");
      }
      // destination Segment
      Segment.logEvent("Add Items Screen Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "entry_point": properties.entryPoint,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Email Captured: Whenever we capture a users email that is NOT in the signup flow, we will trigger this event.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {string} properties.email - Email the user used to sign up.
   * @param {int} properties.userId - The id of the registry owner
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/3pmDm5FPSm}
   */
  function emailCaptured(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertEmail(properties.email));
      messages = messages.concat(assertUserId(properties.userId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "3pmDm5FPSm", "b574659bd72efef976f5c3c59bb4b9a427bdbd79ac5294ca86399f826469989f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Email Captured", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "store_name": properties.storeName,
        "email": properties.email,
        "user_id": properties.userId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("3pmDm5FPSm", "Email Captured", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "Mzj1HBhPg9", name: "user_id", value: properties.userId},
        {id: "RKqhBhnmEV", name: "email", value: properties.email},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Email Captured': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Email Captured", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "store_name": properties.storeName,
          "email": properties.email,
          "user_id": properties.userId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "3pmDm5FPSm", "b574659bd72efef976f5c3c59bb4b9a427bdbd79ac5294ca86399f826469989f");
      }
      // destination Segment
      Segment.logEvent("Email Captured", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "store_name": properties.storeName,
        "email": properties.email,
        "user_id": properties.userId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Session Started: This event will fire every time a new session is created or after 30 minutes of inactivity on the site.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {int} [properties.userId] - The id of the registry owner
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/RlBN9t7GVY}
   */
  function sessionStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalUserId(properties.userId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "RlBN9t7GVY", "aecaa01e82552a6623a2a31db43a7a8cf84a9421998a05beceb3659f5b691370", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Session Started", {
        "event_url": properties.eventUrl,
        "user_id": properties.userId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("RlBN9t7GVY", "Session Started", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "Mzj1HBhPg9", name: "user_id", value: properties.userId},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Session Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Session Started", {
          "event_url": properties.eventUrl,
          "user_id": properties.userId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "RlBN9t7GVY", "aecaa01e82552a6623a2a31db43a7a8cf84a9421998a05beceb3659f5b691370");
      }
      // destination Segment
      Segment.logEvent("Session Started", {
        "event_url": properties.eventUrl,
        "user_id": properties.userId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Pump Catalog Selected: This event is fired when a Babylist Health user selects their state and insurance and proceed to view the pump catalog
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {string} properties.insuranceProvider - The name of the user's insurance company
   * @param {string} properties.insuredState - The state in which the user is insured
   * @param {int} properties.insuranceProviderId - no description
   * @param {string} [properties.emailExperimentGroup] - none, optional, required depending on which experiment group the user is put into
   * @param {bool} [properties.emailProvided] - if the user provided their email in the form
   * @param {string} [properties.strategy] - Babylist Health uses a discriminant key called "strategy" to differentiate between the pumps vs parts flow
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/Dilh7PEnZ0}
   */
  function pumpCatalogSelected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertInsuranceProvider(properties.insuranceProvider));
      messages = messages.concat(assertInsuredState(properties.insuredState));
      messages = messages.concat(assertInsuranceProviderId(properties.insuranceProviderId));
      messages = messages.concat(assertOptionalEmailExperimentGroup(properties.emailExperimentGroup));
      messages = messages.concat(assertOptionalEmailProvided(properties.emailProvided));
      messages = messages.concat(assertOptionalStrategy(properties.strategy));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Dilh7PEnZ0", "7b7be99ca21a698c6d79ff655af76f34019cd85382d32c271e35b09b70e3be34", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Pump Catalog Selected", {
        "store_name": properties.storeName,
        "insurance_provider": properties.insuranceProvider,
        "insured_state": properties.insuredState,
        "insurance_provider_id": properties.insuranceProviderId,
        "email_experiment_group": properties.emailExperimentGroup,
        "email_provided": properties.emailProvided,
        "strategy": properties.strategy,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Dilh7PEnZ0", "Pump Catalog Selected", messages, [
        {id: "2qrsdSn6P", name: "email_provided", value: properties.emailProvided},
        {id: "ENRznu7YeV", name: "insurance_provider", value: properties.insuranceProvider},
        {id: "FjngcQv7h", name: "strategy", value: properties.strategy},
        {id: "ZmEyxhz5TT", name: "insurance_provider_id", value: properties.insuranceProviderId},
        {id: "gEYP33E4tC", name: "insured_state", value: properties.insuredState},
        {id: "wf5l_8C4a", name: "email_experiment_group", value: properties.emailExperimentGroup},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Pump Catalog Selected': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Pump Catalog Selected", {
          "store_name": properties.storeName,
          "insurance_provider": properties.insuranceProvider,
          "insured_state": properties.insuredState,
          "insurance_provider_id": properties.insuranceProviderId,
          "email_experiment_group": properties.emailExperimentGroup,
          "email_provided": properties.emailProvided,
          "strategy": properties.strategy,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "Dilh7PEnZ0", "7b7be99ca21a698c6d79ff655af76f34019cd85382d32c271e35b09b70e3be34");
      }
      // destination Segment
      Segment.logEvent("Pump Catalog Selected", {
        "store_name": properties.storeName,
        "insurance_provider": properties.insuranceProvider,
        "insured_state": properties.insuredState,
        "insurance_provider_id": properties.insuranceProviderId,
        "email_experiment_group": properties.emailExperimentGroup,
        "email_provided": properties.emailProvided,
        "strategy": properties.strategy,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Home Viewed: Fired when the Home page is loaded
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {string} [properties.strategy] - Babylist Health uses a discriminant key called "strategy" to differentiate between the pumps vs parts flow
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/LwnnJ7BVA}
   */
  function homeViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalStrategy(properties.strategy));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "LwnnJ7BVA", "d6ce0c072ac2ac6f5818b97c61c942e8e8bee6663561f66a5cc657941bb0e505", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Home Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "store_name": properties.storeName,
        "strategy": properties.strategy,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("LwnnJ7BVA", "Home Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "FjngcQv7h", name: "strategy", value: properties.strategy},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Home Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Home Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "store_name": properties.storeName,
          "strategy": properties.strategy,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "LwnnJ7BVA", "d6ce0c072ac2ac6f5818b97c61c942e8e8bee6663561f66a5cc657941bb0e505");
      }
      // destination Segment
      Segment.logEvent("Home Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "store_name": properties.storeName,
        "strategy": properties.strategy,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Product List Viewed: Fired when the PLP is loaded

   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {string} [properties.strategy] - Babylist Health uses a discriminant key called "strategy" to differentiate between the pumps vs parts flow
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/7Ug0nGIiv}
   */
  function productListViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalStrategy(properties.strategy));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "7Ug0nGIiv", "6c1750aa4f726a5f47f07fcee56a653ed74a3dc1680c108f23312f14ab6d9bfe", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Product List Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "store_name": properties.storeName,
        "strategy": properties.strategy,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("7Ug0nGIiv", "Product List Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "FjngcQv7h", name: "strategy", value: properties.strategy},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Product List Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product List Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "store_name": properties.storeName,
          "strategy": properties.strategy,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "7Ug0nGIiv", "6c1750aa4f726a5f47f07fcee56a653ed74a3dc1680c108f23312f14ab6d9bfe");
      }
      // destination Segment
      Segment.logEvent("Product List Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "store_name": properties.storeName,
        "strategy": properties.strategy,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Physician Search Viewed: Fired when the physician search page is loaded
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {string} [properties.strategy] - Babylist Health uses a discriminant key called "strategy" to differentiate between the pumps vs parts flow
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/d7vGgK6Ku}
   */
  function physicianSearchViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalStrategy(properties.strategy));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "d7vGgK6Ku", "69df80cb23901a62efe01ddb396959bf40499d1caa292a16a5df8a31093712f9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Physician Search Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "store_name": properties.storeName,
        "strategy": properties.strategy,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("d7vGgK6Ku", "Physician Search Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "FjngcQv7h", name: "strategy", value: properties.strategy},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Physician Search Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Physician Search Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "store_name": properties.storeName,
          "strategy": properties.strategy,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "d7vGgK6Ku", "69df80cb23901a62efe01ddb396959bf40499d1caa292a16a5df8a31093712f9");
      }
      // destination Segment
      Segment.logEvent("Physician Search Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "store_name": properties.storeName,
        "strategy": properties.strategy,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Customer Information Form Viewed: Fired when the customer information form page is loaded
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {string} [properties.strategy] - Babylist Health uses a discriminant key called "strategy" to differentiate between the pumps vs parts flow
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/JV3r40byi}
   */
  function customerInformationFormViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalStrategy(properties.strategy));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "JV3r40byi", "d2bdc2c70a3c4f0d52b2c0a75a38319a81d381eadb0a0344391ba5c11cd1e366", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Customer Information Form Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "store_name": properties.storeName,
        "strategy": properties.strategy,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("JV3r40byi", "Customer Information Form Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "FjngcQv7h", name: "strategy", value: properties.strategy},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Customer Information Form Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Customer Information Form Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "store_name": properties.storeName,
          "strategy": properties.strategy,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "JV3r40byi", "d2bdc2c70a3c4f0d52b2c0a75a38319a81d381eadb0a0344391ba5c11cd1e366");
      }
      // destination Segment
      Segment.logEvent("Customer Information Form Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "store_name": properties.storeName,
        "strategy": properties.strategy,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Physician Search Completed: This event happens when the user is in the physician search flow and proceeds to get the results of the form
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {int} properties.resultCount - The number of search results that get returned.
   * @param {string} [properties.strategy] - Babylist Health uses a discriminant key called "strategy" to differentiate between the pumps vs parts flow
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/96HjarvGMo}
   */
  function physicianSearchCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertResultCount(properties.resultCount));
      messages = messages.concat(assertOptionalStrategy(properties.strategy));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "96HjarvGMo", "bc409372429c8b97a7d0f64f44257d900786c1a4876693b3d13aa1043f43953d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Physician Search Completed", {
        "store_name": properties.storeName,
        "result_count": properties.resultCount,
        "strategy": properties.strategy,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("96HjarvGMo", "Physician Search Completed", messages, [
        {id: "FjngcQv7h", name: "strategy", value: properties.strategy},
        {id: "VPXPSm5669", name: "result_count", value: properties.resultCount},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Physician Search Completed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Physician Search Completed", {
          "store_name": properties.storeName,
          "result_count": properties.resultCount,
          "strategy": properties.strategy,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "96HjarvGMo", "bc409372429c8b97a7d0f64f44257d900786c1a4876693b3d13aa1043f43953d");
      }
      // destination Segment
      Segment.logEvent("Physician Search Completed", {
        "store_name": properties.storeName,
        "result_count": properties.resultCount,
        "strategy": properties.strategy,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Unsupported State Selected: This event is fired an a start we don't ship to is selected in the insurance picker widget
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {string} properties.state - The name of the selected state
   * @param {string} [properties.strategy] - Babylist Health uses a discriminant key called "strategy" to differentiate between the pumps vs parts flow
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/MZcsgd3cuz}
   */
  function unsupportedStateSelected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertState(properties.state));
      messages = messages.concat(assertOptionalStrategy(properties.strategy));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "MZcsgd3cuz", "93c5891c98295c822a1f60cbf07839dbaa98d21faac0a43278a3ba7bdc2f84d6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Unsupported State Selected", {
        "store_name": properties.storeName,
        "state": properties.state,
        "strategy": properties.strategy,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("MZcsgd3cuz", "Unsupported State Selected", messages, [
        {id: "FjngcQv7h", name: "strategy", value: properties.strategy},
        {id: "IwLCHBAQ8", name: "state", value: properties.state},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Unsupported State Selected': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Unsupported State Selected", {
          "store_name": properties.storeName,
          "state": properties.state,
          "strategy": properties.strategy,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "MZcsgd3cuz", "93c5891c98295c822a1f60cbf07839dbaa98d21faac0a43278a3ba7bdc2f84d6");
      }
      // destination Segment
      Segment.logEvent("Unsupported State Selected", {
        "store_name": properties.storeName,
        "state": properties.state,
        "strategy": properties.strategy,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Unsupported Insurance Provider Selected: Fired when user selects the option "My insurance is not listed" in the insurance picker widget
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {string} properties.insuranceName - no description
   * @param {string} [properties.strategy] - Babylist Health uses a discriminant key called "strategy" to differentiate between the pumps vs parts flow
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/FXXumUjxtm}
   */
  function unsupportedInsuranceProviderSelected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertInsuranceName(properties.insuranceName));
      messages = messages.concat(assertOptionalStrategy(properties.strategy));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "FXXumUjxtm", "ed51ffccdaad642b16b16d84e3af2b6a111a2da4f4fd1a9993b116d8b54943d0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Unsupported Insurance Provider Selected", {
        "store_name": properties.storeName,
        "insurance_name": properties.insuranceName,
        "strategy": properties.strategy,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("FXXumUjxtm", "Unsupported Insurance Provider Selected", messages, [
        {id: "8ls_yj5rwW", name: "insurance_name", value: properties.insuranceName},
        {id: "FjngcQv7h", name: "strategy", value: properties.strategy},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Unsupported Insurance Provider Selected': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Unsupported Insurance Provider Selected", {
          "store_name": properties.storeName,
          "insurance_name": properties.insuranceName,
          "strategy": properties.strategy,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "FXXumUjxtm", "ed51ffccdaad642b16b16d84e3af2b6a111a2da4f4fd1a9993b116d8b54943d0");
      }
      // destination Segment
      Segment.logEvent("Unsupported Insurance Provider Selected", {
        "store_name": properties.storeName,
        "insurance_name": properties.insuranceName,
        "strategy": properties.strategy,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Error Thrown: This event is fired and an error occurs o the Babylist Health UI
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {string} properties.error - The error message or code
   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/ukGH0JI-5M}
   */
  function errorThrown(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertError(properties.error));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ukGH0JI-5M", "60e734563c058412e8b3171f7c6cd6de400c5339ca3c18be66dc14fbd344309c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Error Thrown", {
        "store_name": properties.storeName,
        "error": properties.error,
        "event_location": properties.eventLocation,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ukGH0JI-5M", "Error Thrown", messages, [
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "z0zvXpwNs7", name: "error", value: properties.error},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Error Thrown': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Error Thrown", {
          "store_name": properties.storeName,
          "error": properties.error,
          "event_location": properties.eventLocation,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "ukGH0JI-5M", "60e734563c058412e8b3171f7c6cd6de400c5339ca3c18be66dc14fbd344309c");
      }
      // destination Segment
      Segment.logEvent("Error Thrown", {
        "store_name": properties.storeName,
        "error": properties.error,
        "event_location": properties.eventLocation,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * App Download Interstitial Viewed: Triggered when users see an app download interstitial
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.experimentName] - This is to be used for events that are tracking specific experiments
   * @param {string} [properties.experimentGroup] - This is to be used for events that are tracking specific experiments
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/-EIBXCuMqF}
   */
  function appDownloadInterstitialViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalExperimentName(properties.experimentName));
      messages = messages.concat(assertOptionalExperimentGroup(properties.experimentGroup));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "-EIBXCuMqF", "07122bd85937cb10fbb3bdb94ce2249b517e1940578810337eb1eddd6a6fd01a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("App Download Interstitial Viewed", {
        "event_location": properties.eventLocation,
        "experiment_name": properties.experimentName,
        "experiment_group": properties.experimentGroup,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("-EIBXCuMqF", "App Download Interstitial Viewed", messages, [
        {id: "2fe5gtXT8S", name: "experiment_group", value: properties.experimentGroup},
        {id: "tN6DzKw_AQ", name: "experiment_name", value: properties.experimentName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'App Download Interstitial Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("App Download Interstitial Viewed", {
          "event_location": properties.eventLocation,
          "experiment_name": properties.experimentName,
          "experiment_group": properties.experimentGroup,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "-EIBXCuMqF", "07122bd85937cb10fbb3bdb94ce2249b517e1940578810337eb1eddd6a6fd01a");
      }
      // destination Segment
      Segment.logEvent("App Download Interstitial Viewed", {
        "event_location": properties.eventLocation,
        "experiment_name": properties.experimentName,
        "experiment_group": properties.experimentGroup,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * App Download Interstitial Skipped: Triggered when users select to skip it
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.experimentName] - This is to be used for events that are tracking specific experiments
   * @param {string} [properties.experimentGroup] - This is to be used for events that are tracking specific experiments
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/oCP6z0o8Vd}
   */
  function appDownloadInterstitialSkipped(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalExperimentName(properties.experimentName));
      messages = messages.concat(assertOptionalExperimentGroup(properties.experimentGroup));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "oCP6z0o8Vd", "bb46836a8d44d14c3412f707f1d2917e145e228319d050665fb07212e20c37b2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("App Download Interstitial Skipped", {
        "event_location": properties.eventLocation,
        "experiment_name": properties.experimentName,
        "experiment_group": properties.experimentGroup,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("oCP6z0o8Vd", "App Download Interstitial Skipped", messages, [
        {id: "2fe5gtXT8S", name: "experiment_group", value: properties.experimentGroup},
        {id: "tN6DzKw_AQ", name: "experiment_name", value: properties.experimentName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'App Download Interstitial Skipped': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("App Download Interstitial Skipped", {
          "event_location": properties.eventLocation,
          "experiment_name": properties.experimentName,
          "experiment_group": properties.experimentGroup,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "oCP6z0o8Vd", "bb46836a8d44d14c3412f707f1d2917e145e228319d050665fb07212e20c37b2");
      }
      // destination Segment
      Segment.logEvent("App Download Interstitial Skipped", {
        "event_location": properties.eventLocation,
        "experiment_name": properties.experimentName,
        "experiment_group": properties.experimentGroup,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * App Download Interstitial Clicked: Triggered when users select to click the “get app” CTA
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.experimentName] - This is to be used for events that are tracking specific experiments
   * @param {string} [properties.experimentGroup] - This is to be used for events that are tracking specific experiments
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/eVGnzB2Emg}
   */
  function appDownloadInterstitialClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalExperimentName(properties.experimentName));
      messages = messages.concat(assertOptionalExperimentGroup(properties.experimentGroup));
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "eVGnzB2Emg", "91e00f1c705fe4e59d42773ac7de6cfe88cc06f0e2c6251cc16eded4184028a5", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("App Download Interstitial Clicked", {
        "event_location": properties.eventLocation,
        "experiment_name": properties.experimentName,
        "experiment_group": properties.experimentGroup,
        "event_cta": properties.eventCta,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("eVGnzB2Emg", "App Download Interstitial Clicked", messages, [
        {id: "2fe5gtXT8S", name: "experiment_group", value: properties.experimentGroup},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "tN6DzKw_AQ", name: "experiment_name", value: properties.experimentName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'App Download Interstitial Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("App Download Interstitial Clicked", {
          "event_location": properties.eventLocation,
          "experiment_name": properties.experimentName,
          "experiment_group": properties.experimentGroup,
          "event_cta": properties.eventCta,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "eVGnzB2Emg", "91e00f1c705fe4e59d42773ac7de6cfe88cc06f0e2c6251cc16eded4184028a5");
      }
      // destination Segment
      Segment.logEvent("App Download Interstitial Clicked", {
        "event_location": properties.eventLocation,
        "experiment_name": properties.experimentName,
        "experiment_group": properties.experimentGroup,
        "event_cta": properties.eventCta,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Checklist Viewed: When the registry checklist is viewed.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {int} properties.checklistType - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/Dt47mtnP9S}
   */
  function checklistViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertChecklistType(properties.checklistType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Dt47mtnP9S", "b26704f380c96f67b5089de41ff2c681445f604d2803ffc5b0f241d97db12f2c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Checklist Viewed", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "checklist_type": properties.checklistType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Dt47mtnP9S", "Checklist Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "VMnhclaN1n", name: "checklist_type", value: properties.checklistType},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Checklist Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Checklist Viewed", {
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "checklist_type": properties.checklistType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "Dt47mtnP9S", "b26704f380c96f67b5089de41ff2c681445f604d2803ffc5b0f241d97db12f2c");
      }
      // destination Segment
      Segment.logEvent("Checklist Viewed", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "checklist_type": properties.checklistType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Checklist Category Viewed: When a checklist sub category is viewed.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {int} properties.checklistType - no description
   * @param {int} properties.checklistCategoryId - no description
   * @param {string} properties.checklistCategoryName - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/Rwsn_OFU-O}
   */
  function checklistCategoryViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertChecklistType(properties.checklistType));
      messages = messages.concat(assertChecklistCategoryId(properties.checklistCategoryId));
      messages = messages.concat(assertChecklistCategoryName(properties.checklistCategoryName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Rwsn_OFU-O", "93374d08618acdd56705dfca3e21bc7425f826e6dbd9cd937aa6ed179dc59c70", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Checklist Category Viewed", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "checklist_type": properties.checklistType,
        "checklist_category_id": properties.checklistCategoryId,
        "checklist_category_name": properties.checklistCategoryName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Rwsn_OFU-O", "Checklist Category Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "NYCVcKFMW-", name: "checklist_category_id", value: properties.checklistCategoryId},
        {id: "VMnhclaN1n", name: "checklist_type", value: properties.checklistType},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "pb82BUpUN-", name: "checklist_category_name", value: properties.checklistCategoryName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Checklist Category Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Checklist Category Viewed", {
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "checklist_type": properties.checklistType,
          "checklist_category_id": properties.checklistCategoryId,
          "checklist_category_name": properties.checklistCategoryName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "Rwsn_OFU-O", "93374d08618acdd56705dfca3e21bc7425f826e6dbd9cd937aa6ed179dc59c70");
      }
      // destination Segment
      Segment.logEvent("Checklist Category Viewed", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "checklist_type": properties.checklistType,
        "checklist_category_id": properties.checklistCategoryId,
        "checklist_category_name": properties.checklistCategoryName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Checklist Checkbox Clicked: When a checklist checkbox is clicked.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {int} properties.checklistType - no description
   * @param {int} properties.checklistCategoryId - no description
   * @param {string} properties.checklistCategoryName - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/-WxanOgbU}
   */
  function checklistCheckboxClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertChecklistType(properties.checklistType));
      messages = messages.concat(assertChecklistCategoryId(properties.checklistCategoryId));
      messages = messages.concat(assertChecklistCategoryName(properties.checklistCategoryName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "-WxanOgbU", "8d8f2febd21034c336716d4117ad3520138bb130a5fe78fb4cdbb774778a845b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Checklist Checkbox Clicked", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "checklist_type": properties.checklistType,
        "checklist_category_id": properties.checklistCategoryId,
        "checklist_category_name": properties.checklistCategoryName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("-WxanOgbU", "Checklist Checkbox Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "NYCVcKFMW-", name: "checklist_category_id", value: properties.checklistCategoryId},
        {id: "VMnhclaN1n", name: "checklist_type", value: properties.checklistType},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "pb82BUpUN-", name: "checklist_category_name", value: properties.checklistCategoryName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Checklist Checkbox Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Checklist Checkbox Clicked", {
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "checklist_type": properties.checklistType,
          "checklist_category_id": properties.checklistCategoryId,
          "checklist_category_name": properties.checklistCategoryName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "-WxanOgbU", "8d8f2febd21034c336716d4117ad3520138bb130a5fe78fb4cdbb774778a845b");
      }
      // destination Segment
      Segment.logEvent("Checklist Checkbox Clicked", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "checklist_type": properties.checklistType,
        "checklist_category_id": properties.checklistCategoryId,
        "checklist_category_name": properties.checklistCategoryName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Form Submitted: Fired when a user attempts to submit a form
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {string} properties.status - no description
   * @param {string} properties.formName - no description
   * @param {string} [properties.errorMessage] - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/mE_6WgNai0}
   */
  function formSubmitted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertStatus(properties.status));
      messages = messages.concat(assertFormName(properties.formName));
      messages = messages.concat(assertOptionalErrorMessage(properties.errorMessage));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "mE_6WgNai0", "719e706cf0e7a3c148c7d626518c7d14790a313497ed77fc4c0ed7cb45061638", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Form Submitted", {
        "store_name": properties.storeName,
        "status": properties.status,
        "form_name": properties.formName,
        "error_message": properties.errorMessage,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("mE_6WgNai0", "Form Submitted", messages, [
        {id: "Jpho3Mg1f", name: "error_message", value: properties.errorMessage},
        {id: "VWt-iAFvK", name: "form_name", value: properties.formName},
        {id: "iC2fNqDR8", name: "status", value: properties.status},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Form Submitted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Form Submitted", {
          "store_name": properties.storeName,
          "status": properties.status,
          "form_name": properties.formName,
          "error_message": properties.errorMessage,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "mE_6WgNai0", "719e706cf0e7a3c148c7d626518c7d14790a313497ed77fc4c0ed7cb45061638");
      }
      // destination Segment
      Segment.logEvent("Form Submitted", {
        "store_name": properties.storeName,
        "status": properties.status,
        "form_name": properties.formName,
        "error_message": properties.errorMessage,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Feedback Modal Submitted: When a feedback modal answer is submitted. This event has several properties attached to it:

• feature_name: registry_appearance, registry_organization
• feedback_value: Uses a 5-point Likert scale (1 = worst, 5 = best)
• feedback_text_value: Freeform input from user of why the choice was selected
   *
   * @param {object} properties - the properties associatied with this event
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.featureName - no description
   * @param {string} properties.feedbackValue - no description
   * @param {string} [properties.feedbackTextValue] - When a feedback modal contains a text area for input, it goes here.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/hDvpNBz8Za}
   */
  function feedbackModalSubmitted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertFeatureName(properties.featureName));
      messages = messages.concat(assertFeedbackValue(properties.feedbackValue));
      messages = messages.concat(assertOptionalFeedbackTextValue(properties.feedbackTextValue));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hDvpNBz8Za", "4ac90dfabed24d36315fdf11cfbdfb39737b5af5f014f67be20fdbfa39e89615", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Feedback Modal Submitted", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "feature_name": properties.featureName,
        "feedback_value": properties.feedbackValue,
        "feedback_text_value": properties.feedbackTextValue,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hDvpNBz8Za", "Feedback Modal Submitted", messages, [
        {id: "8sWc-mWJy", name: "feedback_text_value", value: properties.feedbackTextValue},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "WGPIMEP175", name: "feedback_value", value: properties.feedbackValue},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "vWgDaXFfgR", name: "feature_name", value: properties.featureName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Feedback Modal Submitted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Feedback Modal Submitted", {
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "feature_name": properties.featureName,
          "feedback_value": properties.feedbackValue,
          "feedback_text_value": properties.feedbackTextValue,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "hDvpNBz8Za", "4ac90dfabed24d36315fdf11cfbdfb39737b5af5f014f67be20fdbfa39e89615");
      }
      // destination Segment
      Segment.logEvent("Feedback Modal Submitted", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "feature_name": properties.featureName,
        "feedback_value": properties.feedbackValue,
        "feedback_text_value": properties.feedbackTextValue,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Feedback Modal Viewed: When a feedback modal is viewed.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.featureName - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/rfj8KT-i0R}
   */
  function feedbackModalViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertFeatureName(properties.featureName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "rfj8KT-i0R", "84edf645ff1d8a4752b0aaac4b64b4f8eeeb81da139beb1b4cda3b19d0471b6f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Feedback Modal Viewed", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "feature_name": properties.featureName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("rfj8KT-i0R", "Feedback Modal Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "vWgDaXFfgR", name: "feature_name", value: properties.featureName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Feedback Modal Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Feedback Modal Viewed", {
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "feature_name": properties.featureName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "rfj8KT-i0R", "84edf645ff1d8a4752b0aaac4b64b4f8eeeb81da139beb1b4cda3b19d0471b6f");
      }
      // destination Segment
      Segment.logEvent("Feedback Modal Viewed", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "feature_name": properties.featureName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Feedback Modal Dismissed: When a feedback modal is dismissed.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.featureName - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/BBlrdgUsYn}
   */
  function feedbackModalDismissed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertFeatureName(properties.featureName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "BBlrdgUsYn", "a6a3abe3fb7e0c5059741211bd9f7058cca6d7739e65c1edaede7f7e953fa0c2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Feedback Modal Dismissed", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "feature_name": properties.featureName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("BBlrdgUsYn", "Feedback Modal Dismissed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "vWgDaXFfgR", name: "feature_name", value: properties.featureName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Feedback Modal Dismissed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Feedback Modal Dismissed", {
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "feature_name": properties.featureName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "BBlrdgUsYn", "a6a3abe3fb7e0c5059741211bd9f7058cca6d7739e65c1edaede7f7e953fa0c2");
      }
      // destination Segment
      Segment.logEvent("Feedback Modal Dismissed", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "feature_name": properties.featureName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Physician Result Viewed: Fired when the physician result viewed is displayed
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {string} [properties.strategy] - Babylist Health uses a discriminant key called "strategy" to differentiate between the pumps vs parts flow
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/jHIX3RbKUP}
   */
  function physicianResultViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalStrategy(properties.strategy));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "jHIX3RbKUP", "8c71115270d8c6bf50dd15bccdb4cc48a1c892a4c5d59f01437a6a799ac0677b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Physician Result Viewed", {
        "store_name": properties.storeName,
        "strategy": properties.strategy,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("jHIX3RbKUP", "Physician Result Viewed", messages, [
        {id: "FjngcQv7h", name: "strategy", value: properties.strategy},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Physician Result Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Physician Result Viewed", {
          "store_name": properties.storeName,
          "strategy": properties.strategy,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "jHIX3RbKUP", "8c71115270d8c6bf50dd15bccdb4cc48a1c892a4c5d59f01437a6a799ac0677b");
      }
      // destination Segment
      Segment.logEvent("Physician Result Viewed", {
        "store_name": properties.storeName,
        "strategy": properties.strategy,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Sponsored Product Viewed: When a sponsored product is viewed.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/3uCgW0qlL4k}
   */
  function sponsoredProductViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "3uCgW0qlL4k", "7a93467a78e0b9c72d3c4e197abbef55fcd02acb9ee808b26aefb3bab912e4f0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Sponsored Product Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("3uCgW0qlL4k", "Sponsored Product Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Sponsored Product Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Sponsored Product Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "3uCgW0qlL4k", "7a93467a78e0b9c72d3c4e197abbef55fcd02acb9ee808b26aefb3bab912e4f0");
      }
      // destination Segment
      Segment.logEvent("Sponsored Product Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Experiment Reached: This event should be fired whenever you want to track A/B test data for a user that has reached a point in the application, where their experience can be affected by the experiment.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.experimentName - This is to be used for events that are tracking specific experiments
   * @param {string} properties.experimentGroup - This is to be used for events that are tracking specific experiments
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/aViUTegxWl}
   */
  function experimentReached(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertExperimentName(properties.experimentName));
      messages = messages.concat(assertExperimentGroup(properties.experimentGroup));
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "aViUTegxWl", "64ad03a5650381d2b2288ee75742c3dae567a17c95360143a9c59e7fc542cb08", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Experiment Reached", {
        "experiment_name": properties.experimentName,
        "experiment_group": properties.experimentGroup,
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("aViUTegxWl", "Experiment Reached", messages, [
        {id: "2fe5gtXT8S", name: "experiment_group", value: properties.experimentGroup},
        {id: "tN6DzKw_AQ", name: "experiment_name", value: properties.experimentName},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Experiment Reached': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Experiment Reached", {
          "experiment_name": properties.experimentName,
          "experiment_group": properties.experimentGroup,
          "store_name": properties.storeName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "aViUTegxWl", "64ad03a5650381d2b2288ee75742c3dae567a17c95360143a9c59e7fc542cb08");
      }
      // destination Segment
      Segment.logEvent("Experiment Reached", {
        "experiment_name": properties.experimentName,
        "experiment_group": properties.experimentGroup,
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Organize Clicked: Event triggered when user clicks on "Organize Registry". On the App it can be accessed from the hamburger menu Registry > Actions or  the Organize Registry Icon in the Registry View.

- event_location: Registry, Settings
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/x4QqwjfGNL}
   */
  function registryOrganizeClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "x4QqwjfGNL", "d218185c7006b35d77ae194fe03ae69d62b5c64322ee95a52ba3cc5e45c95270", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Organize Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("x4QqwjfGNL", "Registry Organize Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Organize Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Organize Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "x4QqwjfGNL", "d218185c7006b35d77ae194fe03ae69d62b5c64322ee95a52ba3cc5e45c95270");
      }
      // destination Segment
      Segment.logEvent("Registry Organize Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Category Created: When a registry category is created.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/2owsN9TSUh}
   */
  function registryCategoryCreated(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "2owsN9TSUh", "ce853f6fbdc5204f6ee0d9a24908a017e8fb798a6ca41a40f365eeeeedaab9c6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Category Created", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("2owsN9TSUh", "Registry Category Created", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Category Created': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Category Created", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "2owsN9TSUh", "ce853f6fbdc5204f6ee0d9a24908a017e8fb798a6ca41a40f365eeeeedaab9c6");
      }
      // destination Segment
      Segment.logEvent("Registry Category Created", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Category Edited: When a registry category is edited.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/Y8heVU-5Rg}
   */
  function registryCategoryEdited(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Y8heVU-5Rg", "e40f2bec9615bbc8380c3403f428e7567390ffb84deaace96bb19b005b943414", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Category Edited", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Y8heVU-5Rg", "Registry Category Edited", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Category Edited': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Category Edited", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "Y8heVU-5Rg", "e40f2bec9615bbc8380c3403f428e7567390ffb84deaace96bb19b005b943414");
      }
      // destination Segment
      Segment.logEvent("Registry Category Edited", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Category Deleted: When a registry category is deleted.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/WprGfzjjMB}
   */
  function registryCategoryDeleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "WprGfzjjMB", "7416e6c62293d5217df804186da8f1434a87d3a40ee822d12b8fb3d749f153bc", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Category Deleted", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("WprGfzjjMB", "Registry Category Deleted", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Category Deleted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Category Deleted", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "WprGfzjjMB", "7416e6c62293d5217df804186da8f1434a87d3a40ee822d12b8fb3d749f153bc");
      }
      // destination Segment
      Segment.logEvent("Registry Category Deleted", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Category Moved: When a registry category is moved.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/T-Blf2nv8z}
   */
  function registryCategoryMoved(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "T-Blf2nv8z", "5abb89fafaebbffb587e7fc40b7130370bd24d5477acb5ca5cd0dfd1a4c48fc5", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Category Moved", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("T-Blf2nv8z", "Registry Category Moved", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Category Moved': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Category Moved", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "T-Blf2nv8z", "5abb89fafaebbffb587e7fc40b7130370bd24d5477acb5ca5cd0dfd1a4c48fc5");
      }
      // destination Segment
      Segment.logEvent("Registry Category Moved", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Dropdown Clicked: Occurs when the see more registry dropdown is clicked
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/ihCnvjV42p}
   */
  function registryDropdownClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ihCnvjV42p", "572709baeac0feaab4bc5ac4f67279d13630c4bb259d09e0d5ca4b7a32c6cf0c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Dropdown Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ihCnvjV42p", "Registry Dropdown Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Dropdown Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Dropdown Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "ihCnvjV42p", "572709baeac0feaab4bc5ac4f67279d13630c4bb259d09e0d5ca4b7a32c6cf0c");
      }
      // destination Segment
      Segment.logEvent("Registry Dropdown Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Switched: Occurs when someone switches to a new active registry
   *
   * @param {object} properties - the properties associatied with this event
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/UUGe5lDAwV}
   */
  function registrySwitched(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UUGe5lDAwV", "3f52f49e4946631a7f6a76411e5262e21895d7609d8630618dfa36453cebd19a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Switched", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UUGe5lDAwV", "Registry Switched", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Switched': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Switched", {
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "UUGe5lDAwV", "3f52f49e4946631a7f6a76411e5262e21895d7609d8630618dfa36453cebd19a");
      }
      // destination Segment
      Segment.logEvent("Registry Switched", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Template Copied: Occurs when a user selects a registry to clone into the new registry they are creating
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {int} [properties.registryTemplateId] - A registry that was used to copy items from into a newly created registry
   * @param {string} [properties.registryTemplateTitle] - Title of a registry that was use to copy items to a newly created registry
   * @param {string} properties.registryTemplateType - The type of registry template
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/StcR_TvDzB}
   */
  function registryTemplateCopied(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalRegistryTemplateId(properties.registryTemplateId));
      messages = messages.concat(assertOptionalRegistryTemplateTitle(properties.registryTemplateTitle));
      messages = messages.concat(assertRegistryTemplateType(properties.registryTemplateType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "StcR_TvDzB", "7b54fe48a766b8de244246ce73ad3761d5ac1dbae7f62bbd1a6b86c3e5b55705", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Template Copied", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "registry_template_id": properties.registryTemplateId,
        "registry_template_title": properties.registryTemplateTitle,
        "registry_template_type": properties.registryTemplateType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("StcR_TvDzB", "Registry Template Copied", messages, [
        {id: "47VVtO4qg", name: "registry_template_type", value: properties.registryTemplateType},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KEBwqFi-k", name: "registry_template_id", value: properties.registryTemplateId},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "P5TuvrzYy", name: "registry_template_title", value: properties.registryTemplateTitle},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Template Copied': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Template Copied", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "registry_template_id": properties.registryTemplateId,
          "registry_template_title": properties.registryTemplateTitle,
          "registry_template_type": properties.registryTemplateType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "StcR_TvDzB", "7b54fe48a766b8de244246ce73ad3761d5ac1dbae7f62bbd1a6b86c3e5b55705");
      }
      // destination Segment
      Segment.logEvent("Registry Template Copied", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "registry_template_id": properties.registryTemplateId,
        "registry_template_title": properties.registryTemplateTitle,
        "registry_template_type": properties.registryTemplateType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * All Registries Viewed: Occurs on the list page for registries
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/caOR9LNsEq}
   */
  function allRegistriesViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "caOR9LNsEq", "511f6c95762ee29d87faaaa7e3bcb748ad500870c6f87edfe82bd736e4c2598f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("All Registries Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("caOR9LNsEq", "All Registries Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'All Registries Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("All Registries Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "caOR9LNsEq", "511f6c95762ee29d87faaaa7e3bcb748ad500870c6f87edfe82bd736e4c2598f");
      }
      // destination Segment
      Segment.logEvent("All Registries Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Deactivated: Occurs when a registry is deactivated
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/HLju8SukLR}
   */
  function registryDeactivated(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "HLju8SukLR", "ad7dd72db867cee03aa3a2018f8a2fa1f0cc1b4c6e926616347d4003bb79e3a3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Deactivated", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("HLju8SukLR", "Registry Deactivated", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Deactivated': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Deactivated", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "HLju8SukLR", "ad7dd72db867cee03aa3a2018f8a2fa1f0cc1b4c6e926616347d4003bb79e3a3");
      }
      // destination Segment
      Segment.logEvent("Registry Deactivated", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Create New Registry Clicked: Occurs when a users clicks/taps to enter into the create new registry flow
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/Riqr8ObouV}
   */
  function createNewRegistryClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Riqr8ObouV", "21b3580ec5a8ae297da4dc5aec193cf040942683703862461a5b80b07fe197a0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Create New Registry Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Riqr8ObouV", "Create New Registry Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Create New Registry Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Create New Registry Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "Riqr8ObouV", "21b3580ec5a8ae297da4dc5aec193cf040942683703862461a5b80b07fe197a0");
      }
      // destination Segment
      Segment.logEvent("Create New Registry Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Template Type Clicked: Occurs when user selects how they will populate their new registry.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} properties.registryTemplateType - The type of registry template
   * @param {int} [properties.registryTemplateId] - A registry that was used to copy items from into a newly created registry
   * @param {string} [properties.registryTemplateTitle] - Title of a registry that was use to copy items to a newly created registry
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/XIRRiykdQd}
   */
  function registryTemplateTypeClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertRegistryTemplateType(properties.registryTemplateType));
      messages = messages.concat(assertOptionalRegistryTemplateId(properties.registryTemplateId));
      messages = messages.concat(assertOptionalRegistryTemplateTitle(properties.registryTemplateTitle));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "XIRRiykdQd", "c150925ad6536e754600854043758cae66ebefb7c7580090f269b68a832b9460", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Template Type Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "registry_template_type": properties.registryTemplateType,
        "registry_template_id": properties.registryTemplateId,
        "registry_template_title": properties.registryTemplateTitle,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("XIRRiykdQd", "Registry Template Type Clicked", messages, [
        {id: "47VVtO4qg", name: "registry_template_type", value: properties.registryTemplateType},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KEBwqFi-k", name: "registry_template_id", value: properties.registryTemplateId},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "P5TuvrzYy", name: "registry_template_title", value: properties.registryTemplateTitle},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Template Type Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Template Type Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "registry_template_type": properties.registryTemplateType,
          "registry_template_id": properties.registryTemplateId,
          "registry_template_title": properties.registryTemplateTitle,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "XIRRiykdQd", "c150925ad6536e754600854043758cae66ebefb7c7580090f269b68a832b9460");
      }
      // destination Segment
      Segment.logEvent("Registry Template Type Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "registry_template_type": properties.registryTemplateType,
        "registry_template_id": properties.registryTemplateId,
        "registry_template_title": properties.registryTemplateTitle,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Restore Clicked: Occurs when a user attempts to restore a deactivated registry
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/PU8aXMHqS}
   */
  function registryRestoreClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "PU8aXMHqS", "1561b36d95d9ae730d5d18dc12c908366b5d01bfe70f8aeb260246a54092c262", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Restore Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("PU8aXMHqS", "Registry Restore Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Restore Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Restore Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "PU8aXMHqS", "1561b36d95d9ae730d5d18dc12c908366b5d01bfe70f8aeb260246a54092c262");
      }
      // destination Segment
      Segment.logEvent("Registry Restore Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Checklist Category Clicked: When a checklist sub category is clicked.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {int} properties.checklistType - no description
   * @param {int} properties.checklistCategoryId - no description
   * @param {string} properties.checklistCategoryName - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/wVpqVng9UD}
   */
  function checklistCategoryClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertChecklistType(properties.checklistType));
      messages = messages.concat(assertChecklistCategoryId(properties.checklistCategoryId));
      messages = messages.concat(assertChecklistCategoryName(properties.checklistCategoryName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wVpqVng9UD", "e339be19a2449ec5ba7830587edb34c5aad62a8344faf86818e751e49bf2f27e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Checklist Category Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "checklist_type": properties.checklistType,
        "checklist_category_id": properties.checklistCategoryId,
        "checklist_category_name": properties.checklistCategoryName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wVpqVng9UD", "Checklist Category Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "NYCVcKFMW-", name: "checklist_category_id", value: properties.checklistCategoryId},
        {id: "VMnhclaN1n", name: "checklist_type", value: properties.checklistType},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "pb82BUpUN-", name: "checklist_category_name", value: properties.checklistCategoryName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Checklist Category Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Checklist Category Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "checklist_type": properties.checklistType,
          "checklist_category_id": properties.checklistCategoryId,
          "checklist_category_name": properties.checklistCategoryName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "wVpqVng9UD", "e339be19a2449ec5ba7830587edb34c5aad62a8344faf86818e751e49bf2f27e");
      }
      // destination Segment
      Segment.logEvent("Checklist Category Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "checklist_type": properties.checklistType,
        "checklist_category_id": properties.checklistCategoryId,
        "checklist_category_name": properties.checklistCategoryName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Home Viewed: Registry Home Viewed is fired when a user is viewing the home page (Feed) of their own registry (/registry/home). iOS fires when viewing the Feed tab.

event properties
- event_cta: None
- event_location: Registry
- event_type: None
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/UXMe5RFR44}
   */
  function registryHomeViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UXMe5RFR44", "3edb8a56bb4bb71a4101d7014b382ee726cd498874923fbec69d08f157daf20e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Home Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UXMe5RFR44", "Registry Home Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Home Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Home Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "UXMe5RFR44", "3edb8a56bb4bb71a4101d7014b382ee726cd498874923fbec69d08f157daf20e");
      }
      // destination Segment
      Segment.logEvent("Registry Home Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Add Items Screen Clicked: Tracking which links/buttons are clicked on the Add Items screen other than store and brand tiles

Post properties will only be sent when the event CTA is Guide

Event CTA should be one of the following:
  -Cash Funds
  -Gift Cards
  -Help and Favors
  -Guides
  -Transfer
  -Install Extension
  -Add Button
  -Download App
  -FAQ - Add From Anywhere
  -FAQ - Add From Other Stores
  -FAQ - Add Without Button
  -FAQ - Where Is Extension
  -FAQ - Button Not Working
  -FAQ - Size and Color
  -FAQ - Gift Cards
  -FAQ - Add Without Link
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} [properties.postId] - Contentful ID for the Guide post
   * @param {string} [properties.postType] - Guide post type
   * @param {int} [properties.postRevision] - Guide post revision number
   * @param {string} [properties.postSlug] - Guide post URL slug
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/jplqtVYwLC}
   */
  function addItemsScreenClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalPostId(properties.postId));
      messages = messages.concat(assertOptionalPostType(properties.postType));
      messages = messages.concat(assertOptionalPostRevision(properties.postRevision));
      messages = messages.concat(assertOptionalPostSlug(properties.postSlug));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "jplqtVYwLC", "2853b0aca2298789045995f0615cea41638f98d85eb16f60715a5c3141ee6d4d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Add Items Screen Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "post_id": properties.postId,
        "post_type": properties.postType,
        "post_revision": properties.postRevision,
        "post_slug": properties.postSlug,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("jplqtVYwLC", "Add Items Screen Clicked", messages, [
        {id: "94vyME35Ha", name: "post_type", value: properties.postType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "nFzKmDrJrr", name: "post_slug", value: properties.postSlug},
        {id: "tVeza_1Hvq", name: "post_revision", value: properties.postRevision},
        {id: "yI66F6Raat", name: "post_id", value: properties.postId},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Add Items Screen Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Add Items Screen Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "post_id": properties.postId,
          "post_type": properties.postType,
          "post_revision": properties.postRevision,
          "post_slug": properties.postSlug,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "jplqtVYwLC", "2853b0aca2298789045995f0615cea41638f98d85eb16f60715a5c3141ee6d4d");
      }
      // destination Segment
      Segment.logEvent("Add Items Screen Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "post_id": properties.postId,
        "post_type": properties.postType,
        "post_revision": properties.postRevision,
        "post_slug": properties.postSlug,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Customer Verification Modal Viewed: Triggered when a Health customer is shown the email verification modal.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/NxCj8Ui7_x}
   */
  function customerVerificationModalViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "NxCj8Ui7_x", "482f317d49b0e3b4e928f6eb1bfa9173cf88a988eb60da33dfdca96a9fd48f91", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Customer Verification Modal Viewed", {
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("NxCj8Ui7_x", "Customer Verification Modal Viewed", messages, [
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Customer Verification Modal Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Customer Verification Modal Viewed", {
          "store_name": properties.storeName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "NxCj8Ui7_x", "482f317d49b0e3b4e928f6eb1bfa9173cf88a988eb60da33dfdca96a9fd48f91");
      }
      // destination Segment
      Segment.logEvent("Customer Verification Modal Viewed", {
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Customer Verification Modal Dismissed: Triggered when a Health customer dismisses the email verification modal without completing verification.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/Mw_-0LsCHe}
   */
  function customerVerificationModalDismissed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Mw_-0LsCHe", "4428aafad1219bbe312b559176988ed4b6bb33f6a2a955a08537512f2491752a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Customer Verification Modal Dismissed", {
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Mw_-0LsCHe", "Customer Verification Modal Dismissed", messages, [
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Customer Verification Modal Dismissed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Customer Verification Modal Dismissed", {
          "store_name": properties.storeName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "Mw_-0LsCHe", "4428aafad1219bbe312b559176988ed4b6bb33f6a2a955a08537512f2491752a");
      }
      // destination Segment
      Segment.logEvent("Customer Verification Modal Dismissed", {
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Email Capture Viewed: An event to track when a user sees the Email Capture module on Hello Baby articles. When the store is Babylist Health, this is when a user sees the Email Capture module on Babylist Health.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/1fq54buSGB}
   */
  function emailCaptureViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "1fq54buSGB", "c280825fe546d2e5c710e10320d819c115a9890eafb646919df11f64bdf000f1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Email Capture Viewed", {
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("1fq54buSGB", "Email Capture Viewed", messages, [
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Email Capture Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Email Capture Viewed", {
          "store_name": properties.storeName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "1fq54buSGB", "c280825fe546d2e5c710e10320d819c115a9890eafb646919df11f64bdf000f1");
      }
      // destination Segment
      Segment.logEvent("Email Capture Viewed", {
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * List Type Clicked: Selecting a list type during onboarding / sprinkle
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/7useqRLGbL}
   */
  function listTypeClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "7useqRLGbL", "e77ed97fc62b0dd1d22d7d4c72ba92421c477aa97a32da242adf36ff34b1a740", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("List Type Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("7useqRLGbL", "List Type Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'List Type Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("List Type Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "7useqRLGbL", "e77ed97fc62b0dd1d22d7d4c72ba92421c477aa97a32da242adf36ff34b1a740");
      }
      // destination Segment
      Segment.logEvent("List Type Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * List Created: When a new list is created
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} [properties.userFirstName] - First name of the actor triggering the event. Marked as 'Sometimes sent' for compatibility w/ legacy mobile.
   * @param {string} [properties.userLastName] - Last name of the actor triggering the event. Marked as 'Sometimes sent' for compatibility w/ legacy mobile.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/9oJjmc9GRV}
   */
  function listCreated(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalUserFirstName(properties.userFirstName));
      messages = messages.concat(assertOptionalUserLastName(properties.userLastName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "9oJjmc9GRV", "483fae3d9c921f652b4b548f4a3ecdd99e319dac40c98913a80f76bfe936268d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("List Created", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "user_first_name": properties.userFirstName,
        "user_last_name": properties.userLastName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("9oJjmc9GRV", "List Created", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "JUHzVfzt_p", name: "user_last_name", value: properties.userLastName},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "UqqJyK4STl", name: "user_first_name", value: properties.userFirstName},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'List Created': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("List Created", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "user_first_name": properties.userFirstName,
          "user_last_name": properties.userLastName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "9oJjmc9GRV", "483fae3d9c921f652b4b548f4a3ecdd99e319dac40c98913a80f76bfe936268d");
      }
      // destination Segment
      Segment.logEvent("List Created", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "user_first_name": properties.userFirstName,
        "user_last_name": properties.userLastName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * DME Pre Checkout Modal Viewed: When the modal prior to DME checkout is viewed
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {bool} properties.manualReviewRequired - signifies whether a customer's insurance requires manual review
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/ukjPXA-7Gj}
   */
  function dmePreCheckoutModalViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertManualReviewRequired(properties.manualReviewRequired));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ukjPXA-7Gj", "0c05a7129d6552a78e1cd0339f3bacdf32d95f87e150918e0ca088cdedde515e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("DME Pre Checkout Modal Viewed", {
        "store_name": properties.storeName,
        "manual_review_required": properties.manualReviewRequired,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ukjPXA-7Gj", "DME Pre Checkout Modal Viewed", messages, [
        {id: "lnMhThe37", name: "manual_review_required", value: properties.manualReviewRequired},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'DME Pre Checkout Modal Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("DME Pre Checkout Modal Viewed", {
          "store_name": properties.storeName,
          "manual_review_required": properties.manualReviewRequired,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "ukjPXA-7Gj", "0c05a7129d6552a78e1cd0339f3bacdf32d95f87e150918e0ca088cdedde515e");
      }
      // destination Segment
      Segment.logEvent("DME Pre Checkout Modal Viewed", {
        "store_name": properties.storeName,
        "manual_review_required": properties.manualReviewRequired,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Component Clicked: This event is fired when a CMS component is clicked.

event_properties:
-event_location: Store
-component_type: hero_banner | product_carousel | feature_banner | promo_banner | video | guide | navigation
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} properties.componentType - The type of CMS component
   * @param {string} [properties.contentName] - The CMS component's name in Contentful
   * @param {string} [properties.contentId] - The ID of the content item in Contentful
   * @param {int} properties.slotPosition - Where on the page the given component is rendered. The lower the number, the closer to the top of the page.
   * @param {int} [properties.positionInList] - Position of object in a list of objects. Position starts at 1.

Use Cases:
- Used to calculate average click position in Algolia. Segment maps this property to Algolia event.positions in Algolia Insights destination.
- To determine the position of a message in Message Center

   * @param {string} [properties.urlClicked] - The URL of the link that was clicked
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/44_vUYSPQR}
   */
  function componentClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertComponentType(properties.componentType));
      messages = messages.concat(assertOptionalContentName(properties.contentName));
      messages = messages.concat(assertOptionalContentId(properties.contentId));
      messages = messages.concat(assertSlotPosition(properties.slotPosition));
      messages = messages.concat(assertOptionalPositionInList(properties.positionInList));
      messages = messages.concat(assertOptionalUrlClicked(properties.urlClicked));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "44_vUYSPQR", "ecbb4e4b481188f1ae908b9c172ada93f87c5aa4e27a43ca7e592025bb35dcfa", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Component Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "component_type": properties.componentType,
        "content_name": properties.contentName,
        "content_id": properties.contentId,
        "slot_position": properties.slotPosition,
        "position_in_list": properties.positionInList,
        "url_clicked": properties.urlClicked,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("44_vUYSPQR", "Component Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "9hIUmuT0nS", name: "position_in_list", value: properties.positionInList},
        {id: "AuhMqGrHU", name: "content_id", value: properties.contentId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "Kbkh_3jyi", name: "component_type", value: properties.componentType},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "PQeYFLl2c", name: "url_clicked", value: properties.urlClicked},
        {id: "WJKbg26Iv", name: "slot_position", value: properties.slotPosition},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "spXyE0RLQ", name: "content_name", value: properties.contentName},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Component Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Component Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "component_type": properties.componentType,
          "content_name": properties.contentName,
          "content_id": properties.contentId,
          "slot_position": properties.slotPosition,
          "position_in_list": properties.positionInList,
          "url_clicked": properties.urlClicked,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "44_vUYSPQR", "ecbb4e4b481188f1ae908b9c172ada93f87c5aa4e27a43ca7e592025bb35dcfa");
      }
      // destination Segment
      Segment.logEvent("Component Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "component_type": properties.componentType,
        "content_name": properties.contentName,
        "content_id": properties.contentId,
        "slot_position": properties.slotPosition,
        "position_in_list": properties.positionInList,
        "url_clicked": properties.urlClicked,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Navbar Clicked: When an element on the Navigation Bar is clicked:

-event_location: App Bottom Nav, Web Top Nav, Mobile Web Hamburger, Mobile Web Top Utility Bar

- event_cta: Home, Registry, Shop, Guides, Add Items, Help, Settings, Logo, Start my Registry, Log Out, App Download, Find Registry, Health, Holiday, Your Orders, Login, Sign Up
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/BkCNEV1UB}
   */
  function navbarClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "BkCNEV1UB", "ded26a52003c87ca71d70cb1859e56af7a74511192903e15f4d3e2f1a15cc6f6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Navbar Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("BkCNEV1UB", "Navbar Clicked", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Navbar Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Navbar Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "BkCNEV1UB", "ded26a52003c87ca71d70cb1859e56af7a74511192903e15f4d3e2f1a15cc6f6");
      }
      // destination Segment
      Segment.logEvent("Navbar Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Sign Up Intent Shown: An event to let us know a user attempted to do something that leads them to a signup flow (example: trying to add an item from a guide while not logged in)
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/SKNZNOeX4B}
   */
  function signUpIntentShown(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "SKNZNOeX4B", "3f3bdbddff24b44d09bc92dc0cd75b82956f44c06e5d2aab92241e666c351af7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Sign Up Intent Shown", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("SKNZNOeX4B", "Sign Up Intent Shown", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Sign Up Intent Shown': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Sign Up Intent Shown", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "SKNZNOeX4B", "3f3bdbddff24b44d09bc92dc0cd75b82956f44c06e5d2aab92241e666c351af7");
      }
      // destination Segment
      Segment.logEvent("Sign Up Intent Shown", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Shipping Consolidation Updated: When shipping consolidation choice is updated.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} properties.consolidationValue - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/L_wmWqRTCG}
   */
  function shippingConsolidationUpdated(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertConsolidationValue(properties.consolidationValue));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "L_wmWqRTCG", "bab9a4722df399bb50cf67996d24f0bfc9ad202e1d3bf86feb738c8d96674fe9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Shipping Consolidation Updated", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "consolidation_value": properties.consolidationValue,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("L_wmWqRTCG", "Shipping Consolidation Updated", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "hgLh5g6P_", name: "consolidation_value", value: properties.consolidationValue},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Shipping Consolidation Updated': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Shipping Consolidation Updated", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "consolidation_value": properties.consolidationValue,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "L_wmWqRTCG", "bab9a4722df399bb50cf67996d24f0bfc9ad202e1d3bf86feb738c8d96674fe9");
      }
      // destination Segment
      Segment.logEvent("Shipping Consolidation Updated", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "consolidation_value": properties.consolidationValue,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Shipping Consolidation Viewed: When the shipping consolidation UI is viewed.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/4HVy6LrB4c}
   */
  function shippingConsolidationViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "4HVy6LrB4c", "e3b2878b5d1e3653d9866a366f98a2c398c4acb019be2d40e9435d8073f8ff2b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Shipping Consolidation Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("4HVy6LrB4c", "Shipping Consolidation Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Shipping Consolidation Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Shipping Consolidation Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "4HVy6LrB4c", "e3b2878b5d1e3653d9866a366f98a2c398c4acb019be2d40e9435d8073f8ff2b");
      }
      // destination Segment
      Segment.logEvent("Shipping Consolidation Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Find Registry Viewed: Fires when the Find My Registry (https://www.babylist.com/find) page is visited
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/326AXuNEdL}
   */
  function findRegistryViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "326AXuNEdL", "37144381f517eab3c2fa77157c3774afc379d4b96f82e7aa11413187304ea637", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Find Registry Viewed", {
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("326AXuNEdL", "Find Registry Viewed", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Find Registry Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Find Registry Viewed", {
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "326AXuNEdL", "37144381f517eab3c2fa77157c3774afc379d4b96f82e7aa11413187304ea637");
      }
      // destination Segment
      Segment.logEvent("Find Registry Viewed", {
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Health Banner Viewed: When the health banner is viewed
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} [properties.searchTerm] - Search term
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/xHN8F536dk}
   */
  function healthBannerViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalSearchTerm(properties.searchTerm));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "xHN8F536dk", "5557ef7634ed94dfe950e28f41cc05b289e0a360c4d18023a50cd9cc7cb01afa", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Health Banner Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "search_term": properties.searchTerm,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("xHN8F536dk", "Health Banner Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "DP8VA0H6RC", name: "search_term", value: properties.searchTerm},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Health Banner Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Health Banner Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "search_term": properties.searchTerm,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "xHN8F536dk", "5557ef7634ed94dfe950e28f41cc05b289e0a360c4d18023a50cd9cc7cb01afa");
      }
      // destination Segment
      Segment.logEvent("Health Banner Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "search_term": properties.searchTerm,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Health Banner Clicked: When the babylist health banner is clicked
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} [properties.searchTerm] - Search term
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/f6fvTvQLC4}
   */
  function healthBannerClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalSearchTerm(properties.searchTerm));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "f6fvTvQLC4", "42211af58fcc8b885409e746246f258fad31163a14a569594adce8775752dfb8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Health Banner Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "search_term": properties.searchTerm,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("f6fvTvQLC4", "Health Banner Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "DP8VA0H6RC", name: "search_term", value: properties.searchTerm},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Health Banner Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Health Banner Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "search_term": properties.searchTerm,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "f6fvTvQLC4", "42211af58fcc8b885409e746246f258fad31163a14a569594adce8775752dfb8");
      }
      // destination Segment
      Segment.logEvent("Health Banner Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "search_term": properties.searchTerm,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * List Shared: This event is fired when a user shares their registry
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/z_VtGyxCM}
   */
  function listShared(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "z_VtGyxCM", "e355a8ce0126b799bb54b7c241a081116d2b363a66ba0ae54e83d126f32f0677", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("List Shared", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("z_VtGyxCM", "List Shared", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'List Shared': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("List Shared", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "z_VtGyxCM", "e355a8ce0126b799bb54b7c241a081116d2b363a66ba0ae54e83d126f32f0677");
      }
      // destination Segment
      Segment.logEvent("List Shared", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * DME Pre Checkout Modal Completed: When the modal prior to DME checkout is completed
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {bool} properties.freeGiftSelected - whether or not the user selected to receive the free gift with their order
   * @param {bool} properties.manualReviewRequired - signifies whether a customer's insurance requires manual review
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/O8FxYkbJme}
   */
  function dmePreCheckoutModalCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertFreeGiftSelected(properties.freeGiftSelected));
      messages = messages.concat(assertManualReviewRequired(properties.manualReviewRequired));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "O8FxYkbJme", "bead2efeb1234fe0d653db53ef23415c86c6d1f02e40eaa088f4a7540831ef8b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("DME Pre Checkout Modal Completed", {
        "store_name": properties.storeName,
        "free_gift_selected": properties.freeGiftSelected,
        "manual_review_required": properties.manualReviewRequired,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("O8FxYkbJme", "DME Pre Checkout Modal Completed", messages, [
        {id: "5LZ4gMc0f", name: "free_gift_selected", value: properties.freeGiftSelected},
        {id: "lnMhThe37", name: "manual_review_required", value: properties.manualReviewRequired},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'DME Pre Checkout Modal Completed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("DME Pre Checkout Modal Completed", {
          "store_name": properties.storeName,
          "free_gift_selected": properties.freeGiftSelected,
          "manual_review_required": properties.manualReviewRequired,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "O8FxYkbJme", "bead2efeb1234fe0d653db53ef23415c86c6d1f02e40eaa088f4a7540831ef8b");
      }
      // destination Segment
      Segment.logEvent("DME Pre Checkout Modal Completed", {
        "store_name": properties.storeName,
        "free_gift_selected": properties.freeGiftSelected,
        "manual_review_required": properties.manualReviewRequired,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Forgot Password Viewed: Triggered when user views the Forgot Password Screen.

event_type:
• Page Viewed (When user lands on Forgot Password screen)
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.userAuthenticationMethod - The method they authenticated with.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/83hEiU1nhl}
   */
  function forgotPasswordViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertUserAuthenticationMethod(properties.userAuthenticationMethod));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "83hEiU1nhl", "4398581a919b9c13d220ff3748f84529507316aa592a42303c087b633212a332", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Forgot Password Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "user_authentication_method": properties.userAuthenticationMethod,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("83hEiU1nhl", "Forgot Password Viewed", messages, [
        {id: "-5fcT2VKC", name: "user_authentication_method", value: properties.userAuthenticationMethod},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Forgot Password Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Forgot Password Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "user_authentication_method": properties.userAuthenticationMethod,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "83hEiU1nhl", "4398581a919b9c13d220ff3748f84529507316aa592a42303c087b633212a332");
      }
      // destination Segment
      Segment.logEvent("Forgot Password Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "user_authentication_method": properties.userAuthenticationMethod,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Forgot Password Submitted: Triggered when user submits request to recover password, when clicking "send reset instructions" cta and receives a response

event_type:
• Successful (When PW reset was successfully submitted)
• Error - Unrecognized Email(When email is incorrect)
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} [properties.reqLibrary] - (Backend) Front-end library type of the client that triggered the backend event.
   * @param {string} [properties.reqPlatform] - (Backend) Platform of the client that triggered a backend event.
   * @param {string} [properties.reqDeviceType] - (Backend) Device type of the client that triggered a backend event.
   * @param {string} [properties.reqUtmTerm] - (Backend) UTM parameter attributing the term for the user's session.
   * @param {string} [properties.reqReferrer] - (Backend) Value of Document.referrer from the web client that triggered a backend event.
   * @param {string} [properties.reqUtmMedium] - (Backend) UTM parameter attributing the medium for the user's session.
   * @param {string} [properties.reqUtmSource] - (Backend) UTM parameter attributing the source for the user's session.
   * @param {string} [properties.reqBlAnonId] - (Backend) bl_anon_id for the current request
   * @param {string} [properties.reqUtmContent] - (Backend) UTM parameter attributing the content for the user's session.
   * @param {string} [properties.reqUtmCampaign] - (Backend) UTM parameter attributing the campaign for the user's session.
   * @param {string} [properties.reqLandingPage] - (Backend) The current URL of the web client that triggered a backend event.
   * @param {string} [properties.reqLastExternalReferrer] - (Backend) The most recent non-Babylist referrer URI that was recorded for the user
   * @param {string} properties.userAuthenticationMethod - The method they authenticated with.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/EHjFNHyZFj}
   */
  function forgotPasswordSubmitted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalReqLibrary(properties.reqLibrary));
      messages = messages.concat(assertOptionalReqPlatform(properties.reqPlatform));
      messages = messages.concat(assertOptionalReqDeviceType(properties.reqDeviceType));
      messages = messages.concat(assertOptionalReqUtmTerm(properties.reqUtmTerm));
      messages = messages.concat(assertOptionalReqReferrer(properties.reqReferrer));
      messages = messages.concat(assertOptionalReqUtmMedium(properties.reqUtmMedium));
      messages = messages.concat(assertOptionalReqUtmSource(properties.reqUtmSource));
      messages = messages.concat(assertOptionalReqBlAnonId(properties.reqBlAnonId));
      messages = messages.concat(assertOptionalReqUtmContent(properties.reqUtmContent));
      messages = messages.concat(assertOptionalReqUtmCampaign(properties.reqUtmCampaign));
      messages = messages.concat(assertOptionalReqLandingPage(properties.reqLandingPage));
      messages = messages.concat(assertOptionalReqLastExternalReferrer(properties.reqLastExternalReferrer));
      messages = messages.concat(assertUserAuthenticationMethod(properties.userAuthenticationMethod));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "EHjFNHyZFj", "97995053c7ec079e91908459ed7fa71356a2dce83f04bb750d6688b0ad329b91", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Forgot Password Submitted", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "req_library": properties.reqLibrary,
        "req_platform": properties.reqPlatform,
        "req_device_type": properties.reqDeviceType,
        "req_utm_term": properties.reqUtmTerm,
        "req_referrer": properties.reqReferrer,
        "req_utm_medium": properties.reqUtmMedium,
        "req_utm_source": properties.reqUtmSource,
        "req_bl_anon_id": properties.reqBlAnonId,
        "req_utm_content": properties.reqUtmContent,
        "req_utm_campaign": properties.reqUtmCampaign,
        "req_landing_page": properties.reqLandingPage,
        "req_last_external_referrer": properties.reqLastExternalReferrer,
        "user_authentication_method": properties.userAuthenticationMethod,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("EHjFNHyZFj", "Forgot Password Submitted", messages, [
        {id: "-5fcT2VKC", name: "user_authentication_method", value: properties.userAuthenticationMethod},
        {id: "2evh-NL9K4", name: "req_device_type", value: properties.reqDeviceType},
        {id: "3cepIA03RI", name: "req_bl_anon_id", value: properties.reqBlAnonId},
        {id: "7hn8qCCpUt", name: "req_library", value: properties.reqLibrary},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "FZC-2sIqqH", name: "req_utm_term", value: properties.reqUtmTerm},
        {id: "Jn1_yHbURD", name: "req_landing_page", value: properties.reqLandingPage},
        {id: "NwyX62Z4r2", name: "req_last_external_referrer", value: properties.reqLastExternalReferrer},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "e2tQHS2Tb5", name: "req_utm_content", value: properties.reqUtmContent},
        {id: "fjC5ZBjHZ5", name: "req_platform", value: properties.reqPlatform},
        {id: "hH2iVCa9I1", name: "req_utm_source", value: properties.reqUtmSource},
        {id: "sjQiDoAwhk", name: "req_utm_medium", value: properties.reqUtmMedium},
        {id: "x4OTktHTFo", name: "req_utm_campaign", value: properties.reqUtmCampaign},
        {id: "xIHFyif3OA", name: "req_referrer", value: properties.reqReferrer},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Forgot Password Submitted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Forgot Password Submitted", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "req_library": properties.reqLibrary,
          "req_platform": properties.reqPlatform,
          "req_device_type": properties.reqDeviceType,
          "req_utm_term": properties.reqUtmTerm,
          "req_referrer": properties.reqReferrer,
          "req_utm_medium": properties.reqUtmMedium,
          "req_utm_source": properties.reqUtmSource,
          "req_bl_anon_id": properties.reqBlAnonId,
          "req_utm_content": properties.reqUtmContent,
          "req_utm_campaign": properties.reqUtmCampaign,
          "req_landing_page": properties.reqLandingPage,
          "req_last_external_referrer": properties.reqLastExternalReferrer,
          "user_authentication_method": properties.userAuthenticationMethod,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "EHjFNHyZFj", "97995053c7ec079e91908459ed7fa71356a2dce83f04bb750d6688b0ad329b91");
      }
      // destination Segment
      Segment.logEvent("Forgot Password Submitted", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "req_library": properties.reqLibrary,
        "req_platform": properties.reqPlatform,
        "req_device_type": properties.reqDeviceType,
        "req_utm_term": properties.reqUtmTerm,
        "req_referrer": properties.reqReferrer,
        "req_utm_medium": properties.reqUtmMedium,
        "req_utm_source": properties.reqUtmSource,
        "req_bl_anon_id": properties.reqBlAnonId,
        "req_utm_content": properties.reqUtmContent,
        "req_utm_campaign": properties.reqUtmCampaign,
        "req_landing_page": properties.reqLandingPage,
        "req_last_external_referrer": properties.reqLastExternalReferrer,
        "user_authentication_method": properties.userAuthenticationMethod,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Log In Submitted: This backend event is fired when a response is returned after a user attempts to Log In (whether successful or if there was an error). The response is recorded in the event type property.

- event_location: Log In - Verify Email Password, Log In - Submit Email Password
- user_authentication_method: Apple, Google, Email
- event_type: Successful, Error - Invalid Credentials
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.userAuthenticationMethod - The method they authenticated with.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/N4NcE7g4fe}
   */
  function logInSubmitted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertUserAuthenticationMethod(properties.userAuthenticationMethod));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "N4NcE7g4fe", "72f81c50cbcb278c6e73a6a9f3473dbe921fd19f6629b70a1403c0fb04a0250a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Log In Submitted", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "user_authentication_method": properties.userAuthenticationMethod,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("N4NcE7g4fe", "Log In Submitted", messages, [
        {id: "-5fcT2VKC", name: "user_authentication_method", value: properties.userAuthenticationMethod},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Log In Submitted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Log In Submitted", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "user_authentication_method": properties.userAuthenticationMethod,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "N4NcE7g4fe", "72f81c50cbcb278c6e73a6a9f3473dbe921fd19f6629b70a1403c0fb04a0250a");
      }
      // destination Segment
      Segment.logEvent("Log In Submitted", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "user_authentication_method": properties.userAuthenticationMethod,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Sign Up Step Processed: User sign up, fire when the account already exists, the user has to validate name or email
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.userAuthenticationMethod - The method they authenticated with.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/oCxAoQ8qnd}
   */
  function signUpStepProcessed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertUserAuthenticationMethod(properties.userAuthenticationMethod));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "oCxAoQ8qnd", "417e6abd22bebf7144b696eff027d70a23b95a28bedfb5d33f85979861aa5fb7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Sign Up Step Processed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "user_authentication_method": properties.userAuthenticationMethod,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("oCxAoQ8qnd", "Sign Up Step Processed", messages, [
        {id: "-5fcT2VKC", name: "user_authentication_method", value: properties.userAuthenticationMethod},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Sign Up Step Processed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Sign Up Step Processed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "user_authentication_method": properties.userAuthenticationMethod,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "oCxAoQ8qnd", "417e6abd22bebf7144b696eff027d70a23b95a28bedfb5d33f85979861aa5fb7");
      }
      // destination Segment
      Segment.logEvent("Sign Up Step Processed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "user_authentication_method": properties.userAuthenticationMethod,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Log In Step Processed: Triggered when a user screen event_location will be used to indicate where in the login flow someone is. They will be named after the different screens.

   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.userAuthenticationMethod - The method they authenticated with.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/lyRUw0uQbW}
   */
  function logInStepProcessed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertUserAuthenticationMethod(properties.userAuthenticationMethod));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "lyRUw0uQbW", "8b97a69af8b2e18309e8816b6294c1385d49b787854e173fe88300646f30c665", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Log In Step Processed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "user_authentication_method": properties.userAuthenticationMethod,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("lyRUw0uQbW", "Log In Step Processed", messages, [
        {id: "-5fcT2VKC", name: "user_authentication_method", value: properties.userAuthenticationMethod},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Log In Step Processed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Log In Step Processed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "user_authentication_method": properties.userAuthenticationMethod,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "lyRUw0uQbW", "8b97a69af8b2e18309e8816b6294c1385d49b787854e173fe88300646f30c665");
      }
      // destination Segment
      Segment.logEvent("Log In Step Processed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "user_authentication_method": properties.userAuthenticationMethod,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Page Viewed: Generic page viewed event fired when a page or screen is loaded.

When the Event Location = Shipments, then the entry point should be one of:
    account_menu, gift_tracker, mobile_navbar, feed_notice_bundle, feed_notice_shipment,
    orders

When the Event Location = Orders, then the entry point should be one of:
    account_menu, settings, shipments
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} properties.consolidationValue - no description
   * @param {string} [properties.entryPoint] - Used for page view events.  Describes the method of entry used to access the view.  For any given event, this property should take on one of a small list of expected values (which will differ for each event).
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/0olbTcmu3h}
   */
  function pageViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertConsolidationValue(properties.consolidationValue));
      messages = messages.concat(assertOptionalEntryPoint(properties.entryPoint));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "0olbTcmu3h", "9fbc4c2c66a6c2333b8a0a216841fc25f9fc02cf09f970c537a3c6837b6d512e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Page Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "consolidation_value": properties.consolidationValue,
        "entry_point": properties.entryPoint,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("0olbTcmu3h", "Page Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "SEpbyxPtUJ", name: "entry_point", value: properties.entryPoint},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "hgLh5g6P_", name: "consolidation_value", value: properties.consolidationValue},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Page Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Page Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "consolidation_value": properties.consolidationValue,
          "entry_point": properties.entryPoint,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "0olbTcmu3h", "9fbc4c2c66a6c2333b8a0a216841fc25f9fc02cf09f970c537a3c6837b6d512e");
      }
      // destination Segment
      Segment.logEvent("Page Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "consolidation_value": properties.consolidationValue,
        "entry_point": properties.entryPoint,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Setup Step Clicked: Triggered when user clicks on a Registry Setup Step on either App or Web. You will be able to determine which registry step was clicked by looking at `event_cta`
   *
   * @param {object} properties - the properties associatied with this event
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/xeJZQe0AQp}
   */
  function registrySetupStepClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "xeJZQe0AQp", "8831e9d71f0a08c923d0b5956ec9249c66efaa3b25494b206b984d77b3e46f47", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Setup Step Clicked", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("xeJZQe0AQp", "Registry Setup Step Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Setup Step Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Setup Step Clicked", {
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "xeJZQe0AQp", "8831e9d71f0a08c923d0b5956ec9249c66efaa3b25494b206b984d77b3e46f47");
      }
      // destination Segment
      Segment.logEvent("Registry Setup Step Clicked", {
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * External Registry Contact Support Clicked: Fired when a user clicks the "Contact CS" button int he external registry flow.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} properties.externalRegistryMergeType - Merge type for an external registry request.
   * @param {string} properties.externalRegistryUrl - URL of an external registry
   * @param {string} properties.externalStoreName - Name of an external (third-party) store

When Triggered From External Registry Transfer
Pass the store domain of the external registry

When Triggered From Proceeded to Buy:
Pass the actual value of the store name.
   * @param {string} [properties.externalRegistryCanonicalUrl] - Canonical URL of an external registry. This is the external registry URL after it is passed through normalization. This value should match up with the value stored in the external_registries table
   * @param {string} [properties.errorMessage] - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/m33mnaKN1L}
   */
  function externalRegistryContactSupportClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertExternalRegistryMergeType(properties.externalRegistryMergeType));
      messages = messages.concat(assertExternalRegistryUrl(properties.externalRegistryUrl));
      messages = messages.concat(assertExternalStoreName(properties.externalStoreName));
      messages = messages.concat(assertOptionalExternalRegistryCanonicalUrl(properties.externalRegistryCanonicalUrl));
      messages = messages.concat(assertOptionalErrorMessage(properties.errorMessage));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "m33mnaKN1L", "139690fa379609cc0cd65155a74e1e048c908fa7ebcd91350312c61c21abb31a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("External Registry Contact Support Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "external_registry_merge_type": properties.externalRegistryMergeType,
        "external_registry_url": properties.externalRegistryUrl,
        "external_store_name": properties.externalStoreName,
        "external_registry_canonical_url": properties.externalRegistryCanonicalUrl,
        "error_message": properties.errorMessage,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("m33mnaKN1L", "External Registry Contact Support Clicked", messages, [
        {id: "8Cxs_Nq4i", name: "external_registry_url", value: properties.externalRegistryUrl},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "Jpho3Mg1f", name: "error_message", value: properties.errorMessage},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "czcBAIKvtf", name: "external_store_name", value: properties.externalStoreName},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "rUGWKcAvL", name: "external_registry_merge_type", value: properties.externalRegistryMergeType},
        {id: "z_s_3ch01", name: "external_registry_canonical_url", value: properties.externalRegistryCanonicalUrl},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'External Registry Contact Support Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("External Registry Contact Support Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "external_registry_merge_type": properties.externalRegistryMergeType,
          "external_registry_url": properties.externalRegistryUrl,
          "external_store_name": properties.externalStoreName,
          "external_registry_canonical_url": properties.externalRegistryCanonicalUrl,
          "error_message": properties.errorMessage,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "m33mnaKN1L", "139690fa379609cc0cd65155a74e1e048c908fa7ebcd91350312c61c21abb31a");
      }
      // destination Segment
      Segment.logEvent("External Registry Contact Support Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "external_registry_merge_type": properties.externalRegistryMergeType,
        "external_registry_url": properties.externalRegistryUrl,
        "external_store_name": properties.externalStoreName,
        "external_registry_canonical_url": properties.externalRegistryCanonicalUrl,
        "error_message": properties.errorMessage,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Babylist Pop-Up Blocked: Triggered when a user attempts to add an item to their registry by using the bookmarklet or extension and the pop-up is blocked
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/0YLg22QLTY_}
   */
  function babylistPopUpBlocked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "0YLg22QLTY_", "8877c4e0170fa2f2ad62a98396566315f25f74bc8409afe65bf93ba65cfe257a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Babylist Pop-Up Blocked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("0YLg22QLTY_", "Babylist Pop-Up Blocked", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Babylist Pop-Up Blocked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Babylist Pop-Up Blocked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "0YLg22QLTY_", "8877c4e0170fa2f2ad62a98396566315f25f74bc8409afe65bf93ba65cfe257a");
      }
      // destination Segment
      Segment.logEvent("Babylist Pop-Up Blocked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Replacement Parts Order Form Viewed : Triggered when the user views the replacement parts order form.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/be0isHnlr}
   */
  function replacementPartsOrderFormViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "be0isHnlr", "980f9098710fbe84247cc38051875731e3683059447b986e6e49de69e64e7a6d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Replacement Parts Order Form Viewed ", {
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("be0isHnlr", "Replacement Parts Order Form Viewed ", messages, [
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Replacement Parts Order Form Viewed ': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Replacement Parts Order Form Viewed ", {
          "store_name": properties.storeName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "be0isHnlr", "980f9098710fbe84247cc38051875731e3683059447b986e6e49de69e64e7a6d");
      }
      // destination Segment
      Segment.logEvent("Replacement Parts Order Form Viewed ", {
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Replacement Parts Order Blocker Viewed: Triggered when a user encounters a blocker preventing them from placing a replacement parts order.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   * @param {string} properties.blockerType - Indicates the type/reason for the blocker.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/5X2vrl8UB}
   */
  function replacementPartsOrderBlockerViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertBlockerType(properties.blockerType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "5X2vrl8UB", "76247102bc821612da10a0214a899ead7da83dd247f430d2e092a9a87e6ddb48", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Replacement Parts Order Blocker Viewed", {
        "store_name": properties.storeName,
        "blocker_type": properties.blockerType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("5X2vrl8UB", "Replacement Parts Order Blocker Viewed", messages, [
        {id: "JF9Kviyl_", name: "blocker_type", value: properties.blockerType},
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Replacement Parts Order Blocker Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Replacement Parts Order Blocker Viewed", {
          "store_name": properties.storeName,
          "blocker_type": properties.blockerType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "5X2vrl8UB", "76247102bc821612da10a0214a899ead7da83dd247f430d2e092a9a87e6ddb48");
      }
      // destination Segment
      Segment.logEvent("Replacement Parts Order Blocker Viewed", {
        "store_name": properties.storeName,
        "blocker_type": properties.blockerType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Replacement Parts New Insurance Form Viewed: Triggered when the user views the New Insurance Form.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.storeName] - This property represents the url of the website. It's used to help distinguish which events came from babylist.com and health.babylist.com
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/eGKAplz8a}
   */
  function replacementPartsNewInsuranceFormViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalStoreName(properties.storeName));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "eGKAplz8a", "245ab646a2a2eb35bdb18cd5c6278acd85ab99edfe42f385a5829658ee09e3b9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Replacement Parts New Insurance Form Viewed", {
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("eGKAplz8a", "Replacement Parts New Insurance Form Viewed", messages, [
        {id: "xO6nLm6j6K", name: "store_name", value: properties.storeName},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Replacement Parts New Insurance Form Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Replacement Parts New Insurance Form Viewed", {
          "store_name": properties.storeName,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "eGKAplz8a", "245ab646a2a2eb35bdb18cd5c6278acd85ab99edfe42f385a5829658ee09e3b9");
      }
      // destination Segment
      Segment.logEvent("Replacement Parts New Insurance Form Viewed", {
        "store_name": properties.storeName,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Search Executed: This event fires when a user executes a search by either hitting return after typing something into a search bar or selecting a search preview.

Event Type -  Shop, Guide, Registry, Unified
Event Location - The page the user is currently on
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} [properties.searchId] - ID of Algolia query which generated the original list of search results. Used by Algolia to attribute an event to a specific query for click conversion metrics. Segment maps this property to Algolia event.queryID in Algolia Insights destination.
   * @param {string} properties.searchTerm - Search term
   * @param {string} [properties.initialSearchBarSize] - This property captures the size of the search bar when it is inactive.  The two possible values are expanded (the user sees a search bar with some instructive text) or icon (the user sees only a magnifying glass icon that they can click to expand).
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/KaQdc4XnN9}
   */
  function searchExecuted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalSearchId(properties.searchId));
      messages = messages.concat(assertSearchTerm(properties.searchTerm));
      messages = messages.concat(assertOptionalInitialSearchBarSize(properties.initialSearchBarSize));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "KaQdc4XnN9", "7b4ad761ff14f8e5c5294006f153520ee39161abfc7bd03663bbebb7d661412a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Search Executed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "search_id": properties.searchId,
        "search_term": properties.searchTerm,
        "initial_search_bar_size": properties.initialSearchBarSize,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("KaQdc4XnN9", "Search Executed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "DP8VA0H6RC", name: "search_term", value: properties.searchTerm},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "VlL55_rwx1", name: "search_id", value: properties.searchId},
        {id: "_rOlgjAh0G", name: "initial_search_bar_size", value: properties.initialSearchBarSize},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Search Executed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Search Executed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "search_id": properties.searchId,
          "search_term": properties.searchTerm,
          "initial_search_bar_size": properties.initialSearchBarSize,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "KaQdc4XnN9", "7b4ad761ff14f8e5c5294006f153520ee39161abfc7bd03663bbebb7d661412a");
      }
      // destination Segment
      Segment.logEvent("Search Executed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "search_id": properties.searchId,
        "search_term": properties.searchTerm,
        "initial_search_bar_size": properties.initialSearchBarSize,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Search Results Page Viewed: This event fires when a user views a search results page.  There are two ways this can happen: either a user executes a search OR someone enters a url into their browser of the form https://www.babylist.com/store/search?search_term=some_search_term.

Event Type - Shop, Guide, Registry, Unified
Event Location - Shop, Guide, Registry
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} properties.searchTerm - Search term
   * @param {string} [properties.searchId] - ID of Algolia query which generated the original list of search results. Used by Algolia to attribute an event to a specific query for click conversion metrics. Segment maps this property to Algolia event.queryID in Algolia Insights destination.
   * @param {int} properties.resultCount - The number of search results that get returned.
   * @param {Array<string>} properties.top20Results - Serialized list of the first twenty search results that are returned.
   * @param {bool} properties.executedSearch - Was the results page viewed by executing a search (value TRUE), meaning initiated by either hitting return on a search query or clicking a search suggestion, or was the results page arrived at by typing a URL (value FALSE).
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/ok1yzL3FLM}
   */
  function searchResultsPageViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertSearchTerm(properties.searchTerm));
      messages = messages.concat(assertOptionalSearchId(properties.searchId));
      messages = messages.concat(assertResultCount(properties.resultCount));
      messages = messages.concat(assertTop20Results(properties.top20Results));
      messages = messages.concat(assertExecutedSearch(properties.executedSearch));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ok1yzL3FLM", "3c9aff9f37a64ad9d15009fb54a6edbdd91861102e7b55e1da3526ba46b91cf5", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Search Results Page Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "search_term": properties.searchTerm,
        "search_id": properties.searchId,
        "result_count": properties.resultCount,
        "top_20_results": properties.top20Results,
        "executed_search": properties.executedSearch,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ok1yzL3FLM", "Search Results Page Viewed", messages, [
        {id: "3gjxIHhWK", name: "top_20_results", value: properties.top20Results},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "DP8VA0H6RC", name: "search_term", value: properties.searchTerm},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "VPXPSm5669", name: "result_count", value: properties.resultCount},
        {id: "VlL55_rwx1", name: "search_id", value: properties.searchId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "o1QaPjYEr", name: "executed_search", value: properties.executedSearch},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Search Results Page Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Search Results Page Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "search_term": properties.searchTerm,
          "search_id": properties.searchId,
          "result_count": properties.resultCount,
          "top_20_results": properties.top20Results,
          "executed_search": properties.executedSearch,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "ok1yzL3FLM", "3c9aff9f37a64ad9d15009fb54a6edbdd91861102e7b55e1da3526ba46b91cf5");
      }
      // destination Segment
      Segment.logEvent("Search Results Page Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "search_term": properties.searchTerm,
        "search_id": properties.searchId,
        "result_count": properties.resultCount,
        "top_20_results": properties.top20Results,
        "executed_search": properties.executedSearch,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Stock Notification Request Clicked: To track when a User requests an in-stock notification for a Product.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/fy65Tzf4mK}
   */
  function stockNotificationRequestClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "fy65Tzf4mK", "4ab4f67adc3a3e584ec86399c9f035e39b34ff9e304bc767a3df5e8798766fd4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Stock Notification Request Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("fy65Tzf4mK", "Stock Notification Request Clicked", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Stock Notification Request Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Stock Notification Request Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "product_ids": properties.productIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "fy65Tzf4mK", "4ab4f67adc3a3e584ec86399c9f035e39b34ff9e304bc767a3df5e8798766fd4");
      }
      // destination Segment
      Segment.logEvent("Stock Notification Request Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "product_ids": properties.productIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Buy on Amazon Button Clicked: Tracks clicks to the 'Buy on Amazon' button in the 'Amazon Cart' to determine how often this feature is being used.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {Array<int>} [properties.regItemIds] - This is the targeted list of reg item ids. For events that operate on a single product like Added to Registry, it is a list of 1 reg_item_id.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/ivz7oEWewV}
   */
  function buyOnAmazonButtonClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertOptionalRegItemIds(properties.regItemIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ivz7oEWewV", "05072be7c1e46d70bd90785f62ae5f726c6c26200b451e9cae405adcf5982960", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Buy on Amazon Button Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "registry_id": properties.registryId,
        "product_ids": properties.productIds,
        "reg_item_ids": properties.regItemIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ivz7oEWewV", "Buy on Amazon Button Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "w4Er1Tq_Sl", name: "reg_item_ids", value: properties.regItemIds},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Buy on Amazon Button Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Buy on Amazon Button Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "registry_id": properties.registryId,
          "product_ids": properties.productIds,
          "reg_item_ids": properties.regItemIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "ivz7oEWewV", "05072be7c1e46d70bd90785f62ae5f726c6c26200b451e9cae405adcf5982960");
      }
      // destination Segment
      Segment.logEvent("Buy on Amazon Button Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "registry_id": properties.registryId,
        "product_ids": properties.productIds,
        "reg_item_ids": properties.regItemIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Inbox Opened: Triggered when the Inbox for Message Center is opened.

- event_location: Message Center Inbox

   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} properties.inboxId - The ID of the inbox in Message Center

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/HSM5q2G6Y-}
   */
  function inboxOpened(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertInboxId(properties.inboxId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "HSM5q2G6Y-", "4a240af4b8109061beddd159c8eff9fb0c8f9bdbcae37d9fa49fd1cfa24e3724", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Inbox Opened", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "inbox_id": properties.inboxId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("HSM5q2G6Y-", "Inbox Opened", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "QmI5NOtzp", name: "inbox_id", value: properties.inboxId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Inbox Opened': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Inbox Opened", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "inbox_id": properties.inboxId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "HSM5q2G6Y-", "4a240af4b8109061beddd159c8eff9fb0c8f9bdbcae37d9fa49fd1cfa24e3724");
      }
      // destination Segment
      Segment.logEvent("Inbox Opened", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "inbox_id": properties.inboxId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Message Viewed: Event fires when user views message, triggered when user opens the Inbox and the message is rendered on the screen.

- event_location: Message Center Inbox
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} properties.messageId - The ID of the message in the Message Center

   * @param {int} [properties.positionInList] - Position of object in a list of objects. Position starts at 1.

Use Cases:
- Used to calculate average click position in Algolia. Segment maps this property to Algolia event.positions in Algolia Insights destination.
- To determine the position of a message in Message Center

   * @param {string} properties.inboxId - The ID of the inbox in Message Center

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/aV3kLeZA99}
   */
  function messageViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertMessageId(properties.messageId));
      messages = messages.concat(assertOptionalPositionInList(properties.positionInList));
      messages = messages.concat(assertInboxId(properties.inboxId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "aV3kLeZA99", "dc7d6612b56ef8f4239156d3304852d86326b90930e7ed19708c68b51345f26c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Message Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "message_id": properties.messageId,
        "position_in_list": properties.positionInList,
        "inbox_id": properties.inboxId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("aV3kLeZA99", "Message Viewed", messages, [
        {id: "8mW_BCBJR", name: "message_id", value: properties.messageId},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "9hIUmuT0nS", name: "position_in_list", value: properties.positionInList},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "QmI5NOtzp", name: "inbox_id", value: properties.inboxId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Message Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Message Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "message_id": properties.messageId,
          "position_in_list": properties.positionInList,
          "inbox_id": properties.inboxId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "aV3kLeZA99", "dc7d6612b56ef8f4239156d3304852d86326b90930e7ed19708c68b51345f26c");
      }
      // destination Segment
      Segment.logEvent("Message Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "message_id": properties.messageId,
        "position_in_list": properties.positionInList,
        "inbox_id": properties.inboxId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Message Clicked: Event fires when a user clicks on a message within the Inbox in Message Center and directly from a Push Notification.

-event_location: Push Notification or Message Center Inbox
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} properties.messageId - The ID of the message in the Message Center

   * @param {int} [properties.positionInList] - Position of object in a list of objects. Position starts at 1.

Use Cases:
- Used to calculate average click position in Algolia. Segment maps this property to Algolia event.positions in Algolia Insights destination.
- To determine the position of a message in Message Center

   * @param {string} properties.inboxId - The ID of the inbox in Message Center

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/pywkQH61_u}
   */
  function messageClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertMessageId(properties.messageId));
      messages = messages.concat(assertOptionalPositionInList(properties.positionInList));
      messages = messages.concat(assertInboxId(properties.inboxId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "pywkQH61_u", "f9c46787bc8828db395328ef5bccedadc049782ade57c7beeb80ccb5259d14aa", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Message Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "message_id": properties.messageId,
        "position_in_list": properties.positionInList,
        "inbox_id": properties.inboxId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("pywkQH61_u", "Message Clicked", messages, [
        {id: "8mW_BCBJR", name: "message_id", value: properties.messageId},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "9hIUmuT0nS", name: "position_in_list", value: properties.positionInList},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "QmI5NOtzp", name: "inbox_id", value: properties.inboxId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Message Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Message Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "message_id": properties.messageId,
          "position_in_list": properties.positionInList,
          "inbox_id": properties.inboxId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "pywkQH61_u", "f9c46787bc8828db395328ef5bccedadc049782ade57c7beeb80ccb5259d14aa");
      }
      // destination Segment
      Segment.logEvent("Message Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "message_id": properties.messageId,
        "position_in_list": properties.positionInList,
        "inbox_id": properties.inboxId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Message Deleted: Event triggered when user deletes a message in their Message Center Inbox.

- event_location: Message Center Inbox
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} properties.messageId - The ID of the message in the Message Center

   * @param {string} properties.inboxId - The ID of the inbox in Message Center

   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/dAHonB_vUv}
   */
  function messageDeleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertMessageId(properties.messageId));
      messages = messages.concat(assertInboxId(properties.inboxId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "dAHonB_vUv", "2ef4f216ba15cfcaa6af897f70361e01a721010361b88ceae01fc2fa20df39fc", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Message Deleted", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "message_id": properties.messageId,
        "inbox_id": properties.inboxId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("dAHonB_vUv", "Message Deleted", messages, [
        {id: "8mW_BCBJR", name: "message_id", value: properties.messageId},
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "QmI5NOtzp", name: "inbox_id", value: properties.inboxId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Message Deleted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Message Deleted", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "message_id": properties.messageId,
          "inbox_id": properties.inboxId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "dAHonB_vUv", "2ef4f216ba15cfcaa6af897f70361e01a721010361b88ceae01fc2fa20df39fc");
      }
      // destination Segment
      Segment.logEvent("Message Deleted", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "message_id": properties.messageId,
        "inbox_id": properties.inboxId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Guest View Clicked: Event is triggered when a user clicks "Guest View" to view their registry as a guest. On the App it can be accessed from the hamburger menu Registry > Actions and clicking "View Registry as Guest" or from the Registry View by clicking "Guest View"

- event_location: Registry, Settings

   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/wOduRMzF16}
   */
  function guestViewClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wOduRMzF16", "9ae7b6fa790c699b970d74a74a6e8d105cd8e4b5a9a532f7dc5b1deb4a9f9af2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Guest View Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wOduRMzF16", "Guest View Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Guest View Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Guest View Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "wOduRMzF16", "9ae7b6fa790c699b970d74a74a6e8d105cd8e4b5a9a532f7dc5b1deb4a9f9af2");
      }
      // destination Segment
      Segment.logEvent("Guest View Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Visibility & Privacy Clicked: Event is triggered when the Visibility & Privacy settings are clicked. This can be accessed on the App either through the hamburger menu Registry > Settings or directly from the Registry view where the cta is Public or Private (depending on the current privacy status of the registry).

- event_location: Settings, Registry
- event_cta: Visibility & Privacy, Public, Private
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/_r1EsYyEiD}
   */
  function visibilityPrivacyClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "_r1EsYyEiD", "17fe393cf0898e261afd01f8c28f02d5ea5395c1d888988a49872a659b1ca6eb", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Visibility & Privacy Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("_r1EsYyEiD", "Visibility & Privacy Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visibility & Privacy Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visibility & Privacy Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "_r1EsYyEiD", "17fe393cf0898e261afd01f8c28f02d5ea5395c1d888988a49872a659b1ca6eb");
      }
      // destination Segment
      Segment.logEvent("Visibility & Privacy Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Gift Tracker Clicked: Event triggers when the user clicks on Gift Tracker. On the App it can be accessed from the hamburger menu Registry > Actions or from the Home Feed Screen by clicking Gifts Purchased.

- event_location: Feed, Settings
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/m97mdohrFn}
   */
  function giftTrackerClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "m97mdohrFn", "e4b5d9e4970855cc248733e4721c94ff1405b02fd55bf955829525ebf7699cf8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Gift Tracker Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("m97mdohrFn", "Gift Tracker Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Gift Tracker Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Gift Tracker Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "m97mdohrFn", "e4b5d9e4970855cc248733e4721c94ff1405b02fd55bf955829525ebf7699cf8");
      }
      // destination Segment
      Segment.logEvent("Gift Tracker Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Sign Up Submitted: This backend event is fired when a response is returned after a user has attempted to Sign Up. The response is recorded in the event type property.

- event_location: Sign Up - Start
- user_authentication_method: Google, Apple, Email
- event_type: Successful, Error - Invalid Credentials, Unknown
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.userAuthenticationMethod - The method they authenticated with.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/dfmhRuuG4Ah}
   */
  function signUpSubmitted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertUserAuthenticationMethod(properties.userAuthenticationMethod));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "dfmhRuuG4Ah", "138eb18893911c3fbf4d46901daf55b070a6e67c3a98766122fd6c1b3ba8a3c7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Sign Up Submitted", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "user_authentication_method": properties.userAuthenticationMethod,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("dfmhRuuG4Ah", "Sign Up Submitted", messages, [
        {id: "-5fcT2VKC", name: "user_authentication_method", value: properties.userAuthenticationMethod},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Sign Up Submitted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Sign Up Submitted", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "user_authentication_method": properties.userAuthenticationMethod,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "dfmhRuuG4Ah", "138eb18893911c3fbf4d46901daf55b070a6e67c3a98766122fd6c1b3ba8a3c7");
      }
      // destination Segment
      Segment.logEvent("Sign Up Submitted", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "user_authentication_method": properties.userAuthenticationMethod,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Tooltip Clicked: This event is fired when a user clicks on the tooltip.
- event location: PDP
- event_type: FSA/HSA
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {float} properties.productPrice - Price displayed for the product
   * @param {string} properties.productType - Type of the product
   * @param {bool} [properties.isFsaHsaEligible] - This property describes whether a product is eligible for FSA/HSA.
   * @param {string} [properties.pdpType] - We have several different PDP variations. This will give us insight into which variation of the PDP the user is currently on.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/kLC7xIfj8I}
   */
  function tooltipClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertProductPrice(properties.productPrice));
      messages = messages.concat(assertProductType(properties.productType));
      messages = messages.concat(assertOptionalIsFsaHsaEligible(properties.isFsaHsaEligible));
      messages = messages.concat(assertOptionalPdpType(properties.pdpType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "kLC7xIfj8I", "8515b959037988e50a936857c9d8afa234ec0e79f4479d6c2fef5b4528ff9e39", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Tooltip Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
        "pdp_type": properties.pdpType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("kLC7xIfj8I", "Tooltip Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "h12bnVZfao", name: "pdp_type", value: properties.pdpType},
        {id: "hHOUpzCIx2", name: "product_price", value: properties.productPrice},
        {id: "hh5IW9vG8X", name: "product_type", value: properties.productType},
        {id: "kN_aicHWKA", name: "is_fsa_hsa_eligible", value: properties.isFsaHsaEligible},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Tooltip Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Tooltip Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "product_price": properties.productPrice,
          "product_type": properties.productType,
          "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
          "pdp_type": properties.pdpType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "kLC7xIfj8I", "8515b959037988e50a936857c9d8afa234ec0e79f4479d6c2fef5b4528ff9e39");
      }
      // destination Segment
      Segment.logEvent("Tooltip Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
        "pdp_type": properties.pdpType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Category Teaser Clicked: Category Teaser Clicked is triggered when the user clicks on the link in the category teaser text.

event_properties
- event_cta: Learn More
- event_location: Store - Category
- event_type: None
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.storeCategorySlug - no description
   * @param {string} properties.storeCategoryName - Name of the store category that the user clicked on inside the left hand or top nav
   * @param {string} properties.urlClicked - The URL of the link that was clicked
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/YXyJK_GER0}
   */
  function categoryTeaserClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertStoreCategorySlug(properties.storeCategorySlug));
      messages = messages.concat(assertStoreCategoryName(properties.storeCategoryName));
      messages = messages.concat(assertUrlClicked(properties.urlClicked));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "YXyJK_GER0", "f1972e361ce1b5a2eb7ad4a402185f7e328575bea8a65206980c75a028a25ca0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Category Teaser Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "store_category_slug": properties.storeCategorySlug,
        "store_category_name": properties.storeCategoryName,
        "url_clicked": properties.urlClicked,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("YXyJK_GER0", "Category Teaser Clicked", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IT3W1-U_HY", name: "store_category_name", value: properties.storeCategoryName},
        {id: "PQeYFLl2c", name: "url_clicked", value: properties.urlClicked},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "yyDNRm_pnV", name: "store_category_slug", value: properties.storeCategorySlug},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Category Teaser Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Category Teaser Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "store_category_slug": properties.storeCategorySlug,
          "store_category_name": properties.storeCategoryName,
          "url_clicked": properties.urlClicked,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "YXyJK_GER0", "f1972e361ce1b5a2eb7ad4a402185f7e328575bea8a65206980c75a028a25ca0");
      }
      // destination Segment
      Segment.logEvent("Category Teaser Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "store_category_slug": properties.storeCategorySlug,
        "store_category_name": properties.storeCategoryName,
        "url_clicked": properties.urlClicked,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Store Category Clicked: Store Category Clicked is triggered when a user clicks on a category page. User can initiate this action from one of several places.

event_properties
- event_type: None
- event_location: Shop - Flyout Nav | Shop - Left Nav | Shop - Image Nav | Shop - Breadcrumbs | Footer | Checklist Category | Mobile Web Hamburger | Mobil Web - Category Drop Down
- event_cta: None
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.storeCategoryName - Name of the store category that the user clicked on inside the left hand or top nav
   * @param {bool} properties.isLeafCategory - no description
   * @param {string} properties.storeCategorySlug - no description
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/lTXwu9Seg6}
   */
  function storeCategoryClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertStoreCategoryName(properties.storeCategoryName));
      messages = messages.concat(assertIsLeafCategory(properties.isLeafCategory));
      messages = messages.concat(assertStoreCategorySlug(properties.storeCategorySlug));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "lTXwu9Seg6", "e14e73c7e8be7f1adf2901a6948f66fca1baf23694498de3f872bc5892d6debf", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Store Category Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "store_category_name": properties.storeCategoryName,
        "is_leaf_category": properties.isLeafCategory,
        "store_category_slug": properties.storeCategorySlug,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("lTXwu9Seg6", "Store Category Clicked", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IT3W1-U_HY", name: "store_category_name", value: properties.storeCategoryName},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "l-ZBlkTiq4", name: "is_leaf_category", value: properties.isLeafCategory},
        {id: "yyDNRm_pnV", name: "store_category_slug", value: properties.storeCategorySlug},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Store Category Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Store Category Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "store_category_name": properties.storeCategoryName,
          "is_leaf_category": properties.isLeafCategory,
          "store_category_slug": properties.storeCategorySlug,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "lTXwu9Seg6", "e14e73c7e8be7f1adf2901a6948f66fca1baf23694498de3f872bc5892d6debf");
      }
      // destination Segment
      Segment.logEvent("Store Category Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "store_category_name": properties.storeCategoryName,
        "is_leaf_category": properties.isLeafCategory,
        "store_category_slug": properties.storeCategorySlug,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Gift Revealed: This event is fired when the user clicks on the CTA to have an element of a gift revealed, either the gift itself or the gift-giver. If the location is "Reg Item Edit Screen" the gift-giver is revealed. If the location is "Gift Tracker" the gift is revealed. This is a one-time action per user, per registry.

event_location: Reg Item Edit Screen, Gift Tracker
event_cta: TBD

   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/n9DKKuZsoF}
   */
  function giftRevealed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "n9DKKuZsoF", "8e3add866787bacf3c00335c566a0c490c82b8a5780336f76b011fc92695535d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Gift Revealed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("n9DKKuZsoF", "Gift Revealed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Gift Revealed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Gift Revealed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "n9DKKuZsoF", "8e3add866787bacf3c00335c566a0c490c82b8a5780336f76b011fc92695535d");
      }
      // destination Segment
      Segment.logEvent("Gift Revealed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Filter Clicked: Event fires when filter icon in registry view for a registrant (registry owner) is clicked.

• event_location: Registry
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/u92z3TgvJV}
   */
  function registryFilterClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "u92z3TgvJV", "dc34db01fb319cdac79935659ce2ff8c17faaad73436774c48cca259509dcb9e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Filter Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("u92z3TgvJV", "Registry Filter Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Filter Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Filter Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "u92z3TgvJV", "dc34db01fb319cdac79935659ce2ff8c17faaad73436774c48cca259509dcb9e");
      }
      // destination Segment
      Segment.logEvent("Registry Filter Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Category Nav Clicked: Event fires when a registry category in the navigation bar is clicked in the registrant view (registry owner).

• event_location: Registry
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {int} properties.positionInList - Position of object in a list of objects. Position starts at 1.

Use Cases:
- Used to calculate average click position in Algolia. Segment maps this property to Algolia event.positions in Algolia Insights destination.
- To determine the position of a message in Message Center

   * @param {string} properties.categoryTitle - The Category Title of the item in the registry experience (e.g. General, Feeding, Baby Gear)

**Does not map to any Merchandising/Checklist category
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/pkDdXKwW4l}
   */
  function registryCategoryNavClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertPositionInList(properties.positionInList));
      messages = messages.concat(assertCategoryTitle(properties.categoryTitle));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "pkDdXKwW4l", "5ba0a8dd4252008309ffff8e199a355dc26d600671f82ba8201ba32eb3f20da1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Category Nav Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "position_in_list": properties.positionInList,
        "category_title": properties.categoryTitle,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("pkDdXKwW4l", "Registry Category Nav Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "9hIUmuT0nS", name: "position_in_list", value: properties.positionInList},
        {id: "B17latt6RY", name: "category_title", value: properties.categoryTitle},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Category Nav Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Category Nav Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "position_in_list": properties.positionInList,
          "category_title": properties.categoryTitle,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "pkDdXKwW4l", "5ba0a8dd4252008309ffff8e199a355dc26d600671f82ba8201ba32eb3f20da1");
      }
      // destination Segment
      Segment.logEvent("Registry Category Nav Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "position_in_list": properties.positionInList,
        "category_title": properties.categoryTitle,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Search Clicked: Event fires when search icon in registry view for a registrant (registry owner) is clicked. This search is for items in a registry.

• event_location: Registry
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/D-ZtAvHx2O}
   */
  function registrySearchClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "D-ZtAvHx2O", "477383794b543131e7ca666cea0170391fe13904d15e67eeb13e1eb29d64642d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Search Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("D-ZtAvHx2O", "Registry Search Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Search Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Search Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "D-ZtAvHx2O", "477383794b543131e7ca666cea0170391fe13904d15e67eeb13e1eb29d64642d");
      }
      // destination Segment
      Segment.logEvent("Registry Search Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Registry Item Details Viewed: Event fires when a user (registry owner) views the registry item detail screen.

• event_location: Reg Item Edit Screen
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {float} properties.regItemPrice - Registry item price
   * @param {int} properties.regItemQuantity - Registry item quantity
   * @param {int} properties.regItemId - The ID of the registry item
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/gdmQ4FecEY}
   */
  function registryItemDetailsViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertRegItemPrice(properties.regItemPrice));
      messages = messages.concat(assertRegItemQuantity(properties.regItemQuantity));
      messages = messages.concat(assertRegItemId(properties.regItemId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "gdmQ4FecEY", "44741be0810d446b4d8cdf76e4a9266776075b2d038ecba083bf6f0b35baf934", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Registry Item Details Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "reg_item_price": properties.regItemPrice,
        "reg_item_quantity": properties.regItemQuantity,
        "reg_item_id": properties.regItemId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("gdmQ4FecEY", "Registry Item Details Viewed", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "GD_6h8Uh9", name: "reg_item_id", value: properties.regItemId},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_IP9QswtZC", name: "reg_item_quantity", value: properties.regItemQuantity},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "keBt2ma-zt", name: "reg_item_price", value: properties.regItemPrice},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Registry Item Details Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registry Item Details Viewed", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "reg_item_price": properties.regItemPrice,
          "reg_item_quantity": properties.regItemQuantity,
          "reg_item_id": properties.regItemId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "gdmQ4FecEY", "44741be0810d446b4d8cdf76e4a9266776075b2d038ecba083bf6f0b35baf934");
      }
      // destination Segment
      Segment.logEvent("Registry Item Details Viewed", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "reg_item_price": properties.regItemPrice,
        "reg_item_quantity": properties.regItemQuantity,
        "reg_item_id": properties.regItemId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Search Preview Loaded: This event fires when a preview for Unified Search is loaded.

event_properties
- event_location: The page the user is currently on
- event_type: Unified
- event_cta: None

The intent behind this event is to capture evolving or sequential searches, therefore typing that takes place within the debounce window (currently defined as 250ms) will be captured as a single Search Preview Loaded event whereas typing that takes exceeds the debounce window (currently defined as greater than 250ms) will be captured as distinct Search Preview Loaded events.

A second aim of this event is to capture when users navigate directly from a Unified Search Preview to PDP viewed, which is not currently captured by Search Executed (to be deprecated).
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {string} properties.searchTerm - Search term
   * @param {string} [properties.searchPreviewIds] - This event property is a JSON string describing the Algolia Ids which generated the search preview results. Each Algolia Id corresponds to a different Algolia index. The JSON string should be encoded in the following format:

{"AlgoliaIndexName": "AlgoliaId", "AlgoliaIndexName": "AlgoliaId", "AlgoliaIndexName": "AlgoliaId"}
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/BeLOQzWTjt}
   */
  function searchPreviewLoaded(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertSearchTerm(properties.searchTerm));
      messages = messages.concat(assertOptionalSearchPreviewIds(properties.searchPreviewIds));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "BeLOQzWTjt", "7400b060da9cd149b6cd4876862ac5288c742d9d93338a631fa9001c1243ffa8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Search Preview Loaded", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "search_term": properties.searchTerm,
        "search_preview_ids": properties.searchPreviewIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("BeLOQzWTjt", "Search Preview Loaded", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "DP8VA0H6RC", name: "search_term", value: properties.searchTerm},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "eVYsq2XJU", name: "search_preview_ids", value: properties.searchPreviewIds},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Search Preview Loaded': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Search Preview Loaded", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "search_term": properties.searchTerm,
          "search_preview_ids": properties.searchPreviewIds,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "BeLOQzWTjt", "7400b060da9cd149b6cd4876862ac5288c742d9d93338a631fa9001c1243ffa8");
      }
      // destination Segment
      Segment.logEvent("Search Preview Loaded", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "search_term": properties.searchTerm,
        "search_preview_ids": properties.searchPreviewIds,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Shipment Action Clicked: Fires when specific actions are clicked from one of the following locations: Shipments, Shipment Details, Orders, or Order Details.

Event CTA should describe the action taken.  At present (Cycle B 2024) the Event CTA should exactly (including case) match one of the following values:

-Ship Now Started
-Ship Now Confirmed
-View Gift Tracker (Both from Shipment Details and Shipments)
-Order Viewed (when user views their order then Shopify Order ID should populate)
-Payment Details (Clickable from Order Details)
-Cancel Order (Clickable from Order Details)
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {Array<int>} [properties.productIds] - This is the targeted list of product ids. For events that operate on a single product like Added to Cart, it is a list of 1 product_id.

For the Next Add Viewed event, this is the list of recommended product_ids that are displayed in the modal.

Used for Algolia Insights to track search click conversion and personalize search results. Segment maps this property to Algolia event.objectIDs in Algolia Insights destination.

   * @param {string} properties.shipmentId - A computed ID that is equal to a fulfillment ID when it exists and a hold ID when the former does not exist.
   * @param {string} [properties.shopifyOrderId] - Shopify order ID for the order
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/OAzb7McnOf}
   */
  function shipmentActionClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertOptionalProductIds(properties.productIds));
      messages = messages.concat(assertShipmentId(properties.shipmentId));
      messages = messages.concat(assertOptionalShopifyOrderId(properties.shopifyOrderId));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "OAzb7McnOf", "f9bc50d319ba57cb6d6d12562b5b2abee7e3b7217c15ef6e81537bfbddac39fc", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Shipment Action Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "product_ids": properties.productIds,
        "shipment_id": properties.shipmentId,
        "shopify_order_id": properties.shopifyOrderId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("OAzb7McnOf", "Shipment Action Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "IBTbEZvoWR", name: "product_ids", value: properties.productIds},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gMuGQxPhZs", name: "shipment_id", value: properties.shipmentId},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "syfZNcLEPY", name: "shopify_order_id", value: properties.shopifyOrderId},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Shipment Action Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Shipment Action Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "product_ids": properties.productIds,
          "shipment_id": properties.shipmentId,
          "shopify_order_id": properties.shopifyOrderId,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "OAzb7McnOf", "f9bc50d319ba57cb6d6d12562b5b2abee7e3b7217c15ef6e81537bfbddac39fc");
      }
      // destination Segment
      Segment.logEvent("Shipment Action Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "product_ids": properties.productIds,
        "shipment_id": properties.shipmentId,
        "shopify_order_id": properties.shopifyOrderId,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Quick View Clicked: This event is triggered when a user clicks on the "plus" button on a Store (Shop) Product Card.

- event location: Store - Product Card
- event_type: Click
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} [properties.eventType] - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {bool} [properties.isRegistryOwner] - define if the actor is the owner of the act on registry
   * @param {int} [properties.registryOwnerId] - Babylist User ID for the primary owner of the registry. This is only relevant for events triggered on or for a registry. Note that the registry owner may be different that the user who is triggering the event
   * @param {int} [properties.registryId] - targeted registry of the event
   * @param {string} [properties.listType] - Wishlist (registry) type
   * @param {float} properties.productPrice - Price displayed for the product
   * @param {string} properties.productType - Type of the product
   * @param {bool} [properties.isFsaHsaEligible] - This property describes whether a product is eligible for FSA/HSA.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/oVdWKn5utS}
   */
  function quickViewClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertOptionalEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertOptionalIsRegistryOwner(properties.isRegistryOwner));
      messages = messages.concat(assertOptionalRegistryOwnerId(properties.registryOwnerId));
      messages = messages.concat(assertOptionalRegistryId(properties.registryId));
      messages = messages.concat(assertOptionalListType(properties.listType));
      messages = messages.concat(assertProductPrice(properties.productPrice));
      messages = messages.concat(assertProductType(properties.productType));
      messages = messages.concat(assertOptionalIsFsaHsaEligible(properties.isFsaHsaEligible));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "oVdWKn5utS", "ce1e736be0fe8a36c9376583f295f5089cab058e7cb6a957dd9249c14c283aa0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Quick View Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("oVdWKn5utS", "Quick View Clicked", messages, [
        {id: "8uZciylnJf", name: "registry_id", value: properties.registryId},
        {id: "9CoXibTIEF", name: "list_type", value: properties.listType},
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "KljnHhmsWG", name: "registry_owner_id", value: properties.registryOwnerId},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "gjtXFSi923", name: "is_registry_owner", value: properties.isRegistryOwner},
        {id: "hHOUpzCIx2", name: "product_price", value: properties.productPrice},
        {id: "hh5IW9vG8X", name: "product_type", value: properties.productType},
        {id: "kN_aicHWKA", name: "is_fsa_hsa_eligible", value: properties.isFsaHsaEligible},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Quick View Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Quick View Clicked", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "is_registry_owner": properties.isRegistryOwner,
          "registry_owner_id": properties.registryOwnerId,
          "registry_id": properties.registryId,
          "list_type": properties.listType,
          "product_price": properties.productPrice,
          "product_type": properties.productType,
          "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "oVdWKn5utS", "ce1e736be0fe8a36c9376583f295f5089cab058e7cb6a957dd9249c14c283aa0");
      }
      // destination Segment
      Segment.logEvent("Quick View Clicked", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "is_registry_owner": properties.isRegistryOwner,
        "registry_owner_id": properties.registryOwnerId,
        "registry_id": properties.registryId,
        "list_type": properties.listType,
        "product_price": properties.productPrice,
        "product_type": properties.productType,
        "is_fsa_hsa_eligible": properties.isFsaHsaEligible,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  /**
   * Page Interaction: A generic event type to track smaller interactions within a page.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.eventCta] - Copy or Call to Action on the button that the user clicked to trigger this action.

   * @param {string} properties.eventLocation - Location in the app where the event was triggered. If the event was triggered from outside the app (e.g. embedded click in an email, set the value to None).
   * @param {string} properties.eventType - Type or subtype of the event being fired. The list of allowed values ranges across different event types. Refer to the specific event description to see values that are actually sensible for that event.
   * @param {string} [properties.eventUrl] - This is the current URL from where the actin is triggered. In almost all cases, it will be the same as the landing page URL. This is only relevant for web. There is no event_url for iOS or Android.
   * @param {string} properties.interactionTarget - The element where the page interaction took place.
   * @param {string} [properties.pdpType] - We have several different PDP variations. This will give us insight into which variation of the PDP the user is currently on.
   *
   * @see {@link https://www.avo.app/schemas/X9gv6TJDCL2GRoNljVYW/events/B54ZLEXyLDj}
   */
  function pageInteraction(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalEventCta(properties.eventCta));
      messages = messages.concat(assertEventLocation(properties.eventLocation));
      messages = messages.concat(assertEventType(properties.eventType));
      messages = messages.concat(assertOptionalEventUrl(properties.eventUrl));
      messages = messages.concat(assertInteractionTarget(properties.interactionTarget));
      messages = messages.concat(assertOptionalPdpType(properties.pdpType));
      messages = messages.concat(assertOptionalUtmCampaign(sysUtmCampaign));
      messages = messages.concat(assertOptionalUtmMedium(sysUtmMedium));
      messages = messages.concat(assertOptionalUtmSource(sysUtmSource));
      messages = messages.concat(assertOptionalUtmContent(sysUtmContent));
      messages = messages.concat(assertOptionalUtmTerm(sysUtmTerm));
      messages = messages.concat(assertOptionalLandingPage(sysLandingPage));
      messages = messages.concat(assertOptionalReferrer(sysReferrer));
      messages = messages.concat(assertOptionalSearchKeyword(sysSearchKeyword));
      messages = messages.concat(assertLibrary(sysLibrary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertDeviceType(sysDeviceType));
      messages = messages.concat(assertBranchId(sysBranchId));
      messages = messages.concat(assertAppVersion(sysAppVersion));
      messages = messages.concat(assertOptionalUtmCoop(sysUtmCoop));
      messages = messages.concat(assertOptionalUtmGroup(sysUtmGroup));
      messages = messages.concat(assertOptionalSplitTests(sysSplitTests));
      messages = messages.concat(assertOptionalLastExternalReferrer(sysLastExternalReferrer));
      messages = messages.concat(assertOptionalBlAnonId(sysBlAnonId));
      messages = messages.concat(assertOptionalIsSynthetic(sysIsSynthetic));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "B54ZLEXyLDj", "4f90aaf11d3324603acee6bb3169e835d06aea808029e2dc024eb3c70d06a039", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Page Interaction", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "interaction_target": properties.interactionTarget,
        "pdp_type": properties.pdpType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("B54ZLEXyLDj", "Page Interaction", messages, [
        {id: "Dkb7pVwGYW", name: "event_url", value: properties.eventUrl},
        {id: "FAr2OJLazI", name: "event_cta", value: properties.eventCta},
        {id: "_w-bj6EA-b", name: "event_type", value: properties.eventType},
        {id: "h12bnVZfao", name: "pdp_type", value: properties.pdpType},
        {id: "yZMbs_5CI", name: "interaction_target", value: properties.interactionTarget},
        {id: "zseEDZJCEW", name: "event_location", value: properties.eventLocation},
        {id: "0f-4JhLUSj", name: "app_version", value: sysAppVersion},
        {id: "2D0Tn9jeZ9", name: "branch_id", value: sysBranchId},
        {id: "8qZabQPXtS", name: "utm_coop", value: sysUtmCoop},
        {id: "CEkofPYbd2", name: "utm_term", value: sysUtmTerm},
        {id: "KriAEwq44m", name: "device_type", value: sysDeviceType},
        {id: "NDLOh-q9J", name: "bl_anon_id", value: sysBlAnonId},
        {id: "OH8aphJyJx", name: "is_synthetic", value: sysIsSynthetic},
        {id: "WS8hgbYjUd", name: "platform", value: sysPlatform},
        {id: "X7_HdTU1M4", name: "referrer", value: sysReferrer},
        {id: "c8vjcYacK2", name: "utm_source", value: sysUtmSource},
        {id: "gelTZbhh9", name: "landing_page", value: sysLandingPage},
        {id: "gyskR7Tl0j", name: "utm_group", value: sysUtmGroup},
        {id: "hSwRq6Rl5g", name: "utm_campaign", value: sysUtmCampaign},
        {id: "lbx7p9h9EN", name: "last_external_referrer", value: sysLastExternalReferrer},
        {id: "q52hxkLks3", name: "search_keyword", value: sysSearchKeyword},
        {id: "vkFxnsX-JA", name: "split_tests", value: sysSplitTests},
        {id: "vn2eM76CG-", name: "library", value: sysLibrary},
        {id: "wgx9ZN1Pi1", name: "utm_content", value: sysUtmContent},
        {id: "xaXhMYt66p", name: "utm_medium", value: sysUtmMedium},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Page Interaction': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Page Interaction", {
          "event_cta": properties.eventCta,
          "event_location": properties.eventLocation,
          "event_type": properties.eventType,
          "event_url": properties.eventUrl,
          "interaction_target": properties.interactionTarget,
          "pdp_type": properties.pdpType,
          "utm_campaign": sysUtmCampaign,
          "utm_medium": sysUtmMedium,
          "utm_source": sysUtmSource,
          "utm_content": sysUtmContent,
          "utm_term": sysUtmTerm,
          "landing_page": sysLandingPage,
          "referrer": sysReferrer,
          "search_keyword": sysSearchKeyword,
          "library": sysLibrary,
          "platform": sysPlatform,
          "device_type": sysDeviceType,
          "branch_id": sysBranchId,
          "app_version": sysAppVersion,
          "utm_coop": sysUtmCoop,
          "utm_group": sysUtmGroup,
          "split_tests": sysSplitTests,
          "last_external_referrer": sysLastExternalReferrer,
          "bl_anon_id": sysBlAnonId,
          "is_synthetic": sysIsSynthetic,
          }, "B54ZLEXyLDj", "4f90aaf11d3324603acee6bb3169e835d06aea808029e2dc024eb3c70d06a039");
      }
      // destination Segment
      Segment.logEvent("Page Interaction", {
        "event_cta": properties.eventCta,
        "event_location": properties.eventLocation,
        "event_type": properties.eventType,
        "event_url": properties.eventUrl,
        "interaction_target": properties.interactionTarget,
        "pdp_type": properties.pdpType,
        "utm_campaign": sysUtmCampaign,
        "utm_medium": sysUtmMedium,
        "utm_source": sysUtmSource,
        "utm_content": sysUtmContent,
        "utm_term": sysUtmTerm,
        "landing_page": sysLandingPage,
        "referrer": sysReferrer,
        "search_keyword": sysSearchKeyword,
        "library": sysLibrary,
        "platform": sysPlatform,
        "device_type": sysDeviceType,
        "branch_id": sysBranchId,
        "app_version": sysAppVersion,
        "utm_coop": sysUtmCoop,
        "utm_group": sysUtmGroup,
        "split_tests": sysSplitTests,
        "last_external_referrer": sysLastExternalReferrer,
        "bl_anon_id": sysBlAnonId,
        "is_synthetic": sysIsSynthetic,
        }, {});
    } else {
      // do nothing
    }
  }

  exports.UserAuthenticationMethod = UserAuthenticationMethod;
  exports.RegistryTemplateType = RegistryTemplateType;
  exports.ListType = ListType;
  exports.CoregistrationPromptType = CoregistrationPromptType;
  exports.ContentIds = ContentIds;
  exports.BlockerType = BlockerType;
  exports.CartTypes = CartTypes;
  exports.ComponentType = ComponentType;
  exports.DeviceType = DeviceType;
  exports.SortCriteria = SortCriteria;
  exports.FormName = FormName;
  exports.ItemType = ItemType;
  exports.DeactivationReason = DeactivationReason;
  exports.InitialSearchBarSize = InitialSearchBarSize;
  exports.EventType = EventType;
  exports.StoreAdded = StoreAdded;
  exports.PdpType = PdpType;
  exports.ConsolidationValue = ConsolidationValue;
  exports.ProductType = ProductType;
  exports.Status = Status;
  exports.CartStores = CartStores;
  exports.SortOrder = SortOrder;
  exports.ExternalRegistryMergeType = ExternalRegistryMergeType;
  exports.CollaboratorRole = CollaboratorRole;
  exports.Library = Library;
  exports.ReservationCancellationReason = ReservationCancellationReason;
  exports.StoreName = StoreName;
  exports.InteractionTarget = InteractionTarget;
  exports.EventLocation = EventLocation;
  exports.setAvoLogger = setAvoLogger;
  exports.addedToCart = addedToCart;
  exports.addedToRegistry = addedToRegistry;
  exports.logInCompleted = logInCompleted;
  exports.signUpCompleted = signUpCompleted;
  exports.logOutCompleted = logOutCompleted;
  exports.checkoutStarted = checkoutStarted;
  exports.registryDiscountToggled = registryDiscountToggled;
  exports.cartOpened = cartOpened;
  exports.cartModified = cartModified;
  exports.reservationUpdated = reservationUpdated;
  exports.proceededToBuy = proceededToBuy;
  exports.userIdentified = userIdentified;
  exports.feedItemViewed = feedItemViewed;
  exports.feedItemClicked = feedItemClicked;
  exports.productCollectionClicked = productCollectionClicked;
  exports.productCollectionViewed = productCollectionViewed;
  exports.pdpViewed = pdpViewed;
  exports.guideViewed = guideViewed;
  exports.storeLandingViewed = storeLandingViewed;
  exports.storeSearchViewed = storeSearchViewed;
  exports.storeCategoryViewed = storeCategoryViewed;
  exports.productClicked = productClicked;
  exports.registryAddModalClicked = registryAddModalClicked;
  exports.nextAddViewed = nextAddViewed;
  exports.guideClicked = guideClicked;
  exports.filtersPanelToggled = filtersPanelToggled;
  exports.filtersApplied = filtersApplied;
  exports.purchaseConfirmed = purchaseConfirmed;
  exports.productReviewStarted = productReviewStarted;
  exports.productReviewCompleted = productReviewCompleted;
  exports.productQuestionStarted = productQuestionStarted;
  exports.productQuestionCompleted = productQuestionCompleted;
  exports.logInStarted = logInStarted;
  exports.signUpStarted = signUpStarted;
  exports.diaperCalculatorOptionSelected = diaperCalculatorOptionSelected;
  exports.diaperCalculatorResultViewed = diaperCalculatorResultViewed;
  exports.coregistrationCompleted = coregistrationCompleted;
  exports.coregistrationPromptViewed = coregistrationPromptViewed;
  exports.coregistrationPromptDismissed = coregistrationPromptDismissed;
  exports.diaperCalculatorFormViewed = diaperCalculatorFormViewed;
  exports.placementViewed = placementViewed;
  exports.productRecommendationsViewed = productRecommendationsViewed;
  exports.productRecommendationClicked = productRecommendationClicked;
  exports.viewContent = viewContent;
  exports.registryViewed = registryViewed;
  exports.checklistQuestionAnswered = checklistQuestionAnswered;
  exports.checklistQuizResultsViewed = checklistQuizResultsViewed;
  exports.onboardingQuestionAnswered = onboardingQuestionAnswered;
  exports.storeBrandViewed = storeBrandViewed;
  exports.collaboratorInvited = collaboratorInvited;
  exports.storeTileClicked = storeTileClicked;
  exports.accountDeactivated = accountDeactivated;
  exports.accountDeactivationReasonGiven = accountDeactivationReasonGiven;
  exports.registryProductOfferClicked = registryProductOfferClicked;
  exports.carouselProductAddedToCart = carouselProductAddedToCart;
  exports.brandTileClicked = brandTileClicked;
  exports.addItemsScreenViewed = addItemsScreenViewed;
  exports.emailCaptured = emailCaptured;
  exports.sessionStarted = sessionStarted;
  exports.pumpCatalogSelected = pumpCatalogSelected;
  exports.homeViewed = homeViewed;
  exports.productListViewed = productListViewed;
  exports.physicianSearchViewed = physicianSearchViewed;
  exports.customerInformationFormViewed = customerInformationFormViewed;
  exports.physicianSearchCompleted = physicianSearchCompleted;
  exports.unsupportedStateSelected = unsupportedStateSelected;
  exports.unsupportedInsuranceProviderSelected = unsupportedInsuranceProviderSelected;
  exports.errorThrown = errorThrown;
  exports.appDownloadInterstitialViewed = appDownloadInterstitialViewed;
  exports.appDownloadInterstitialSkipped = appDownloadInterstitialSkipped;
  exports.appDownloadInterstitialClicked = appDownloadInterstitialClicked;
  exports.checklistViewed = checklistViewed;
  exports.checklistCategoryViewed = checklistCategoryViewed;
  exports.checklistCheckboxClicked = checklistCheckboxClicked;
  exports.formSubmitted = formSubmitted;
  exports.feedbackModalSubmitted = feedbackModalSubmitted;
  exports.feedbackModalViewed = feedbackModalViewed;
  exports.feedbackModalDismissed = feedbackModalDismissed;
  exports.physicianResultViewed = physicianResultViewed;
  exports.sponsoredProductViewed = sponsoredProductViewed;
  exports.experimentReached = experimentReached;
  exports.registryOrganizeClicked = registryOrganizeClicked;
  exports.registryCategoryCreated = registryCategoryCreated;
  exports.registryCategoryEdited = registryCategoryEdited;
  exports.registryCategoryDeleted = registryCategoryDeleted;
  exports.registryCategoryMoved = registryCategoryMoved;
  exports.registryDropdownClicked = registryDropdownClicked;
  exports.registrySwitched = registrySwitched;
  exports.registryTemplateCopied = registryTemplateCopied;
  exports.allRegistriesViewed = allRegistriesViewed;
  exports.registryDeactivated = registryDeactivated;
  exports.createNewRegistryClicked = createNewRegistryClicked;
  exports.registryTemplateTypeClicked = registryTemplateTypeClicked;
  exports.registryRestoreClicked = registryRestoreClicked;
  exports.checklistCategoryClicked = checklistCategoryClicked;
  exports.registryHomeViewed = registryHomeViewed;
  exports.addItemsScreenClicked = addItemsScreenClicked;
  exports.customerVerificationModalViewed = customerVerificationModalViewed;
  exports.customerVerificationModalDismissed = customerVerificationModalDismissed;
  exports.emailCaptureViewed = emailCaptureViewed;
  exports.listTypeClicked = listTypeClicked;
  exports.listCreated = listCreated;
  exports.dmePreCheckoutModalViewed = dmePreCheckoutModalViewed;
  exports.componentClicked = componentClicked;
  exports.navbarClicked = navbarClicked;
  exports.signUpIntentShown = signUpIntentShown;
  exports.shippingConsolidationUpdated = shippingConsolidationUpdated;
  exports.shippingConsolidationViewed = shippingConsolidationViewed;
  exports.findRegistryViewed = findRegistryViewed;
  exports.healthBannerViewed = healthBannerViewed;
  exports.healthBannerClicked = healthBannerClicked;
  exports.listShared = listShared;
  exports.dmePreCheckoutModalCompleted = dmePreCheckoutModalCompleted;
  exports.forgotPasswordViewed = forgotPasswordViewed;
  exports.forgotPasswordSubmitted = forgotPasswordSubmitted;
  exports.logInSubmitted = logInSubmitted;
  exports.signUpStepProcessed = signUpStepProcessed;
  exports.logInStepProcessed = logInStepProcessed;
  exports.pageViewed = pageViewed;
  exports.registrySetupStepClicked = registrySetupStepClicked;
  exports.externalRegistryContactSupportClicked = externalRegistryContactSupportClicked;
  exports.babylistPopUpBlocked = babylistPopUpBlocked;
  exports.replacementPartsOrderFormViewed = replacementPartsOrderFormViewed;
  exports.replacementPartsOrderBlockerViewed = replacementPartsOrderBlockerViewed;
  exports.replacementPartsNewInsuranceFormViewed = replacementPartsNewInsuranceFormViewed;
  exports.searchExecuted = searchExecuted;
  exports.searchResultsPageViewed = searchResultsPageViewed;
  exports.stockNotificationRequestClicked = stockNotificationRequestClicked;
  exports.buyOnAmazonButtonClicked = buyOnAmazonButtonClicked;
  exports.inboxOpened = inboxOpened;
  exports.messageViewed = messageViewed;
  exports.messageClicked = messageClicked;
  exports.messageDeleted = messageDeleted;
  exports.guestViewClicked = guestViewClicked;
  exports.visibilityPrivacyClicked = visibilityPrivacyClicked;
  exports.giftTrackerClicked = giftTrackerClicked;
  exports.signUpSubmitted = signUpSubmitted;
  exports.tooltipClicked = tooltipClicked;
  exports.categoryTeaserClicked = categoryTeaserClicked;
  exports.storeCategoryClicked = storeCategoryClicked;
  exports.giftRevealed = giftRevealed;
  exports.registryFilterClicked = registryFilterClicked;
  exports.registryCategoryNavClicked = registryCategoryNavClicked;
  exports.registrySearchClicked = registrySearchClicked;
  exports.registryItemDetailsViewed = registryItemDetailsViewed;
  exports.searchPreviewLoaded = searchPreviewLoaded;
  exports.shipmentActionClicked = shipmentActionClicked;
  exports.quickViewClicked = quickViewClicked;
  exports.pageInteraction = pageInteraction;
  exports.setSystemProperties_ = setSystemProperties_;
  exports.setSystemProperties = setSystemProperties;
  exports.setup_ = setup_;
  exports.initAvo = initAvo;
  exports.WebDebuggerPosition = WebDebuggerPosition;
  exports.avoInspectorApiKey = avoInspectorApiKey;
}(typeof exports === 'undefined' ? this.BabylistAvo = {} : exports));

// AVOMODULEMAP:"BabylistAvo"
// AVOEVENTMAP:["addedToCart","addedToRegistry","logInCompleted","signUpCompleted","logOutCompleted","checkoutStarted","registryDiscountToggled","cartOpened","cartModified","reservationUpdated","proceededToBuy","userIdentified","feedItemViewed","feedItemClicked","productCollectionClicked","productCollectionViewed","pdpViewed","guideViewed","storeLandingViewed","storeSearchViewed","storeCategoryViewed","productClicked","registryAddModalClicked","nextAddViewed","guideClicked","filtersPanelToggled","filtersApplied","purchaseConfirmed","productReviewStarted","productReviewCompleted","productQuestionStarted","productQuestionCompleted","logInStarted","signUpStarted","diaperCalculatorOptionSelected","diaperCalculatorResultViewed","coregistrationCompleted","coregistrationPromptViewed","coregistrationPromptDismissed","diaperCalculatorFormViewed","placementViewed","productRecommendationsViewed","productRecommendationClicked","viewContent","registryViewed","checklistQuestionAnswered","checklistQuizResultsViewed","onboardingQuestionAnswered","storeBrandViewed","collaboratorInvited","storeTileClicked","accountDeactivated","accountDeactivationReasonGiven","registryProductOfferClicked","carouselProductAddedToCart","brandTileClicked","addItemsScreenViewed","emailCaptured","sessionStarted","pumpCatalogSelected","homeViewed","productListViewed","physicianSearchViewed","customerInformationFormViewed","physicianSearchCompleted","unsupportedStateSelected","unsupportedInsuranceProviderSelected","errorThrown","appDownloadInterstitialViewed","appDownloadInterstitialSkipped","appDownloadInterstitialClicked","checklistViewed","checklistCategoryViewed","checklistCheckboxClicked","formSubmitted","feedbackModalSubmitted","feedbackModalViewed","feedbackModalDismissed","physicianResultViewed","sponsoredProductViewed","experimentReached","registryOrganizeClicked","registryCategoryCreated","registryCategoryEdited","registryCategoryDeleted","registryCategoryMoved","registryDropdownClicked","registrySwitched","registryTemplateCopied","allRegistriesViewed","registryDeactivated","createNewRegistryClicked","registryTemplateTypeClicked","registryRestoreClicked","checklistCategoryClicked","registryHomeViewed","addItemsScreenClicked","customerVerificationModalViewed","customerVerificationModalDismissed","emailCaptureViewed","listTypeClicked","listCreated","dmePreCheckoutModalViewed","componentClicked","navbarClicked","signUpIntentShown","shippingConsolidationUpdated","shippingConsolidationViewed","findRegistryViewed","healthBannerViewed","healthBannerClicked","listShared","dmePreCheckoutModalCompleted","forgotPasswordViewed","forgotPasswordSubmitted","logInSubmitted","signUpStepProcessed","logInStepProcessed","pageViewed","registrySetupStepClicked","externalRegistryContactSupportClicked","babylistPopUpBlocked","replacementPartsOrderFormViewed","replacementPartsOrderBlockerViewed","replacementPartsNewInsuranceFormViewed","searchExecuted","searchResultsPageViewed","stockNotificationRequestClicked","buyOnAmazonButtonClicked","inboxOpened","messageViewed","messageClicked","messageDeleted","guestViewClicked","visibilityPrivacyClicked","giftTrackerClicked","signUpSubmitted","tooltipClicked","categoryTeaserClicked","storeCategoryClicked","giftRevealed","registryFilterClicked","registryCategoryNavClicked","registrySearchClicked","registryItemDetailsViewed","searchPreviewLoaded","shipmentActionClicked","quickViewClicked","pageInteraction"]
